// 自动生成，请勿手动修改
import type { Spirit } from '../core/types';

export const SPIRITS: Spirit[] = [
  {
    id: '1',
    name: '迪莫',
    types: ['光'],
    baseStats: { hp: 120, atk: 80, def: 105, spa: 80, spd: 105, spe: 92 },
    skills: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.001_迪莫.png',
    traitName: '最好的伙伴',
    traitEffect: '造成克制伤害后，获得攻防速+20%，并回复2能量。',
  },
  {
    id: '2',
    name: '喵喵',
    types: ['草'],
    baseStats: { hp: 65, atk: 66, def: 49, spa: 66, spd: 91, spe: 33 },
    skills: ['53', '54', '8', '55', '50', '3', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '38', '81', '82', '83', '84', '85', '86', '87', '88', '89', '90', '91', '92', '93', '94', '95'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.002_喵喵.png',
    traitName: '氧循环',
    traitEffect: '使用草系技能后，回复10%生命。',
  },
  {
    id: '3',
    name: '喵呜',
    types: ['草'],
    baseStats: { hp: 86, atk: 87, def: 65, spa: 87, spd: 121, spe: 44 },
    skills: ['53', '54', '8', '55', '50', '3', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '38', '81', '82', '83', '84', '85', '86', '87', '88', '89', '90', '91', '92', '93', '94', '95'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.003_喵呜.png',
    traitName: '氧循环',
    traitEffect: '使用草系技能后，回复10%生命。',
  },
  {
    id: '4',
    name: '魔力猫',
    types: ['草'],
    baseStats: { hp: 108, atk: 109, def: 81, spa: 109, spd: 151, spe: 55 },
    skills: ['53', '54', '8', '55', '50', '3', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '38', '81', '82', '83', '84', '85', '86', '87', '88', '89', '90', '91', '92', '93', '94', '95'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.004_魔力猫.png',
    traitName: '氧循环',
    traitEffect: '使用草系技能后，回复10%生命。',
  },
  {
    id: '5',
    name: '火花',
    types: ['火'],
    baseStats: { hp: 70, atk: 84, def: 56, spa: 37, spd: 43, spe: 78 },
    skills: ['1', '96', '7', '97', '3', '98', '85', '42', '99', '100', '101', '52', '102', '20', '21', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '37', '106', '107', '108', '109', '110', '111', '90', '112', '113', '114', '115', '116', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.005_火花.png',
    traitName: '助燃',
    traitEffect: '使用火系技能后，获得双攻+20%。',
  },
  {
    id: '6',
    name: '焰火',
    types: ['火'],
    baseStats: { hp: 93, atk: 111, def: 75, spa: 49, spd: 58, spe: 104 },
    skills: ['1', '96', '7', '97', '3', '98', '85', '42', '99', '100', '101', '52', '102', '20', '21', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '37', '106', '107', '108', '109', '110', '111', '90', '112', '113', '114', '115', '116', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.006_焰火.png',
    traitName: '助燃',
    traitEffect: '使用火系技能后，获得双攻+20%。',
  },
  {
    id: '7',
    name: '火神',
    types: ['火'],
    baseStats: { hp: 117, atk: 139, def: 94, spa: 61, spd: 72, spe: 130 },
    skills: ['1', '96', '7', '97', '3', '98', '85', '42', '99', '100', '101', '52', '102', '20', '21', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '37', '106', '107', '108', '109', '110', '111', '90', '112', '113', '114', '115', '116', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.007_火神.png',
    traitName: '助燃',
    traitEffect: '使用火系技能后，获得双攻+20%。',
  },
  {
    id: '8',
    name: '水蓝蓝',
    types: ['水'],
    baseStats: { hp: 75, atk: 35, def: 56, spa: 76, spd: 79, spe: 51 },
    skills: ['3', '118', '119', '45', '4', '120', '121', '122', '123', '124', '125', '126', '40', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '87', '138', '139', '38', '140', '141', '28', '142', '143', '144', '41', '44', '145', '146', '147', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.008_水蓝蓝.png',
    traitName: '浸润',
    traitEffect: '使用水系技能后，全技能能耗-1。',
  },
  {
    id: '9',
    name: '波波拉',
    types: ['水'],
    baseStats: { hp: 100, atk: 46, def: 75, spa: 102, spd: 106, spe: 68 },
    skills: ['3', '118', '119', '45', '4', '120', '121', '122', '123', '124', '125', '126', '40', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '87', '138', '139', '38', '140', '141', '28', '142', '143', '144', '41', '44', '145', '146', '147', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.009_波波拉.png',
    traitName: '浸润',
    traitEffect: '使用水系技能后，全技能能耗-1。',
  },
  {
    id: '10',
    name: '水灵',
    types: ['水'],
    baseStats: { hp: 125, atk: 58, def: 94, spa: 127, spd: 132, spe: 85 },
    skills: ['3', '118', '119', '45', '4', '120', '121', '122', '123', '124', '125', '126', '40', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '87', '138', '139', '38', '140', '141', '28', '142', '143', '144', '41', '44', '145', '146', '147', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.010_水灵.png',
    traitName: '浸润',
    traitEffect: '使用水系技能后，全技能能耗-1。',
  },
  {
    id: '11',
    name: '鸭吉吉（蓬松的样子）',
    types: ['普通'],
    baseStats: { hp: 136, atk: 95, def: 55, spa: 35, spd: 45, spe: 105 },
    skills: ['1', '7', '55', '3', '54', '149', '150', '142', '151', '152', '153', '154', '155', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '94', '75', '76', '77', '78', '86', '79', '80', '156', '157', '106', '158', '130', '109', '159', '84', '160', '90', '24', '127', '115', '161'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.011_鸭吉吉（蓬松的样子）.png',
    traitName: '挺起胸脯',
    traitEffect: '携带的能耗为1的技能，威力+50%。',
  },
  {
    id: '12',
    name: '鸭吉吉（紧实的样子）',
    types: ['普通'],
    baseStats: { hp: 136, atk: 35, def: 45, spa: 95, spd: 55, spe: 105 },
    skills: ['4', '162', '118', '3', '54', '163', '150', '142', '164', '152', '165', '148', '155', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '86', '79', '80', '157', '106', '38', '166', '130', '143', '167', '159', '84', '168', '160', '90', '169', '161'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.011_鸭吉吉（紧实的样子）.png',
    traitName: '挺起胸脯',
    traitEffect: '携带的能耗为1的技能，威力+50%。',
  },
  {
    id: '13',
    name: '鸭吉吉（急急急鸭）',
    types: ['普通'],
    baseStats: { hp: 130, atk: 95, def: 55, spa: 35, spd: 45, spe: 110 },
    skills: ['1', '7', '55', '3', '54', '149', '150', '142', '151', '152', '153', '154', '155', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '94', '75', '76', '77', '78', '86', '79', '80', '156', '157', '106', '158', '130', '109', '159', '84', '160', '90', '24', '127', '115', '161'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.011_鸭吉吉（急急急鸭）.png',
    traitName: '挺起胸脯',
    traitEffect: '携带的能耗为1的技能，威力+50%。',
  },
  {
    id: '14',
    name: '鸭吉吉（等一等鸭）',
    types: ['普通'],
    baseStats: { hp: 137, atk: 35, def: 46, spa: 94, spd: 57, spe: 100 },
    skills: ['4', '162', '118', '3', '54', '163', '150', '142', '164', '152', '165', '148', '155', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '86', '79', '80', '157', '106', '38', '166', '130', '143', '167', '159', '84', '168', '160', '90', '169', '161'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.011_鸭吉吉（等一等鸭）.png',
    traitName: '挺起胸脯',
    traitEffect: '携带的能耗为1的技能，威力+50%。',
  },
  {
    id: '15',
    name: '鸭吉吉（起来鸭）',
    types: ['普通'],
    baseStats: { hp: 107, atk: 53, def: 80, spa: 125, spd: 113, spe: 100 },
    skills: ['4', '162', '118', '3', '54', '163', '150', '142', '164', '152', '165', '148', '155'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.011_鸭吉吉（起来鸭）.png',
    traitName: '挺起胸脯',
    traitEffect: '携带的能耗为1的技能，威力+50%。',
  },
  {
    id: '16',
    name: '鸭吉吉（燃了鸭）',
    types: ['普通'],
    baseStats: { hp: 108, atk: 89, def: 74, spa: 41, spd: 48, spe: 115 },
    skills: ['1', '7', '55', '3', '54', '149', '150', '142', '151', '152', '153', '154', '155', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '94', '75', '76', '77', '78', '86', '79', '80', '156', '157', '106', '158', '130', '109', '159', '84', '160', '90', '24', '127', '115', '161'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.011_鸭吉吉（燃了鸭）.png',
    traitName: '挺起胸脯',
    traitEffect: '携带的能耗为1的技能，威力+50%。',
  },
  {
    id: '17',
    name: '板板壳（本来的样子）',
    types: ['水'],
    baseStats: { hp: 67, atk: 28, def: 64, spa: 72, spd: 81, spe: 45 },
    skills: ['170', '3', '4', '45', '122', '171', '120', '172', '125', '121', '123', '40', '173', '20', '128', '22', '129', '174', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '87', '138', '175', '68', '176', '109', '177', '44', '8', '168', '178', '146', '58', '127', '179', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.012_板板壳（本来的样子）.png',
    traitName: '缩壳',
    traitEffect: '携带的防御技能能耗-2。',
  },
  {
    id: '18',
    name: '咔咔壳（本来的样子）',
    types: ['水'],
    baseStats: { hp: 90, atk: 37, def: 85, spa: 96, spd: 107, spe: 60 },
    skills: ['170', '3', '4', '45', '122', '171', '120', '172', '125', '121', '123', '40', '173', '20', '128', '22', '129', '174', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '87', '138', '175', '68', '176', '109', '177', '44', '8', '168', '178', '146', '58', '127', '179', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.013_咔咔壳（本来的样子）.png',
    traitName: '缩壳',
    traitEffect: '携带的防御技能能耗-2。',
  },
  {
    id: '19',
    name: '水泡壳（本来的样子）',
    types: ['水'],
    baseStats: { hp: 112, atk: 46, def: 107, spa: 120, spd: 134, spe: 75 },
    skills: ['170', '3', '4', '45', '122', '171', '120', '172', '125', '121', '123', '40', '173', '20', '128', '22', '129', '174', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '87', '138', '175', '68', '176', '109', '177', '44', '8', '168', '178', '146', '58', '127', '179', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.014_水泡壳（本来的样子）.png',
    traitName: '缩壳',
    traitEffect: '携带的防御技能能耗-2。',
  },
  {
    id: '20',
    name: '锥尾羊',
    types: ['幽'],
    baseStats: { hp: 67, atk: 66, def: 72, spa: 29, spd: 49, spe: 66 },
    skills: ['21', '7', '26', '70', '180', '181', '182', '107', '151', '183', '184', '185', '186', '54', '112', '22', '67', '68', '6', '103', '56', '72', '73', '94', '75', '76', '77', '78', '86', '79', '80', '187', '109', '188', '83', '189', '85', '190', '191', '89', '192', '193', '3', '194'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.015_锥尾羊.png',
    traitName: '碰瓷',
    traitEffect: '自己使用恶系技能后，敌方失去2能量。',
  },
  {
    id: '21',
    name: '铃兰羊',
    types: ['幽'],
    baseStats: { hp: 89, atk: 89, def: 96, spa: 39, spd: 65, spe: 88 },
    skills: ['21', '7', '26', '70', '180', '181', '182', '107', '151', '183', '184', '185', '186', '54', '112', '22', '67', '68', '6', '103', '56', '72', '73', '94', '75', '76', '77', '78', '86', '79', '80', '187', '109', '188', '83', '189', '85', '190', '191', '89', '192', '193', '3', '194'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.016_铃兰羊.png',
    traitName: '碰瓷',
    traitEffect: '自己使用恶系技能后，敌方失去2能量。',
  },
  {
    id: '22',
    name: '花影羚羊',
    types: ['幽', '恶'],
    baseStats: { hp: 112, atk: 111, def: 120, spa: 48, spd: 81, spe: 110 },
    skills: ['21', '7', '26', '70', '180', '181', '182', '107', '151', '183', '184', '185', '186', '54', '112', '22', '67', '68', '6', '103', '56', '72', '73', '94', '75', '76', '77', '78', '86', '79', '80', '187', '109', '188', '83', '189', '85', '190', '191', '89', '192', '193', '3', '194'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.017_花影羚羊.png',
    traitName: '碰瓷',
    traitEffect: '自己使用恶系技能后，敌方失去2能量。',
  },
  {
    id: '23',
    name: '雪绒鸟（本来的样子）',
    types: ['翼'],
    baseStats: { hp: 54, atk: 77, def: 65, spa: 33, spd: 44, spe: 69 },
    skills: ['195', '7', '196', '106', '3', '110', '80', '197', '198', '199', '155', '200', '117', '20', '21', '22', '23', '24', '25', '103', '27', '28', '29', '94', '104', '105', '33', '51', '87', '36', '115', '201', '152', '38', '202', '13', '203', '182', '44', '204', '205', '9', '153', '206', '79', '147'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.018_雪绒鸟（本来的样子）.png',
    traitName: '顺风',
    traitEffect: '若先于敌方攻击，本次技能威力+50%。',
  },
  {
    id: '24',
    name: '冬羽雀（本来的样子）',
    types: ['翼'],
    baseStats: { hp: 72, atk: 103, def: 86, spa: 44, spd: 59, spe: 92 },
    skills: ['195', '7', '196', '106', '3', '110', '80', '197', '198', '199', '155', '200', '117', '20', '21', '22', '23', '24', '25', '103', '27', '28', '29', '94', '104', '105', '33', '51', '87', '36', '115', '201', '152', '38', '202', '13', '203', '182', '44', '204', '205', '9', '153', '206', '79', '147'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.019_冬羽雀（本来的样子）.png',
    traitName: '顺风',
    traitEffect: '若先于敌方攻击，本次技能威力+50%。',
  },
  {
    id: '25',
    name: '岚鸟（本来的样子）',
    types: ['翼'],
    baseStats: { hp: 90, atk: 128, def: 108, spa: 55, spd: 74, spe: 115 },
    skills: ['195', '7', '196', '106', '3', '110', '80', '197', '198', '199', '155', '200', '117', '20', '21', '22', '23', '24', '25', '103', '27', '28', '29', '94', '104', '105', '33', '51', '87', '36', '115', '201', '152', '38', '202', '13', '203', '182', '44', '204', '205', '9', '153', '206', '79', '147'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.020_岚鸟（本来的样子）.png',
    traitName: '顺风',
    traitEffect: '若先于敌方攻击，本次技能威力+50%。',
  },
  {
    id: '26',
    name: '小灵菇',
    types: ['幽'],
    baseStats: { hp: 67, atk: 59, def: 62, spa: 59, spd: 82, spe: 45 },
    skills: ['3', '207', '46', '208', '209', '210', '53', '181', '189', '26', '58', '50', '211', '57', '212', '43', '127', '128', '22', '129', '130', '131', '103', '71', '134', '135', '74', '31', '32', '136', '51', '35', '120', '175', '213', '166', '214', '142', '186', '215', '177', '153', '216', '91', '217', '93', '132', '218', '219', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.021_小灵菇.png',
    traitName: '毒蘑菇',
    traitEffect: '回合结束时，偷取敌方场上所有精灵1能量。',
  },
  {
    id: '27',
    name: '幻灵菇',
    types: ['幽', '草'],
    baseStats: { hp: 89, atk: 79, def: 83, spa: 79, spd: 109, spe: 60 },
    skills: ['3', '207', '46', '208', '209', '210', '53', '181', '189', '26', '58', '50', '211', '57', '212', '43', '127', '128', '22', '129', '130', '131', '103', '71', '134', '135', '74', '31', '32', '136', '51', '35', '120', '175', '213', '166', '214', '142', '186', '215', '177', '153', '216', '91', '217', '93', '132', '218', '219', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.022_幻灵菇.png',
    traitName: '毒蘑菇',
    traitEffect: '回合结束时，偷取敌方场上所有精灵1能量。',
  },
  {
    id: '28',
    name: '幻影灵菇',
    types: ['幽', '草'],
    baseStats: { hp: 111, atk: 98, def: 103, spa: 98, spd: 136, spe: 75 },
    skills: ['3', '207', '46', '208', '209', '210', '53', '181', '189', '26', '58', '50', '211', '57', '212', '43', '127', '128', '22', '129', '130', '131', '103', '71', '134', '135', '74', '31', '32', '136', '51', '35', '120', '175', '213', '166', '214', '142', '186', '215', '177', '153', '216', '91', '217', '93', '132', '218', '219', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.023_幻影灵菇.png',
    traitName: '毒蘑菇',
    traitEffect: '回合结束时，偷取敌方场上所有精灵1能量。',
  },
  {
    id: '29',
    name: '石肤蜥（本来的样子）',
    types: ['地'],
    baseStats: { hp: 69, atk: 54, def: 65, spa: 53, spd: 45, spe: 57 },
    skills: ['3', '220', '221', '162', '222', '223', '224', '225', '226', '227', '158', '228', '218', '229', '230', '20', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '51', '35', '120', '175', '231', '7', '171', '143', '232', '109', '233', '177', '234', '88', '235', '105', '92', '93', '127'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.024_石肤蜥（本来的样子）.png',
    traitName: '刺肤',
    traitEffect: '每受到1次攻击，对攻击自己的精灵造成50威力物理伤害。',
  },
  {
    id: '30',
    name: '石刺蜥（本来的样子）',
    types: ['地'],
    baseStats: { hp: 92, atk: 72, def: 87, spa: 71, spd: 60, spe: 76 },
    skills: ['3', '220', '221', '162', '222', '223', '224', '225', '226', '227', '158', '228', '218', '229', '230', '20', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '51', '35', '120', '175', '231', '7', '171', '143', '232', '109', '233', '177', '234', '88', '235', '105', '92', '93', '127'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.025_石刺蜥（本来的样子）.png',
    traitName: '刺肤',
    traitEffect: '每受到1次攻击，对攻击自己的精灵造成50威力物理伤害。',
  },
  {
    id: '31',
    name: '石冠王蜥（本来的样子）',
    types: ['地'],
    baseStats: { hp: 115, atk: 89, def: 109, spa: 89, spd: 75, spe: 95 },
    skills: ['3', '220', '221', '162', '222', '223', '224', '225', '226', '227', '158', '228', '218', '229', '230', '20', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '51', '35', '120', '175', '231', '7', '171', '143', '232', '109', '233', '177', '234', '88', '235', '105', '92', '93', '127'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.026_石冠王蜥（本来的样子）.png',
    traitName: '刺肤',
    traitEffect: '每受到1次攻击，对攻击自己的精灵造成50威力物理伤害。',
  },
  {
    id: '32',
    name: '布是石',
    types: ['地'],
    baseStats: { hp: 72, atk: 81, def: 95, spa: 29, spd: 90, spe: 42 },
    skills: ['3', '51', '7', '236', '224', '226', '237', '154', '238', '239', '228', '240', '241', '232', '231', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '94', '104', '105', '136', '34', '35', '120', '139', '202', '171', '142', '143', '109', '212', '189', '44', '184', '180', '242', '227', '181'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.027_布是石.png',
    traitName: '地脉',
    traitEffect: '初始能量为0，入场前己方精灵每放1次地系技能，回复3能量。',
  },
  {
    id: '33',
    name: '布是岩',
    types: ['地'],
    baseStats: { hp: 96, atk: 108, def: 127, spa: 39, spd: 120, spe: 56 },
    skills: ['3', '51', '7', '236', '224', '226', '237', '154', '238', '239', '228', '240', '241', '232', '231', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '94', '104', '105', '136', '34', '35', '120', '139', '202', '171', '142', '143', '109', '212', '189', '44', '184', '180', '242', '227', '181'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.028_布是岩.png',
    traitName: '地脉',
    traitEffect: '初始能量为0，入场前己方精灵每放1次地系技能，回复3能量。',
  },
  {
    id: '34',
    name: '布克棱岩',
    types: ['地'],
    baseStats: { hp: 120, atk: 135, def: 159, spa: 49, spd: 150, spe: 70 },
    skills: ['3', '51', '7', '236', '224', '226', '237', '154', '238', '239', '228', '240', '241', '232', '231', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '94', '104', '105', '136', '34', '35', '120', '139', '202', '171', '142', '143', '109', '212', '189', '44', '184', '180', '242', '227', '181'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.029_布克棱岩.png',
    traitName: '地脉',
    traitEffect: '初始能量为0，入场前己方精灵每放1次地系技能，回复3能量。',
  },
  {
    id: '35',
    name: '恶魔叮',
    types: ['恶', '翼'],
    baseStats: { hp: 86, atk: 112, def: 58, spa: 44, spd: 43, spe: 84 },
    skills: ['243', '106', '53', '3', '66', '37', '182', '190', '206', '110', '244', '111', '117', '20', '112', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '156', '245', '202', '109', '26', '246', '155', '212', '247', '153', '80', '219', '181'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.030_恶魔叮.png',
    traitName: '渴求',
    traitEffect: '入场时获得50%吸血。',
  },
  {
    id: '36',
    name: '叮叮恶魔',
    types: ['恶', '翼'],
    baseStats: { hp: 108, atk: 140, def: 73, spa: 55, spd: 54, spe: 105 },
    skills: ['243', '106', '53', '3', '66', '37', '182', '190', '206', '110', '244', '111', '117', '20', '112', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '156', '245', '202', '109', '26', '246', '155', '212', '247', '153', '80', '219', '181'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.031_叮叮恶魔.png',
    traitName: '渴求',
    traitEffect: '入场时获得50%吸血。',
  },
  {
    id: '37',
    name: '毛毛',
    types: ['虫', '萌'],
    baseStats: { hp: 32, atk: 28, def: 40, spa: 28, spd: 40, spe: 60 },
    skills: ['248', '249', '3', '29', '250', '251', '252', '135', '32', '253', '254', '76', '255', '256', '257', '54', '66', '22', '67', '68', '69', '70', '56', '72', '258', '74', '75', '259', '77', '78', '86', '79', '80', '260', '214', '150', '143', '83', '155', '84', '261', '85', '234', '262', '263', '90', '264', '197', '265'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.032_毛毛.png',
    traitName: '化茧',
    traitEffect: '受到致命伤害时，获得1层萌化，并免疫此次伤害。',
  },
  {
    id: '38',
    name: '爬爬',
    types: ['虫', '萌'],
    baseStats: { hp: 42, atk: 37, def: 53, spa: 37, spd: 53, spe: 80 },
    skills: ['248', '249', '3', '29', '250', '251', '252', '135', '32', '253', '254', '76', '255', '256', '257', '54', '66', '22', '67', '68', '69', '70', '56', '72', '258', '74', '75', '259', '77', '78', '86', '79', '80', '260', '214', '150', '143', '83', '155', '84', '261', '85', '234', '262', '263', '90', '264', '197', '265'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.033_爬爬.png',
    traitName: '化茧',
    traitEffect: '受到致命伤害时，获得1层萌化，并免疫此次伤害。',
  },
  {
    id: '39',
    name: '化蝶（平常的样子）',
    types: ['虫', '萌'],
    baseStats: { hp: 53, atk: 46, def: 66, spa: 46, spd: 66, spe: 100 },
    skills: ['248', '249', '3', '29', '250', '251', '252', '135', '32', '253', '254', '76', '255', '256', '257', '54', '66', '22', '67', '68', '69', '70', '56', '72', '258', '74', '75', '259', '77', '78', '86', '79', '80', '260', '214', '150', '143', '83', '155', '84', '261', '85', '234', '262', '263', '90', '264', '197', '265'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.034_化蝶（平常的样子）.png',
    traitName: '化茧',
    traitEffect: '受到致命伤害时，获得1层萌化，并免疫此次伤害。',
  },
  {
    id: '40',
    name: '幽影树',
    types: ['幽', '草'],
    baseStats: { hp: 111, atk: 96, def: 65, spa: 96, spd: 123, spe: 80 },
    skills: ['3', '242', '70', '209', '266', '267', '268', '132', '186', '181', '27', '183', '269', '60', '270', '20', '66', '22', '67', '68', '69', '103', '71', '72', '73', '74', '75', '76', '77', '78', '86', '79', '80', '54', '187', '38', '271', '61', '83', '272', '261', '190', '184', '262', '89', '216', '193', '58', '4'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.035_幽影树.png',
    traitName: '小偷小摸',
    traitEffect: '入场时偷取所有敌方精灵2能量。',
  },
  {
    id: '41',
    name: '小鼠獭',
    types: ['普通', '水'],
    baseStats: { hp: 73, atk: 57, def: 60, spa: 57, spd: 60, spe: 48 },
    skills: ['262', '273', '3', '53', '122', '274', '150', '120', '36', '165', '275', '44', '121', '276', '173', '20', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '35', '138', '175', '214', '142', '277', '143', '270', '261', '220', '126', '9', '224', '218', '278', '127', '114', '279', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.036_小鼠獭.png',
    traitName: '保守派',
    traitEffect: '总技能能耗小于4时，自己获得双防+80%。',
  },
  {
    id: '42',
    name: '燕尾獭',
    types: ['普通', '水'],
    baseStats: { hp: 97, atk: 77, def: 81, spa: 77, spd: 81, spe: 64 },
    skills: ['262', '273', '3', '53', '122', '274', '150', '120', '36', '165', '275', '44', '121', '276', '173', '20', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '35', '138', '175', '214', '142', '277', '143', '270', '261', '220', '126', '9', '224', '218', '278', '127', '114', '279', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.037_燕尾獭.png',
    traitName: '保守派',
    traitEffect: '总技能能耗小于4时，自己获得双防+80%。',
  },
  {
    id: '43',
    name: '卷胡巨獭',
    types: ['普通', '水'],
    baseStats: { hp: 121, atk: 96, def: 101, spa: 96, spd: 101, spe: 80 },
    skills: ['262', '273', '3', '53', '122', '274', '150', '120', '36', '165', '275', '44', '121', '276', '173', '20', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '35', '138', '175', '214', '142', '277', '143', '270', '261', '220', '126', '9', '224', '218', '278', '127', '114', '279', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.038_卷胡巨獭.png',
    traitName: '保守派',
    traitEffect: '总技能能耗小于4时，自己获得双防+80%。',
  },
  {
    id: '44',
    name: '矿晶虫',
    types: ['光', '地'],
    baseStats: { hp: 79, atk: 77, def: 102, spa: 81, spd: 75, spe: 52 },
    skills: ['4', '280', '137', '281', '12', '94', '237', '238', '34', '51', '282', '162', '11', '232', '20', '128', '22', '129', '130', '131', '132', '133', '134', '258', '30', '31', '32', '136', '220', '35', '120', '175', '202', '171', '143', '109', '82', '283', '218', '284', '227', '113', '127', '3', '279'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.039_矿晶虫.png',
    traitName: '偏振',
    traitEffect: '受到自己携带技能系别的攻击伤害-40%。',
  },
  {
    id: '45',
    name: '晶石蜗（西瓜碧玺的样子）',
    types: ['光', '地'],
    baseStats: { hp: 99, atk: 96, def: 128, spa: 101, spd: 94, spe: 65 },
    skills: ['4', '280', '137', '281', '12', '94', '237', '238', '34', '51', '282', '162', '11', '232', '127', '128', '22', '129', '130', '131', '132', '133', '134', '258', '30', '31', '32', '136', '220', '35', '120', '175', '202', '140', '203', '230', '171', '143', '109', '82', '41', '44', '126', '283', '218', '284', '227', '113', '3', '279'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.040_晶石蜗（西瓜碧玺的样子）.png',
    traitName: '偏振',
    traitEffect: '受到自己携带技能系别的攻击伤害-40%。',
  },
  {
    id: '46',
    name: '奇丽草',
    types: ['草'],
    baseStats: { hp: 67, atk: 69, def: 73, spa: 69, spd: 57, spe: 48 },
    skills: ['217', '85', '267', '3', '7', '8', '46', '91', '285', '61', '57', '188', '62', '286', '60', '193', '54', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '86', '79', '80', '157', '18', '65', '214', '83', '155', '44', '287', '12', '153', '223', '275', '51', '94', '222', '2', '127'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.041_奇丽草.png',
    traitName: '养分重吸收',
    traitEffect: '回合结束时，回复3能量。',
  },
  {
    id: '47',
    name: '奇丽叶',
    types: ['草'],
    baseStats: { hp: 90, atk: 92, def: 97, spa: 92, spd: 76, spe: 64 },
    skills: ['217', '85', '267', '3', '7', '8', '46', '91', '285', '61', '57', '188', '62', '286', '60', '193', '54', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '86', '79', '80', '157', '18', '65', '214', '83', '155', '44', '287', '12', '153', '223', '275', '51', '94', '222', '2', '127'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.042_奇丽叶.png',
    traitName: '养分重吸收',
    traitEffect: '回合结束时，回复3能量。',
  },
  {
    id: '48',
    name: '奇丽花',
    types: ['草'],
    baseStats: { hp: 112, atk: 115, def: 121, spa: 115, spd: 95, spe: 80 },
    skills: ['217', '85', '267', '3', '7', '8', '46', '91', '285', '61', '57', '188', '62', '286', '60', '193', '54', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '86', '79', '80', '157', '18', '65', '214', '83', '155', '44', '287', '12', '153', '223', '275', '51', '94', '222', '2', '127'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.043_奇丽花.png',
    traitName: '养分重吸收',
    traitEffect: '回合结束时，回复3能量。',
  },
  {
    id: '49',
    name: '丢丢（草地附近的样子）',
    types: ['草'],
    baseStats: { hp: 44, atk: 45, def: 49, spa: 12, spd: 40, spe: 78 },
    skills: ['7', '3', '59', '285', '234', '288', '188', '50', '157', '215', '63', '43', '60', '1', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '202', '214', '289', '258', '84', '85', '89', '90', '192', '290', '291', '276', '243'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.044_丢丢（草地附近的样子）.png',
    traitName: '诈死',
    traitEffect: '自己力竭时，少损失1点魔力。',
  },
  {
    id: '50',
    name: '卡卡虫（草地附近的样子）',
    types: ['草'],
    baseStats: { hp: 59, atk: 60, def: 65, spa: 16, spd: 53, spe: 104 },
    skills: ['7', '3', '59', '285', '234', '288', '188', '50', '157', '215', '63', '43', '60', '1', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '202', '214', '289', '258', '84', '85', '89', '90', '192', '290', '291', '276', '243'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.045_卡卡虫（草地附近的样子）.png',
    traitName: '诈死',
    traitEffect: '自己力竭时，少损失1点魔力。',
  },
  {
    id: '51',
    name: '卡瓦重（草地附近的样子）',
    types: ['草'],
    baseStats: { hp: 74, atk: 75, def: 81, spa: 20, spd: 67, spe: 130 },
    skills: ['7', '3', '59', '285', '234', '288', '188', '50', '157', '215', '63', '43', '60', '1', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '202', '214', '289', '258', '84', '85', '89', '90', '192', '290', '291', '276', '243'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.046_卡瓦重（草地附近的样子）.png',
    traitName: '诈死',
    traitEffect: '自己力竭时，少损失1点魔力。',
  },
  {
    id: '52',
    name: '护主犬',
    types: ['火'],
    baseStats: { hp: 68, atk: 103, def: 81, spa: 37, spd: 66, spe: 96 },
    skills: ['3', '96', '69', '292', '7', '293', '294', '295', '42', '296', '101', '100', '52', '118', '21', '22', '23', '24', '6', '26', '27', '28', '29', '74', '31', '32', '15', '34', '35', '36', '115', '38', '202', '277', '297', '84', '182', '85', '112', '66', '298', '299', '11', '67'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.047_护主犬.png',
    traitName: '专注力',
    traitEffect: '入场首回合，获得物攻+100%。',
  },
  {
    id: '53',
    name: '音速犬',
    types: ['火'],
    baseStats: { hp: 85, atk: 116, def: 101, spa: 38, spd: 82, spe: 120 },
    skills: ['3', '96', '69', '292', '7', '293', '294', '295', '42', '296', '101', '100', '52', '118', '21', '22', '23', '24', '6', '26', '27', '28', '29', '74', '31', '32', '15', '34', '35', '36', '115', '38', '202', '277', '297', '84', '182', '85', '112', '66', '298', '299', '11', '67'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.048_音速犬.png',
    traitName: '专注力',
    traitEffect: '入场首回合，获得物攻+100%。',
  },
  {
    id: '54',
    name: '绿耳松鼠',
    types: ['普通'],
    baseStats: { hp: 69, atk: 50, def: 67, spa: 47, spd: 52, spe: 48 },
    skills: ['3', '273', '54', '118', '283', '162', '127', '149', '300', '53', '164', '158', '142', '146', '177', '20', '128', '22', '129', '174', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '35', '120', '139', '230', '68', '214', '301', '302', '168', '220', '153', '224', '178', '223', '218', '303', '227', '113', '304'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.049_绿耳松鼠.png',
    traitName: '囤积',
    traitEffect: '每有1能量，获得双防+10%。',
  },
  {
    id: '55',
    name: '抱枕松鼠',
    types: ['普通'],
    baseStats: { hp: 92, atk: 67, def: 89, spa: 63, spd: 70, spe: 64 },
    skills: ['3', '273', '54', '118', '283', '162', '127', '149', '300', '53', '164', '158', '142', '146', '177', '20', '128', '22', '129', '174', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '35', '120', '139', '230', '68', '214', '301', '302', '168', '220', '153', '224', '178', '223', '218', '303', '227', '113', '304'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.050_抱枕松鼠.png',
    traitName: '囤积',
    traitEffect: '每有1能量，获得双防+10%。',
  },
  {
    id: '56',
    name: '蹦床松鼠',
    types: ['普通'],
    baseStats: { hp: 114, atk: 84, def: 111, spa: 79, spd: 87, spe: 80 },
    skills: ['3', '273', '54', '118', '283', '162', '127', '149', '300', '53', '164', '158', '142', '146', '177', '20', '128', '22', '129', '174', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '35', '120', '139', '230', '68', '214', '301', '302', '168', '220', '153', '224', '178', '223', '218', '303', '227', '113', '304'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.051_蹦床松鼠.png',
    traitName: '囤积',
    traitEffect: '每有1能量，获得双防+10%。',
  },
  {
    id: '57',
    name: '嘟嘟煲',
    types: ['毒'],
    baseStats: { hp: 110, atk: 29, def: 71, spa: 82, spd: 83, spe: 84 },
    skills: ['3', '305', '214', '118', '86', '93', '306', '88', '307', '308', '309', '310', '81', '54', '66', '22', '67', '68', '6', '70', '56', '72', '73', '74', '75', '76', '77', '78', '87', '79', '80', '142', '83', '69', '84', '311', '85', '262', '312', '101', '153', '294', '31', '90', '313'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.052_嘟嘟煲.png',
    traitName: '复方汤剂',
    traitEffect: '回合结束时，中毒效果触发次数+1。',
  },
  {
    id: '58',
    name: '嘟嘟锅',
    types: ['毒'],
    baseStats: { hp: 137, atk: 36, def: 89, spa: 102, spd: 104, spe: 105 },
    skills: ['3', '305', '214', '118', '86', '93', '306', '88', '307', '308', '309', '310', '81', '54', '66', '22', '67', '68', '6', '70', '56', '72', '73', '74', '75', '76', '77', '78', '87', '79', '80', '142', '83', '69', '84', '311', '85', '262', '312', '101', '153', '294', '31', '90', '313'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.053_嘟嘟锅.png',
    traitName: '复方汤剂',
    traitEffect: '回合结束时，中毒效果触发次数+1。',
  },
  {
    id: '59',
    name: '小灵面',
    types: ['幽'],
    baseStats: { hp: 55, atk: 30, def: 59, spa: 72, spd: 81, spe: 69 },
    skills: ['3', '207', '70', '163', '214', '269', '192', '189', '314', '210', '315', '181', '183', '54', '112', '22', '67', '68', '6', '103', '56', '72', '73', '74', '75', '76', '77', '78', '86', '79', '80', '107', '142', '69', '272', '84', '261', '190', '316', '262', '101', '216', '90', '66', '317'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.054_小灵面.png',
    traitName: '惊吓',
    traitEffect: '能量等于0的精灵，无法对自己造成伤害。',
  },
  {
    id: '60',
    name: '暗影灵面（睁眼的样子）',
    types: ['幽'],
    baseStats: { hp: 74, atk: 40, def: 78, spa: 96, spd: 108, spe: 92 },
    skills: ['3', '207', '70', '163', '214', '269', '192', '189', '314', '210', '315', '181', '183', '54', '112', '22', '67', '68', '6', '103', '56', '72', '73', '74', '75', '76', '77', '78', '86', '79', '80', '107', '142', '69', '272', '84', '261', '190', '316', '262', '101', '216', '90', '66', '317'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.055_暗影灵面（睁眼的样子）.png',
    traitName: '惊吓',
    traitEffect: '能量等于0的精灵，无法对自己造成伤害。',
  },
  {
    id: '61',
    name: '幽冥眼（睁眼的样子）',
    types: ['幽'],
    baseStats: { hp: 92, atk: 50, def: 98, spa: 120, spd: 135, spe: 115 },
    skills: ['3', '207', '70', '163', '214', '269', '192', '189', '314', '210', '315', '181', '183', '54', '112', '22', '67', '68', '6', '103', '56', '72', '73', '74', '75', '76', '77', '78', '86', '79', '80', '107', '142', '69', '272', '84', '261', '190', '316', '262', '101', '216', '90', '66', '317'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.056_幽冥眼（睁眼的样子）.png',
    traitName: '惊吓',
    traitEffect: '能量等于0的精灵，无法对自己造成伤害。',
  },
  {
    id: '62',
    name: '梦游（穿旧睡衣的样子）',
    types: ['幽'],
    baseStats: { hp: 90, atk: 40, def: 60, spa: 106, spd: 74, spe: 92 },
    skills: ['118', '38', '3', '315', '70', '271', '4', '269', '261', '314', '181', '153', '183', '54', '66', '22', '67', '68', '69', '103', '56', '72', '73', '74', '75', '259', '77', '78', '86', '79', '80', '187', '152', '260', '318', '272', '84', '319', '12', '211', '263', '180', '114', '317'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.057_梦游（穿旧睡衣的样子）.png',
    traitName: '做噩梦',
    traitEffect: '敌方精灵离场后，更换入场的精灵失去3能量。',
  },
  {
    id: '63',
    name: '梦悠悠（穿旧睡衣的样子）',
    types: ['幽'],
    baseStats: { hp: 113, atk: 50, def: 75, spa: 133, spd: 93, spe: 115 },
    skills: ['118', '38', '3', '315', '70', '271', '4', '269', '261', '314', '181', '153', '183', '54', '66', '22', '67', '68', '69', '103', '56', '72', '73', '74', '75', '259', '77', '78', '86', '79', '80', '187', '152', '260', '318', '272', '84', '319', '12', '211', '263', '180', '114', '317'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.058_梦悠悠（穿旧睡衣的样子）.png',
    traitName: '做噩梦',
    traitEffect: '敌方精灵离场后，更换入场的精灵失去3能量。',
  },
  {
    id: '64',
    name: '兽花蕾',
    types: ['光', '草'],
    baseStats: { hp: 70, atk: 79, def: 70, spa: 82, spd: 97, spe: 115 },
    skills: ['4', '209', '282', '94', '56', '320', '268', '285', '264', '17', '12', '321', '89', '57', '16', '193', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '30', '75', '105', '15', '78', '86', '79', '80', '38', '7', '61', '83', '270', '155', '110', '19', '177', '85', '46', '206', '60', '2', '3', '161'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.059_兽花蕾.png',
    traitName: '稀兽花宝',
    traitEffect: '根据自己的血脉，入场时获得不同效果。',
  },
  {
    id: '65',
    name: '伏地兽',
    types: ['普通'],
    baseStats: { hp: 95, atk: 56, def: 70, spa: 25, spd: 41, spe: 51 },
    skills: ['53', '7', '196', '3', '156', '293', '153', '245', '84', '277', '276', '114', '202', '20', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '54', '152', '108', '130', '232', '109', '258', '44', '90', '290', '322', '279', '323', '253'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.060_伏地兽.png',
    traitName: '壮胆',
    traitEffect: '队伍存在虫系精灵，自己获得双攻+50%。',
  },
  {
    id: '66',
    name: '贪食鼹',
    types: ['普通'],
    baseStats: { hp: 126, atk: 74, def: 94, spa: 33, spd: 54, spe: 68 },
    skills: ['53', '7', '196', '3', '156', '293', '153', '245', '84', '277', '276', '114', '202', '20', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '54', '152', '108', '130', '232', '109', '258', '44', '90', '290', '322', '279', '323', '253'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.061_贪食鼹.png',
    traitName: '壮胆',
    traitEffect: '队伍存在虫系精灵，自己获得双攻+50%。',
  },
  {
    id: '67',
    name: '巨噬针鼹',
    types: ['普通'],
    baseStats: { hp: 158, atk: 93, def: 117, spa: 41, spd: 68, spe: 85 },
    skills: ['53', '7', '196', '3', '156', '293', '153', '245', '84', '277', '276', '114', '202', '20', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '54', '152', '108', '130', '232', '109', '258', '44', '90', '290', '322', '279', '323', '253'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.062_巨噬针鼹.png',
    traitName: '壮胆',
    traitEffect: '队伍存在虫系精灵，自己获得双攻+50%。',
  },
  {
    id: '68',
    name: '蹦蹦种子（海神球形态）',
    types: ['草', '毒'],
    baseStats: { hp: 60, atk: 64, def: 44, spa: 66, spd: 63, spe: 51 },
    skills: ['268', '209', '87', '86', '3', '267', '61', '133', '57', '324', '92', '310', '81', '62', '193', '308', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '130', '109', '83', '159', '85', '234', '8', '309', '168', '153', '60', '89', '50', '151', '163', '127', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.063_蹦蹦种子（海神球形态）.png',
    traitName: '生物碱',
    traitEffect: '使用草系技能时，敌方获得2层中毒。',
  },
  {
    id: '69',
    name: '蹦蹦草（海神球形态）',
    types: ['草', '毒'],
    baseStats: { hp: 80, atk: 85, def: 59, spa: 88, spd: 84, spe: 68 },
    skills: ['268', '209', '87', '86', '3', '267', '61', '133', '57', '324', '92', '310', '81', '62', '193', '308', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '130', '109', '83', '159', '85', '234', '8', '309', '168', '153', '60', '89', '50', '151', '163', '127', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.064_蹦蹦草（海神球形态）.png',
    traitName: '生物碱',
    traitEffect: '使用草系技能时，敌方获得2层中毒。',
  },
  {
    id: '70',
    name: '蹦蹦花（海神球形态）',
    types: ['草', '毒'],
    baseStats: { hp: 100, atk: 107, def: 73, spa: 110, spd: 105, spe: 85 },
    skills: ['268', '209', '87', '86', '3', '267', '61', '133', '57', '324', '92', '310', '81', '62', '193', '308', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '130', '109', '83', '159', '85', '234', '8', '309', '168', '153', '60', '89', '50', '151', '163', '127', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.065_蹦蹦花（海神球形态）.png',
    traitName: '生物碱',
    traitEffect: '使用草系技能时，敌方获得2层中毒。',
  },
  {
    id: '71',
    name: '电咩咩',
    types: ['电'],
    baseStats: { hp: 47, atk: 49, def: 55, spa: 49, spd: 57, spe: 75 },
    skills: ['3', '23', '166', '196', '326', '327', '328', '129', '329', '165', '330', '331', '332', '20', '128', '22', '333', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '35', '120', '175', '202', '334', '214', '142', '61', '188', '319', '335', '153', '105', '91', '283', '218', '278', '58', '127', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.066_电咩咩.png',
    traitName: '快充',
    traitEffect: '离场时回复10能量。',
  },
  {
    id: '72',
    name: '粉咩咩',
    types: ['电'],
    baseStats: { hp: 62, atk: 66, def: 73, spa: 66, spd: 76, spe: 100 },
    skills: ['3', '23', '166', '196', '326', '327', '328', '129', '329', '165', '330', '331', '332', '20', '128', '22', '333', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '35', '120', '175', '202', '334', '214', '142', '61', '188', '319', '335', '153', '105', '91', '283', '218', '278', '58', '127', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.067_粉咩咩.png',
    traitName: '快充',
    traitEffect: '离场时回复10能量。',
  },
  {
    id: '73',
    name: '电球咩咩',
    types: ['电'],
    baseStats: { hp: 78, atk: 82, def: 91, spa: 82, spd: 95, spe: 125 },
    skills: ['3', '23', '166', '196', '326', '327', '328', '129', '329', '165', '330', '331', '332', '20', '128', '22', '333', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '35', '120', '175', '202', '334', '214', '142', '61', '188', '319', '335', '153', '105', '91', '283', '218', '278', '58', '127', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.068_电球咩咩.png',
    traitName: '快充',
    traitEffect: '离场时回复10能量。',
  },
  {
    id: '74',
    name: '蒲公英',
    types: ['草', '萌'],
    baseStats: { hp: 89, atk: 99, def: 103, spa: 94, spd: 78, spe: 52 },
    skills: ['254', '336', '285', '260', '337', '56', '57', '63', '263', '252', '335', '65', '62', '256', '43', '118', '21', '22', '23', '24', '25', '26', '71', '28', '29', '74', '31', '259', '33', '34', '35', '36', '37', '7', '214', '277', '338', '85', '87', '153', '206', '88', '60', '90', '276', '303', '3', '4', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.069_蒲公英.png',
    traitName: '勇敢',
    traitEffect: '携带的能耗大于3的技能，威力+40%。',
  },
  {
    id: '75',
    name: '蒲公英娃娃',
    types: ['草', '萌'],
    baseStats: { hp: 111, atk: 123, def: 129, spa: 117, spd: 97, spe: 65 },
    skills: ['254', '336', '285', '260', '337', '56', '57', '63', '263', '252', '335', '65', '62', '256', '43', '118', '21', '22', '23', '24', '25', '26', '71', '28', '29', '74', '31', '259', '33', '34', '35', '36', '37', '7', '214', '277', '338', '85', '87', '153', '206', '88', '60', '90', '276', '303', '3', '4', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.070_蒲公英娃娃.png',
    traitName: '勇敢',
    traitEffect: '携带的能耗大于3的技能，威力+40%。',
  },
  {
    id: '76',
    name: '伊贝儿',
    types: ['草'],
    baseStats: { hp: 85, atk: 73, def: 76, spa: 71, spd: 76, spe: 72 },
    skills: ['283', '208', '133', '50', '266', '196', '64', '91', '57', '62', '218', '65', '43', '153', '177', '127', '128', '22', '129', '130', '131', '132', '71', '134', '135', '74', '31', '32', '136', '137', '35', '120', '139', '213', '38', '158', '143', '233', '256', '76', '235', '263', '93', '219', '276', '264', '58', '3', '304'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.071_伊贝儿.png',
    traitName: '腐植循环',
    traitEffect: '每回复1能量，同时回复5%生命。',
  },
  {
    id: '77',
    name: '伊贝粉粉',
    types: ['草'],
    baseStats: { hp: 106, atk: 91, def: 95, spa: 89, spd: 95, spe: 90 },
    skills: ['283', '208', '133', '50', '266', '196', '64', '91', '57', '62', '218', '65', '43', '153', '177', '127', '128', '22', '129', '130', '131', '132', '71', '134', '135', '74', '31', '32', '136', '137', '35', '120', '139', '213', '38', '158', '143', '233', '256', '76', '235', '263', '93', '219', '276', '264', '58', '3', '304'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.072_伊贝粉粉.png',
    traitName: '腐植循环',
    traitEffect: '每回复1能量，同时回复5%生命。',
  },
  {
    id: '78',
    name: '白发懒人',
    types: ['普通'],
    baseStats: { hp: 86, atk: 94, def: 81, spa: 38, spd: 66, spe: 45 },
    skills: ['196', '301', '85', '3', '7', '171', '68', '108', '339', '340', '341', '83', '342', '202', '20', '21', '22', '23', '174', '25', '103', '27', '28', '29', '94', '104', '105', '33', '51', '87', '36', '115', '343', '38', '13', '203', '166', '277', '289', '258', '159', '44', '344', '90', '345', '276', '346'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.073_白发懒人.png',
    traitName: '慢热型',
    traitEffect: '初始能量为0，入场前己方精灵每成功应对1次，回复5能量。',
  },
  {
    id: '79',
    name: '动力猿',
    types: ['普通', '武'],
    baseStats: { hp: 115, atk: 125, def: 108, spa: 51, spd: 88, spe: 60 },
    skills: ['196', '301', '85', '3', '7', '171', '68', '108', '339', '340', '341', '83', '342', '202', '20', '21', '22', '23', '174', '25', '103', '27', '28', '29', '94', '104', '105', '33', '51', '87', '36', '115', '343', '38', '13', '203', '166', '277', '289', '258', '159', '44', '344', '90', '345', '276', '346'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.074_动力猿.png',
    traitName: '慢热型',
    traitEffect: '初始能量为0，入场前己方精灵每成功应对1次，回复5能量。',
  },
  {
    id: '80',
    name: '瞌睡王',
    types: ['普通', '武'],
    baseStats: { hp: 144, atk: 157, def: 135, spa: 64, spd: 110, spe: 75 },
    skills: ['196', '301', '85', '3', '7', '171', '68', '108', '339', '340', '341', '83', '342', '202', '20', '21', '22', '23', '174', '25', '103', '27', '28', '29', '94', '104', '105', '33', '51', '87', '36', '115', '343', '38', '13', '203', '166', '277', '289', '258', '159', '44', '344', '90', '345', '276', '346'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.075_瞌睡王.png',
    traitName: '慢热型',
    traitEffect: '初始能量为0，入场前己方精灵每成功应对1次，回复5能量。',
  },
  {
    id: '81',
    name: '海盔虫（本来的样子）',
    types: ['水', '毒'],
    baseStats: { hp: 71, atk: 25, def: 46, spa: 59, spd: 66, spe: 60 },
    skills: ['3', '119', '79', '93', '92', '163', '307', '123', '310', '309', '124', '347', '338', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '87', '138', '80', '81', '107', '166', '109', '83', '348', '272', '85', '190', '47', '349', '90', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.076_海盔虫（本来的样子）.png',
    traitName: '溶解扩散',
    traitEffect: '每携带1个毒系技能进入战斗，水系技能使敌方获得1层中毒。',
  },
  {
    id: '82',
    name: '刺盔虫（本来的样子）',
    types: ['水', '毒'],
    baseStats: { hp: 94, atk: 33, def: 61, spa: 79, spd: 88, spe: 80 },
    skills: ['3', '119', '79', '93', '92', '163', '307', '123', '310', '309', '124', '347', '338', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '87', '138', '80', '81', '107', '166', '109', '83', '348', '272', '85', '190', '47', '349', '90', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.077_刺盔虫（本来的样子）.png',
    traitName: '溶解扩散',
    traitEffect: '每携带1个毒系技能进入战斗，水系技能使敌方获得1层中毒。',
  },
  {
    id: '83',
    name: '千棘盔（本来的样子）',
    types: ['水', '毒'],
    baseStats: { hp: 118, atk: 41, def: 76, spa: 99, spd: 111, spe: 100 },
    skills: ['3', '119', '79', '93', '92', '163', '307', '123', '310', '309', '124', '347', '338', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '87', '138', '80', '81', '107', '166', '109', '83', '348', '272', '85', '190', '47', '349', '90', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.078_千棘盔（本来的样子）.png',
    traitName: '溶解扩散',
    traitEffect: '每携带1个毒系技能进入战斗，水系技能使敌方获得1层中毒。',
  },
  {
    id: '84',
    name: '菊花梨',
    types: ['萌'],
    baseStats: { hp: 106, atk: 49, def: 77, spa: 116, spd: 115, spe: 60 },
    skills: ['105', '4', '95', '3', '260', '319', '85', '263', '336', '335', '350', '114', '118', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '259', '353', '51', '87', '170', '115', '157', '38', '337', '267', '318', '83', '212', '84', '46', '211', '14', '153', '252', '50', '303'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.079_菊花梨.png',
    traitName: '无忧无虑',
    traitEffect: '可获得的萌化层数不受限制。',
  },
  {
    id: '85',
    name: '小星光（星光能量的样子）',
    types: ['电'],
    baseStats: { hp: 60, atk: 81, def: 72, spa: 85, spd: 88, spe: 108 },
    skills: ['4', '351', '23', '299', '3', '10', '85', '354', '326', '245', '328', '355', '356', '303', '332', '118', '21', '22', '333', '174', '25', '26', '27', '72', '29', '74', '31', '32', '33', '34', '35', '36', '37', '152', '18', '5', '318', '109', '272', '84', '182', '111', '292', '12', '48', '153', '114', '67', '317'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.080_小星光（星光能量的样子）.png',
    traitName: '电流刺激',
    traitEffect: '携带的攻击技能获得迸发：威力+40。',
  },
  {
    id: '86',
    name: '星光狮（星光能量的样子）',
    types: ['电'],
    baseStats: { hp: 75, atk: 101, def: 90, spa: 106, spd: 110, spe: 135 },
    skills: ['4', '351', '23', '299', '3', '10', '85', '354', '326', '245', '328', '355', '356', '303', '332', '118', '21', '22', '333', '174', '25', '26', '27', '72', '29', '74', '31', '32', '33', '34', '35', '36', '37', '152', '18', '5', '318', '109', '272', '84', '182', '111', '292', '12', '48', '153', '114', '67', '317'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.081_星光狮（星光能量的样子）.png',
    traitName: '电流刺激',
    traitEffect: '携带的攻击技能获得迸发：威力+40。',
  },
  {
    id: '87',
    name: '一窝蜂',
    types: ['虫', '翼'],
    baseStats: { hp: 87, atk: 32, def: 27, spa: 29, spd: 27, spe: 26 },
    skills: ['4', '357', '265', '249', '322', '250', '115', '106', '110', '358', '80', '169', '359', '360', '361', '117', '118', '21', '22', '23', '24', '25', '26', '27', '28', '258', '74', '31', '32', '33', '34', '87', '36', '37', '38', '337', '166', '155', '272', '182', '44', '153', '206', '88', '90', '92', '290', '219', '303', '3', '362'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.082_一窝蜂.png',
    traitName: '虫群鼓舞',
    traitEffect: '队伍中每有1只其他的虫系精灵，自己入场时获得攻防速+10%。',
  },
  {
    id: '88',
    name: '黄蜂后',
    types: ['虫', '翼'],
    baseStats: { hp: 116, atk: 43, def: 36, spa: 39, spd: 36, spe: 35 },
    skills: ['4', '357', '265', '249', '322', '250', '115', '106', '110', '358', '80', '169', '359', '360', '361', '117', '118', '21', '22', '23', '24', '25', '26', '27', '28', '258', '74', '31', '32', '33', '34', '87', '36', '37', '38', '337', '166', '155', '272', '182', '44', '153', '206', '88', '90', '92', '290', '219', '303', '3', '362'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.083_黄蜂后.png',
    traitName: '虫群鼓舞',
    traitEffect: '队伍中每有1只其他的虫系精灵，自己入场时获得攻防速+10%。',
  },
  {
    id: '89',
    name: '女王蜂',
    types: ['虫', '翼'],
    baseStats: { hp: 145, atk: 50, def: 42, spa: 45, spd: 42, spe: 40 },
    skills: ['4', '357', '265', '249', '322', '250', '115', '106', '110', '358', '80', '169', '359', '360', '361', '117', '118', '21', '22', '23', '24', '25', '26', '27', '28', '258', '74', '31', '32', '33', '34', '87', '36', '37', '38', '337', '166', '155', '272', '182', '44', '153', '206', '88', '90', '92', '290', '219', '303', '3', '362'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.084_女王蜂.png',
    traitName: '虫群鼓舞',
    traitEffect: '队伍中每有1只其他的虫系精灵，自己入场时获得攻防速+10%。',
  },
  {
    id: '90',
    name: '小夜',
    types: ['恶'],
    baseStats: { hp: 60, atk: 69, def: 62, spa: 63, spd: 51, spe: 69 },
    skills: ['3', '243', '66', '272', '150', '162', '7', '128', '363', '187', '317', '191', '194', '182', '185', '54', '112', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '32', '77', '78', '86', '138', '80', '156', '350', '214', '176', '155', '159', '319', '85', '190', '335', '44', '153', '76', '160', '24', '259'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.085_小夜.png',
    traitName: '嫁祸',
    traitEffect: '自己每失去25%生命，连击数+2。',
  },
  {
    id: '91',
    name: '紫夜',
    types: ['恶'],
    baseStats: { hp: 80, atk: 92, def: 83, spa: 84, spd: 68, spe: 92 },
    skills: ['3', '243', '66', '272', '150', '162', '7', '128', '363', '187', '317', '191', '194', '182', '185', '54', '112', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '32', '77', '78', '86', '138', '80', '156', '350', '214', '176', '155', '159', '319', '85', '190', '335', '44', '153', '76', '160', '24', '259'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.086_紫夜.png',
    traitName: '嫁祸',
    traitEffect: '自己每失去25%生命，连击数+2。',
  },
  {
    id: '92',
    name: '朔夜伊芙',
    types: ['恶'],
    baseStats: { hp: 100, atk: 115, def: 104, spa: 105, spd: 85, spe: 115 },
    skills: ['3', '243', '66', '272', '150', '162', '7', '128', '363', '187', '317', '191', '194', '182', '185', '54', '112', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '32', '77', '78', '86', '138', '80', '156', '350', '214', '176', '155', '159', '319', '85', '190', '335', '44', '153', '76', '160', '24', '259'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.087_朔夜伊芙.png',
    traitName: '嫁祸',
    traitEffect: '自己每失去25%生命，连击数+2。',
  },
  {
    id: '93',
    name: '乖乖鹄',
    types: ['翼', '水'],
    baseStats: { hp: 75, atk: 57, def: 83, spa: 52, spd: 58, spe: 69 },
    skills: ['265', '161', '3', '9', '7', '196', '115', '364', '169', '175', '117', '20', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '35', '120', '139', '54', '199', '143', '109', '177', '274', '192', '218', '127'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.088_乖乖鹄.png',
    traitName: '洁癖',
    traitEffect: '离场后，自己的增益和减益会被更换入场的精灵继承。',
  },
  {
    id: '94',
    name: '蓝珠天鹅',
    types: ['翼', '水'],
    baseStats: { hp: 100, atk: 76, def: 110, spa: 69, spd: 78, spe: 92 },
    skills: ['265', '161', '3', '9', '7', '196', '115', '364', '169', '175', '117', '20', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '35', '120', '139', '54', '199', '143', '109', '177', '274', '192', '218', '127'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.089_蓝珠天鹅.png',
    traitName: '洁癖',
    traitEffect: '离场后，自己的增益和减益会被更换入场的精灵继承。',
  },
  {
    id: '95',
    name: '翠顶夫人',
    types: ['翼', '水'],
    baseStats: { hp: 125, atk: 95, def: 138, spa: 86, spd: 97, spe: 115 },
    skills: ['265', '161', '3', '9', '7', '196', '115', '364', '169', '175', '117', '45', '365', '121', '204', '127', '128', '22', '129', '130', '131', '132', '133', '13', '135', '74', '31', '32', '136', '137', '35', '138', '139', '106', '199', '18', '143', '109', '82', '205', '173', '123', '124', '47', '192', '218', '113', '282'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.090_翠顶夫人.png',
    traitName: '洁癖',
    traitEffect: '离场后，自己的增益和减益会被更换入场的精灵继承。',
  },
  {
    id: '96',
    name: '黑羽夫人',
    types: ['翼', '恶'],
    baseStats: { hp: 132, atk: 93, def: 130, spa: 87, spd: 90, spe: 120 },
    skills: ['265', '161', '3', '9', '7', '196', '115', '364', '169', '175', '117', '366', '182', '128', '367', '368', '127', '112', '22', '129', '130', '131', '103', '133', '134', '135', '74', '31', '32', '136', '137', '35', '120', '139', '106', '199', '143', '109', '45', '204', '205', '274', '123', '47', '192', '180', '218', '113', '317'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.091_黑羽夫人.png',
    traitName: '贪婪',
    traitEffect: '敌方精灵离场后，其增益和减益会被更换入场的精灵继承。',
  },
  {
    id: '97',
    name: '锤头鹳',
    types: ['翼', '水'],
    baseStats: { hp: 111, atk: 67, def: 91, spa: 65, spd: 72, spe: 105 },
    skills: ['4', '265', '139', '115', '79', '9', '161', '206', '106', '245', '198', '365', '347', '169', '121', '54', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '86', '138', '37', '156', '152', '214', '150', '155', '185', '272', '182', '261', '85', '122', '153', '90', '192', '180', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.092_锤头鹳.png',
    traitName: '快锤',
    traitEffect: '携带的能耗小于3的技能，获得迅捷。',
  },
  {
    id: '98',
    name: '绿草精灵',
    types: ['草', '幻'],
    baseStats: { hp: 79, atk: 35, def: 87, spa: 89, spd: 111, spe: 72 },
    skills: ['4', '209', '27', '89', '58', '8', '188', '353', '77', '196', '369', '39', '60', '54', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '15', '78', '86', '79', '80', '157', '370', '64', '214', '143', '144', '82', '83', '371', '85', '12', '90', '193', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.093_绿草精灵.png',
    traitName: '木桶戏法',
    traitEffect: '离场后，更换入场的精灵以木桶状态登场。',
  },
  {
    id: '99',
    name: '魔草巫灵',
    types: ['草', '幻'],
    baseStats: { hp: 99, atk: 43, def: 109, spa: 112, spd: 139, spe: 90 },
    skills: ['4', '209', '27', '89', '58', '8', '188', '353', '77', '196', '369', '39', '60', '54', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '15', '78', '86', '79', '80', '157', '370', '64', '214', '143', '144', '82', '83', '371', '85', '12', '90', '193', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.094_魔草巫灵.png',
    traitName: '木桶戏法',
    traitEffect: '离场后，更换入场的精灵以木桶状态登场。',
  },
  {
    id: '100',
    name: '记忆石',
    types: ['地'],
    baseStats: { hp: 112, atk: 108, def: 141, spa: 97, spd: 79, spe: 70 },
    skills: ['4', '3', '34', '51', '7', '225', '222', '275', '237', '240', '241', '372', '78', '373', '229', '1', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '105', '33', '220', '87', '36', '115', '202', '18', '64', '374', '109', '375', '83', '43', '85', '8', '12', '280', '303', '304', '285'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.095_记忆石.png',
    traitName: '不移',
    traitEffect: '携带的无额外效果的攻击技能，威力+30%。',
  },
  {
    id: '101',
    name: '咔咔羽毛',
    types: ['翼', '普通'],
    baseStats: { hp: 58, atk: 68, def: 61, spa: 66, spd: 53, spe: 72 },
    skills: ['3', '195', '109', '1', '4', '162', '376', '149', '80', '206', '155', '167', '169', '200', '303', '20', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '32', '33', '51', '87', '36', '115', '156', '245', '152', '267', '57', '318', '83', '43', '153', '105', '266', '217', '286', '276', '259', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.096_咔咔羽毛.png',
    traitName: '咔咔冲刺',
    traitEffect: '若先于敌方行动，行动后获得连击数+1。',
  },
  {
    id: '102',
    name: '咔咔雀',
    types: ['翼', '普通'],
    baseStats: { hp: 78, atk: 91, def: 81, spa: 88, spd: 71, spe: 96 },
    skills: ['3', '195', '109', '1', '4', '162', '376', '149', '80', '206', '155', '167', '169', '200', '303', '20', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '32', '33', '51', '87', '36', '115', '156', '245', '152', '267', '57', '318', '83', '43', '153', '105', '266', '217', '286', '276', '259', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.097_咔咔雀.png',
    traitName: '咔咔冲刺',
    traitEffect: '若先于敌方行动，行动后获得连击数+1。',
  },
  {
    id: '103',
    name: '咔咔鸟',
    types: ['翼', '普通'],
    baseStats: { hp: 97, atk: 114, def: 101, spa: 110, spd: 89, spe: 120 },
    skills: ['3', '195', '109', '1', '4', '162', '376', '149', '80', '206', '155', '167', '169', '200', '303', '20', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '32', '33', '51', '87', '36', '115', '156', '245', '152', '267', '57', '318', '83', '43', '153', '105', '266', '217', '286', '276', '259', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.098_咔咔鸟.png',
    traitName: '咔咔冲刺',
    traitEffect: '若先于敌方行动，行动后获得连击数+1。',
  },
  {
    id: '104',
    name: '小草虫',
    types: ['虫', '草'],
    baseStats: { hp: 73, atk: 40, def: 50, spa: 43, spd: 57, spe: 60 },
    skills: ['3', '377', '249', '378', '73', '53', '291', '379', '209', '61', '323', '286', '27', '193', '380', '54', '66', '22', '67', '68', '69', '70', '71', '72', '258', '74', '75', '76', '77', '78', '86', '79', '80', '370', '374', '381', '109', '83', '270', '155', '250', '177', '371', '85', '89', '90', '360', '322', '253'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.099_小草虫.png',
    traitName: '花精灵',
    traitEffect: '回合结束时，己方队伍获得1次随机奉献。',
  },
  {
    id: '105',
    name: '草衣虫',
    types: ['虫', '草'],
    baseStats: { hp: 97, atk: 53, def: 67, spa: 57, spd: 75, spe: 80 },
    skills: ['3', '377', '249', '378', '73', '53', '291', '379', '209', '61', '323', '286', '27', '193', '380', '54', '66', '22', '67', '68', '69', '70', '71', '72', '258', '74', '75', '76', '77', '78', '86', '79', '80', '370', '374', '381', '109', '83', '270', '155', '250', '177', '371', '85', '89', '90', '360', '322', '253'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.100_草衣虫.png',
    traitName: '花精灵',
    traitEffect: '回合结束时，己方队伍获得1次随机奉献。',
  },
  {
    id: '106',
    name: '花衣蝶',
    types: ['虫', '草'],
    baseStats: { hp: 122, atk: 67, def: 84, spa: 72, spd: 94, spe: 100 },
    skills: ['3', '377', '249', '378', '73', '53', '291', '379', '209', '61', '323', '286', '27', '193', '380', '54', '66', '22', '67', '68', '69', '70', '71', '72', '258', '74', '75', '76', '77', '78', '86', '79', '80', '370', '374', '381', '109', '83', '270', '155', '250', '177', '371', '85', '89', '90', '360', '322', '253'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.101_花衣蝶.png',
    traitName: '花精灵',
    traitEffect: '回合结束时，己方队伍获得1次随机奉献。',
  },
  {
    id: '107',
    name: '绿翼鸟',
    types: ['萌', '翼'],
    baseStats: { hp: 52, atk: 68, def: 56, spa: 20, spd: 53, spe: 81 },
    skills: ['195', '76', '254', '3', '80', '235', '252', '206', '198', '110', '284', '335', '117', '1', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '259', '33', '51', '87', '36', '115', '156', '152', '337', '267', '109', '61', '315', '84', '85', '153', '105', '59', '276', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.102_绿翼鸟.png',
    traitName: '自由飘',
    traitEffect: '自己每有1层萌化，获得连击数+2。',
  },
  {
    id: '108',
    name: '魔翼鸟',
    types: ['萌', '翼'],
    baseStats: { hp: 70, atk: 91, def: 75, spa: 27, spd: 70, spe: 108 },
    skills: ['195', '76', '254', '3', '80', '235', '252', '206', '198', '110', '284', '335', '117', '1', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '259', '33', '51', '87', '36', '115', '156', '152', '337', '267', '109', '61', '315', '84', '85', '153', '105', '59', '276', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.103_魔翼鸟.png',
    traitName: '自由飘',
    traitEffect: '自己每有1层萌化，获得连击数+2。',
  },
  {
    id: '109',
    name: '魔眷鸟',
    types: ['萌', '翼'],
    baseStats: { hp: 87, atk: 113, def: 94, spa: 34, spd: 88, spe: 135 },
    skills: ['195', '76', '254', '3', '80', '235', '252', '206', '198', '110', '284', '335', '117', '1', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '259', '33', '51', '87', '36', '115', '156', '152', '337', '267', '109', '61', '315', '84', '85', '153', '105', '59', '276', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.104_魔眷鸟.png',
    traitName: '自由飘',
    traitEffect: '自己每有1层萌化，获得连击数+2。',
  },
  {
    id: '110',
    name: '阿米亚特',
    types: ['地'],
    baseStats: { hp: 64, atk: 95, def: 67, spa: 47, spd: 42, spe: 45 },
    skills: ['243', '363', '66', '7', '196', '222', '382', '107', '228', '239', '78', '111', '232', '240', '20', '112', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '38', '166', '130', '171', '229', '246', '42', '44', '97', '221', '113', '52', '3', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.105_阿米亚特.png',
    traitName: '石头大餐',
    traitEffect: '能量不足时，消耗5%生命，代替1能量。',
  },
  {
    id: '111',
    name: '阿米樱',
    types: ['地'],
    baseStats: { hp: 86, atk: 127, def: 89, spa: 62, spd: 56, spe: 60 },
    skills: ['243', '363', '66', '7', '196', '222', '382', '107', '228', '239', '78', '111', '232', '240', '20', '112', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '38', '166', '130', '171', '229', '246', '42', '44', '97', '221', '113', '52', '3', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.106_阿米樱.png',
    traitName: '石头大餐',
    traitEffect: '能量不足时，消耗5%生命，代替1能量。',
  },
  {
    id: '112',
    name: '罗隐',
    types: ['地', '恶'],
    baseStats: { hp: 107, atk: 159, def: 112, spa: 78, spd: 70, spe: 75 },
    skills: ['243', '363', '66', '7', '196', '222', '382', '107', '228', '239', '78', '111', '232', '240', '20', '112', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '38', '166', '130', '171', '229', '246', '42', '44', '97', '221', '113', '52', '3', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.107_罗隐.png',
    traitName: '石头大餐',
    traitEffect: '能量不足时，消耗5%生命，代替1能量。',
  },
  {
    id: '113',
    name: '风铃鲨',
    types: ['水', '翼'],
    baseStats: { hp: 54, atk: 46, def: 63, spa: 46, spd: 63, spe: 75 },
    skills: ['4', '119', '365', '364', '167', '348', '217', '38', '169', '125', '121', '347', '40', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '32', '353', '51', '87', '138', '115', '383', '41', '155', '384', '385', '124', '153', '146', '255', '386', '303', '3', '198'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.108_风铃鲨.png',
    traitName: '水翼推进',
    traitEffect: '己方精灵每使用1次水系技能，自己入场时获得全技能能耗-1。',
  },
  {
    id: '114',
    name: '蓝蝶鲨',
    types: ['水', '翼'],
    baseStats: { hp: 72, atk: 61, def: 84, spa: 61, spd: 84, spe: 100 },
    skills: ['4', '119', '365', '364', '167', '348', '217', '38', '169', '125', '121', '347', '40', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '32', '353', '51', '87', '138', '115', '383', '41', '155', '384', '385', '124', '153', '146', '255', '386', '303', '3', '198'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.109_蓝蝶鲨.png',
    traitName: '水翼推进',
    traitEffect: '己方精灵每使用1次水系技能，自己入场时获得全技能能耗-1。',
  },
  {
    id: '115',
    name: '彩蝶鲨',
    types: ['水', '翼'],
    baseStats: { hp: 90, atk: 98, def: 105, spa: 98, spd: 105, spe: 125 },
    skills: ['4', '119', '365', '364', '167', '348', '217', '38', '169', '125', '121', '347', '40', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '32', '353', '51', '87', '138', '115', '383', '41', '155', '384', '385', '124', '153', '146', '255', '386', '303', '3', '198'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.110_彩蝶鲨.png',
    traitName: '水翼推进',
    traitEffect: '己方精灵每使用1次水系技能，自己入场时获得全技能能耗-1。',
  },
  {
    id: '116',
    name: '石石',
    types: ['地'],
    baseStats: { hp: 76, atk: 79, def: 101, spa: 79, spd: 56, spe: 76 },
    skills: ['3', '207', '70', '220', '210', '26', '222', '231', '225', '241', '216', '183', '269', '287', '228', '54', '66', '22', '67', '68', '69', '103', '56', '72', '73', '74', '75', '76', '77', '51', '86', '79', '80', '387', '383', '7', '214', '142', '240', '41', '85', '234', '78', '388', '221', '90', '192', '181', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.111_石石.png',
    traitName: '石天平',
    traitEffect: '若使用技能能耗高于敌方，回合结束敌方失去能耗之差的能量。',
  },
  {
    id: '117',
    name: '巨灵石',
    types: ['地', '幽'],
    baseStats: { hp: 95, atk: 99, def: 126, spa: 99, spd: 70, spe: 95 },
    skills: ['3', '207', '70', '220', '210', '26', '222', '231', '225', '241', '216', '183', '269', '287', '228', '54', '66', '22', '67', '68', '69', '103', '56', '72', '73', '74', '75', '76', '77', '51', '86', '79', '80', '387', '383', '7', '214', '142', '240', '41', '85', '234', '78', '388', '221', '90', '192', '181', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.112_巨灵石.png',
    traitName: '石天平',
    traitEffect: '若使用技能能耗高于敌方，回合结束敌方失去能耗之差的能量。',
  },
  {
    id: '118',
    name: '仪使者',
    types: ['地', '幻'],
    baseStats: { hp: 64, atk: 54, def: 69, spa: 57, spd: 71, spe: 51 },
    skills: ['224', '389', '371', '14', '4', '223', '7', '231', '225', '390', '39', '222', '241', '287', '372', '78', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '15', '51', '86', '79', '80', '370', '214', '210', '381', '144', '83', '369', '183', '85', '211', '103', '391', '237', '77', '3', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.113_仪使者.png',
    traitName: '观星',
    traitEffect: '敌方每有1层星陨印记，自己的地系技能威力+15%。',
  },
  {
    id: '119',
    name: '仪式之星',
    types: ['地', '幻'],
    baseStats: { hp: 85, atk: 72, def: 92, spa: 76, spd: 95, spe: 68 },
    skills: ['224', '389', '371', '14', '4', '223', '7', '231', '225', '390', '39', '222', '241', '287', '372', '78', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '15', '51', '86', '79', '80', '370', '214', '210', '381', '144', '83', '369', '183', '85', '211', '103', '391', '237', '77', '3', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.114_仪式之星.png',
    traitName: '观星',
    traitEffect: '敌方每有1层星陨印记，自己的地系技能威力+15%。',
  },
  {
    id: '120',
    name: '仪式巨像',
    types: ['地', '幻'],
    baseStats: { hp: 106, atk: 90, def: 115, spa: 95, spd: 119, spe: 85 },
    skills: ['224', '389', '371', '14', '4', '223', '7', '231', '225', '390', '39', '222', '241', '287', '372', '78', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '15', '51', '86', '79', '80', '370', '214', '210', '381', '144', '83', '369', '183', '85', '211', '103', '391', '237', '77', '3', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.115_仪式巨像.png',
    traitName: '观星',
    traitEffect: '敌方每有1层星陨印记，自己的地系技能威力+15%。',
  },
  {
    id: '121',
    name: '小独角兽',
    types: ['光'],
    baseStats: { hp: 79, atk: 48, def: 62, spa: 129, spd: 74, spe: 84 },
    skills: ['163', '4', '74', '3', '85', '82', '152', '17', '12', '19', '155', '146', '114', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '30', '31', '32', '353', '51', '87', '170', '115', '337', '28', '57', '167', '109', '384', '268', '45', '80', '169', '283', '79', '10', '326', '303', '147', '67', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.116_小独角兽.png',
    traitName: '目空',
    traitEffect: '携带的非光系技能，威力+25%。',
  },
  {
    id: '122',
    name: '白金独角兽',
    types: ['光'],
    baseStats: { hp: 99, atk: 61, def: 77, spa: 161, spd: 92, spe: 105 },
    skills: ['163', '4', '74', '3', '85', '82', '152', '17', '12', '19', '155', '146', '114', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '30', '31', '32', '353', '51', '87', '170', '115', '337', '28', '57', '167', '109', '384', '268', '45', '80', '169', '283', '79', '10', '326', '303', '147', '67', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.117_白金独角兽.png',
    traitName: '目空',
    traitEffect: '携带的非光系技能，威力+25%。',
  },
  {
    id: '123',
    name: '旋叶虫（金黄的样子）',
    types: ['普通', '虫'],
    baseStats: { hp: 56, atk: 15, def: 63, spa: 65, spd: 55, spe: 72 },
    skills: ['357', '192', '118', '3', '73', '322', '84', '162', '255', '148', '278', '303', '20', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '353', '51', '87', '170', '115', '156', '157', '152', '337', '109', '375', '268', '234', '153', '60', '361', '27', '114', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.118_旋叶虫（金黄的样子）.png',
    traitName: '共鸣',
    traitEffect: '携带的【虫鸣】技能威力+20。',
  },
  {
    id: '124',
    name: '蓬叶虫（金黄的样子）',
    types: ['普通', '虫'],
    baseStats: { hp: 74, atk: 19, def: 84, spa: 87, spd: 73, spe: 96 },
    skills: ['357', '192', '118', '3', '73', '322', '84', '162', '255', '148', '278', '303', '20', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '353', '51', '87', '170', '115', '156', '157', '152', '337', '109', '375', '268', '234', '153', '60', '361', '27', '114', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.119_蓬叶虫（金黄的样子）.png',
    traitName: '共鸣',
    traitEffect: '携带的【虫鸣】技能威力+20。',
  },
  {
    id: '125',
    name: '风滚暮虫（金黄的样子）',
    types: ['普通', '虫'],
    baseStats: { hp: 93, atk: 24, def: 105, spa: 109, spd: 91, spe: 120 },
    skills: ['357', '192', '118', '3', '73', '322', '84', '162', '255', '148', '278', '303', '20', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '353', '51', '87', '170', '115', '156', '157', '152', '337', '109', '375', '268', '234', '153', '60', '361', '27', '114', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.120_风滚暮虫（金黄的样子）.png',
    traitName: '共鸣',
    traitEffect: '携带的【虫鸣】技能威力+20。',
  },
  {
    id: '126',
    name: '小黑猫',
    types: ['普通'],
    baseStats: { hp: 121, atk: 72, def: 54, spa: 130, spd: 95, spe: 56 },
    skills: ['4', '118', '3', '163', '152', '304', '192', '143', '392', '157', '270', '90', '155', '20', '66', '22', '67', '68', '69', '103', '56', '72', '73', '74', '75', '76', '15', '78', '86', '79', '139', '38', '70', '271', '210', '315', '84', '261', '177', '85', '153', '80', '198', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.121_小黑猫.png',
    traitName: '预警',
    traitEffect: '若敌方技能足够击败自己，回合开始时自己获得速度+50。',
  },
  {
    id: '127',
    name: '黑猫巫师',
    types: ['普通'],
    baseStats: { hp: 152, atk: 91, def: 67, spa: 163, spd: 119, spe: 70 },
    skills: ['4', '118', '3', '163', '152', '304', '192', '143', '392', '157', '270', '90', '155', '20', '66', '22', '67', '68', '69', '103', '56', '72', '73', '74', '75', '76', '15', '78', '86', '79', '139', '38', '70', '271', '210', '315', '84', '261', '177', '85', '153', '80', '198', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.122_黑猫巫师.png',
    traitName: '预警',
    traitEffect: '若敌方技能足够击败自己，回合开始时自己获得速度+50。',
  },
  {
    id: '128',
    name: '忽幽狸',
    types: ['幽', '毒'],
    baseStats: { hp: 78, atk: 87, def: 84, spa: 84, spd: 56, spe: 104 },
    skills: ['393', '207', '7', '53', '70', '219', '26', '310', '181', '269', '186', '81', '307', '212', '394', '1', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '196', '68', '130', '214', '210', '185', '338', '111', '191', '86', '153', '160', '112', '276', '3', '362', '317'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.123_忽幽狸.png',
    traitName: '下黑手',
    traitEffect: '敌方精灵离场后，更换入场的精灵获得5层中毒。',
  },
  {
    id: '129',
    name: '影狸',
    types: ['幽', '毒'],
    baseStats: { hp: 97, atk: 109, def: 105, spa: 105, spd: 70, spe: 130 },
    skills: ['393', '207', '7', '53', '70', '219', '26', '310', '181', '269', '186', '81', '307', '212', '394', '1', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '196', '68', '130', '214', '210', '185', '338', '111', '191', '86', '153', '160', '112', '276', '3', '362', '317'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.124_影狸.png',
    traitName: '下黑手',
    traitEffect: '敌方精灵离场后，更换入场的精灵获得5层中毒。',
  },
  {
    id: '130',
    name: '多多',
    types: ['毒', '地'],
    baseStats: { hp: 47, atk: 53, def: 82, spa: 53, spd: 66, spe: 54 },
    skills: ['306', '35', '213', '34', '221', '93', '308', '3', '149', '87', '238', '225', '226', '394', '362', '229', '127', '128', '22', '129', '130', '131', '132', '133', '134', '258', '74', '31', '32', '136', '51', '86', '120', '175', '337', '230', '142', '143', '109', '228', '338', '233', '319', '262', '153', '224', '264', '227', '395', '304'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.125_多多.png',
    traitName: '毒牙',
    traitEffect: '使敌方获得中毒时，也会使其获得魔攻和魔防-40%。',
  },
  {
    id: '131',
    name: '多啦多',
    types: ['毒', '地'],
    baseStats: { hp: 63, atk: 70, def: 109, spa: 70, spd: 88, spe: 72 },
    skills: ['306', '35', '213', '34', '221', '93', '308', '3', '149', '87', '238', '225', '226', '394', '362', '229', '127', '128', '22', '129', '130', '131', '132', '133', '134', '258', '74', '31', '32', '136', '51', '86', '120', '175', '337', '230', '142', '143', '109', '228', '338', '233', '319', '262', '153', '224', '264', '227', '395', '304'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.126_多啦多.png',
    traitName: '毒牙',
    traitEffect: '使敌方获得中毒时，也会使其获得魔攻和魔防-40%。',
  },
  {
    id: '132',
    name: '古啦多',
    types: ['毒', '地'],
    baseStats: { hp: 79, atk: 88, def: 136, spa: 88, spd: 110, spe: 90 },
    skills: ['306', '35', '213', '34', '221', '93', '308', '3', '149', '87', '238', '225', '226', '394', '362', '229', '127', '128', '22', '129', '130', '131', '132', '133', '134', '258', '74', '31', '32', '136', '51', '86', '120', '175', '337', '230', '142', '143', '109', '228', '338', '233', '319', '262', '153', '224', '264', '227', '395', '304'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.127_古啦多.png',
    traitName: '毒牙',
    traitEffect: '使敌方获得中毒时，也会使其获得魔攻和魔防-40%。',
  },
  {
    id: '133',
    name: '哭哭菇',
    types: ['幻'],
    baseStats: { hp: 74, atk: 38, def: 30, spa: 41, spd: 60, spe: 36 },
    skills: ['389', '283', '3', '33', '396', '353', '143', '293', '278', '218', '144', '381', '136', '397', '146', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '15', '137', '87', '138', '139', '54', '196', '142', '109', '26', '369', '315', '189', '177', '209', '153', '91', '286', '50', '58', '285'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.128_哭哭菇.png',
    traitName: '吸积盘',
    traitEffect: '回合结束时，敌方获得2层星陨印记。',
  },
  {
    id: '134',
    name: '怖须菇',
    types: ['幻'],
    baseStats: { hp: 99, atk: 50, def: 40, spa: 55, spd: 80, spe: 48 },
    skills: ['389', '283', '3', '33', '396', '353', '143', '293', '278', '218', '144', '381', '136', '397', '146', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '15', '137', '87', '138', '139', '54', '196', '142', '109', '26', '369', '315', '189', '177', '209', '153', '91', '286', '50', '58', '285'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.129_怖须菇.png',
    traitName: '吸积盘',
    traitEffect: '回合结束时，敌方获得2层星陨印记。',
  },
  {
    id: '135',
    name: '怖哭菇',
    types: ['幻'],
    baseStats: { hp: 124, atk: 63, def: 50, spa: 69, spd: 100, spe: 60 },
    skills: ['389', '283', '3', '33', '396', '353', '143', '293', '278', '218', '144', '381', '136', '397', '146', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '15', '137', '87', '138', '139', '54', '196', '142', '109', '26', '369', '315', '189', '177', '209', '153', '91', '286', '50', '58', '285'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.130_怖哭菇.png',
    traitName: '吸积盘',
    traitEffect: '回合结束时，敌方获得2层星陨印记。',
  },
  {
    id: '136',
    name: '恶魔狼',
    types: ['恶'],
    baseStats: { hp: 115, atk: 114, def: 91, spa: 45, spd: 63, spe: 120 },
    skills: ['363', '66', '182', '7', '3', '196', '187', '244', '107', '111', '185', '247', '246', '20', '112', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '38', '202', '70', '277', '186', '83', '293', '42', '212', '85', '44', '97', '242', '52', '116'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.131_恶魔狼.png',
    traitName: '悲悯',
    traitEffect: '己方队伍中每有1只力竭的精灵，自己获得双攻+30%。',
  },
  {
    id: '137',
    name: '小电企鹅',
    types: ['冰', '电'],
    baseStats: { hp: 75, atk: 45, def: 59, spa: 101, spd: 87, spe: 100 },
    skills: ['398', '399', '192', '41', '3', '400', '401', '402', '403', '327', '404', '329', '384', '127', '128', '22', '333', '24', '131', '103', '133', '72', '135', '74', '104', '105', '136', '51', '35', '79', '139', '405', '214', '318', '332', '84', '406', '146', '170', '163', '299', '407', '114', '304', '4'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.132_小电企鹅.png',
    traitName: '超负荷',
    traitEffect: '攻击技能获得迸发：敌方获得全技能能耗+1。',
  },
  {
    id: '138',
    name: '电企鹅',
    types: ['冰', '电'],
    baseStats: { hp: 94, atk: 56, def: 73, spa: 126, spd: 109, spe: 125 },
    skills: ['398', '399', '192', '41', '3', '400', '401', '402', '403', '327', '404', '329', '384', '127', '128', '22', '333', '24', '131', '103', '133', '72', '135', '74', '104', '105', '136', '51', '35', '79', '139', '405', '214', '318', '332', '84', '406', '146', '170', '163', '299', '407', '114', '304', '4'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.133_电企鹅.png',
    traitName: '超负荷',
    traitEffect: '攻击技能获得迸发：敌方获得全技能能耗+1。',
  },
  {
    id: '139',
    name: '雪豆丁',
    types: ['冰'],
    baseStats: { hp: 97, atk: 104, def: 83, spa: 47, spd: 62, spe: 36 },
    skills: ['3', '408', '346', '196', '409', '387', '134', '410', '411', '140', '203', '412', '141', '127', '128', '22', '129', '174', '131', '132', '133', '13', '135', '94', '104', '105', '136', '137', '35', '120', '139', '343', '202', '7', '108', '214', '26', '212', '189', '177', '44', '242', '179', '181'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.134_雪豆丁.png',
    traitName: '打雪仗',
    traitEffect: '初始能量为0，入场前己方精灵每放1次冰系技能，回复3能量。',
  },
  {
    id: '140',
    name: '雪蛮人',
    types: ['冰'],
    baseStats: { hp: 130, atk: 139, def: 111, spa: 63, spd: 83, spe: 48 },
    skills: ['3', '408', '346', '196', '409', '387', '134', '410', '411', '140', '203', '412', '141', '127', '128', '22', '129', '174', '131', '132', '133', '13', '135', '94', '104', '105', '136', '137', '35', '120', '139', '343', '202', '7', '108', '214', '26', '212', '189', '177', '44', '242', '179', '181'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.135_雪蛮人.png',
    traitName: '打雪仗',
    traitEffect: '初始能量为0，入场前己方精灵每放1次冰系技能，回复3能量。',
  },
  {
    id: '141',
    name: '雪巨人',
    types: ['冰'],
    baseStats: { hp: 162, atk: 174, def: 139, spa: 79, spd: 104, spe: 60 },
    skills: ['3', '408', '346', '196', '409', '387', '134', '410', '411', '140', '203', '412', '141', '127', '128', '22', '129', '174', '131', '132', '133', '13', '135', '94', '104', '105', '136', '137', '35', '120', '139', '343', '202', '7', '108', '214', '26', '212', '189', '177', '44', '242', '179', '181'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.136_雪巨人.png',
    traitName: '打雪仗',
    traitEffect: '初始能量为0，入场前己方精灵每放1次冰系技能，回复3能量。',
  },
  {
    id: '142',
    name: '呼呼猪',
    types: ['冰', '地'],
    baseStats: { hp: 98, atk: 95, def: 88, spa: 33, spd: 81, spe: 68 },
    skills: ['387', '7', '410', '236', '3', '232', '346', '411', '221', '239', '226', '401', '203', '413', '1', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '70', '240', '109', '83', '270', '212', '257', '388', '146', '192', '242', '254', '222'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.137_呼呼猪.png',
    traitName: '冻土',
    traitEffect: '每携带1个冰系技能进入战斗，地系技能威力+10%。',
  },
  {
    id: '143',
    name: '獠牙猪',
    types: ['冰', '地'],
    baseStats: { hp: 123, atk: 119, def: 110, spa: 41, spd: 101, spe: 85 },
    skills: ['387', '7', '410', '236', '3', '232', '346', '411', '221', '239', '226', '401', '203', '413', '1', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '70', '240', '109', '83', '270', '212', '257', '388', '146', '192', '242', '254', '222'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.138_獠牙猪.png',
    traitName: '冻土',
    traitEffect: '每携带1个冰系技能进入战斗，地系技能威力+10%。',
  },
  {
    id: '144',
    name: '雪娃娃',
    types: ['冰'],
    baseStats: { hp: 56, atk: 67, def: 63, spa: 67, spd: 63, spe: 69 },
    skills: ['3', '408', '346', '149', '262', '387', '404', '134', '217', '192', '402', '383', '147', '414', '415', '388', '54', '66', '22', '67', '68', '69', '103', '56', '13', '73', '74', '75', '76', '77', '78', '86', '79', '80', '370', '38', '140', '70', '210', '381', '315', '183', '84', '261', '371', '44', '211', '153', '416', '242'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.139_雪娃娃.png',
    traitName: '冰封',
    traitEffect: '在场时，敌方全技能能耗+1。',
  },
  {
    id: '145',
    name: '冰封怨灵',
    types: ['冰'],
    baseStats: { hp: 75, atk: 90, def: 84, spa: 90, spd: 84, spe: 92 },
    skills: ['3', '408', '346', '149', '262', '387', '404', '134', '217', '192', '402', '383', '147', '414', '415', '388', '54', '66', '22', '67', '68', '69', '103', '56', '13', '73', '74', '75', '76', '77', '78', '86', '79', '80', '370', '38', '140', '70', '210', '381', '315', '183', '84', '261', '371', '44', '211', '153', '416', '242'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.140_冰封怨灵.png',
    traitName: '冰封',
    traitEffect: '在场时，敌方全技能能耗+1。',
  },
  {
    id: '146',
    name: '雪灵',
    types: ['冰'],
    baseStats: { hp: 94, atk: 112, def: 105, spa: 112, spd: 105, spe: 115 },
    skills: ['3', '408', '346', '149', '262', '387', '404', '134', '217', '192', '402', '383', '147', '414', '415', '388', '54', '66', '22', '67', '68', '69', '103', '56', '13', '73', '74', '75', '76', '77', '78', '86', '79', '80', '370', '38', '140', '70', '210', '381', '315', '183', '84', '261', '371', '44', '211', '153', '416', '242'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.141_雪灵.png',
    traitName: '冰封',
    traitEffect: '在场时，敌方全技能能耗+1。',
  },
  {
    id: '147',
    name: '大耳帽兜',
    types: ['冰', '萌'],
    baseStats: { hp: 78, atk: 62, def: 39, spa: 59, spd: 78, spe: 54 },
    skills: ['3', '398', '72', '293', '76', '254', '404', '140', '410', '252', '319', '415', '411', '405', '263', '417', '20', '66', '22', '67', '68', '69', '70', '56', '13', '73', '74', '75', '259', '77', '78', '86', '79', '80', '370', '38', '383', '28', '350', '7', '166', '374', '39', '83', '177', '371', '256', '388', '418', '409'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.142_大耳帽兜.png',
    traitName: '捉迷藏',
    traitEffect: '使敌方获得冻结时，也会使其获得全技能能耗+1。',
  },
  {
    id: '148',
    name: '帽兜娃娃',
    types: ['冰', '萌'],
    baseStats: { hp: 104, atk: 83, def: 52, spa: 78, spd: 104, spe: 72 },
    skills: ['3', '398', '72', '293', '76', '254', '404', '140', '410', '252', '319', '415', '411', '405', '263', '417', '20', '66', '22', '67', '68', '69', '70', '56', '13', '73', '74', '75', '259', '77', '78', '86', '79', '80', '370', '38', '383', '28', '350', '7', '166', '374', '39', '83', '177', '371', '256', '388', '418', '409'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.143_帽兜娃娃.png',
    traitName: '捉迷藏',
    traitEffect: '使敌方获得冻结时，也会使其获得全技能能耗+1。',
  },
  {
    id: '149',
    name: '雪影娃娃',
    types: ['冰', '萌'],
    baseStats: { hp: 130, atk: 103, def: 66, spa: 98, spd: 130, spe: 90 },
    skills: ['3', '398', '72', '293', '76', '254', '404', '140', '410', '252', '319', '415', '411', '405', '263', '417', '20', '66', '22', '67', '68', '69', '70', '56', '13', '73', '74', '75', '259', '77', '78', '86', '79', '80', '370', '38', '383', '28', '350', '7', '166', '374', '39', '83', '177', '371', '256', '388', '418', '409'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.144_雪影娃娃.png',
    traitName: '捉迷藏',
    traitEffect: '使敌方获得冻结时，也会使其获得全技能能耗+1。',
  },
  {
    id: '150',
    name: '权杖-Ⅱ',
    types: ['机械'],
    baseStats: { hp: 82, atk: 84, def: 109, spa: 78, spd: 109, spe: 60 },
    skills: ['3', '31', '406', '104', '4', '419', '85', '177', '420', '75', '166', '234', '270', '165', '313', '421', '54', '66', '22', '67', '68', '69', '70', '56', '72', '73', '94', '407', '76', '77', '78', '86', '79', '80', '383', '411', '13', '210', '109', '26', '83', '315', '183', '422', '84', '44', '388', '95', '423', '346'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.145_权杖-Ⅱ.png',
    traitName: '机械变式',
    traitEffect: '自己携带的技能每回合位置变化时，该技能能耗-1。',
  },
  {
    id: '151',
    name: '权杖-Ⅴ',
    types: ['机械'],
    baseStats: { hp: 103, atk: 105, def: 136, spa: 97, spd: 136, spe: 75 },
    skills: ['3', '31', '406', '104', '4', '419', '85', '177', '420', '75', '166', '234', '270', '165', '313', '421', '54', '66', '22', '67', '68', '69', '70', '56', '72', '73', '94', '407', '76', '77', '78', '86', '79', '80', '383', '411', '13', '210', '109', '26', '83', '315', '183', '422', '84', '44', '388', '95', '423', '346'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.146_权杖-Ⅴ.png',
    traitName: '机械变式',
    traitEffect: '自己携带的技能每回合位置变化时，该技能能耗-1。',
  },
  {
    id: '152',
    name: '灵狐',
    types: ['火', '冰'],
    baseStats: { hp: 69, atk: 52, def: 50, spa: 52, spd: 64, spe: 60 },
    skills: ['28', '72', '3', '312', '294', '97', '424', '131', '410', '415', '422', '405', '311', '101', '425', '20', '66', '22', '67', '68', '6', '70', '56', '13', '73', '74', '75', '76', '77', '78', '86', '79', '80', '370', '140', '166', '374', '109', '144', '426', '83', '69', '261', '371', '85', '151', '147', '427', '295', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.147_灵狐.png',
    traitName: '灵魂灼伤',
    traitEffect: '冰系技能使敌方获得4层灼烧，火系技能使敌方获得2层冻结。',
  },
  {
    id: '153',
    name: '九尾狐',
    types: ['火', '冰'],
    baseStats: { hp: 92, atk: 70, def: 67, spa: 70, spd: 86, spe: 80 },
    skills: ['28', '72', '3', '312', '294', '97', '424', '131', '410', '415', '422', '405', '311', '101', '425', '20', '66', '22', '67', '68', '6', '70', '56', '13', '73', '74', '75', '76', '77', '78', '86', '79', '80', '370', '140', '166', '374', '109', '144', '426', '83', '69', '261', '371', '85', '151', '147', '427', '295', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.148_九尾狐.png',
    traitName: '灵魂灼伤',
    traitEffect: '冰系技能使敌方获得4层灼烧，火系技能使敌方获得2层冻结。',
  },
  {
    id: '154',
    name: '尖嘴狐仙',
    types: ['火', '冰'],
    baseStats: { hp: 115, atk: 87, def: 84, spa: 87, spd: 107, spe: 100 },
    skills: ['28', '72', '3', '312', '294', '97', '424', '131', '410', '415', '422', '405', '311', '101', '425', '20', '66', '22', '67', '68', '6', '70', '56', '13', '73', '74', '75', '76', '77', '78', '86', '79', '80', '370', '140', '166', '374', '109', '144', '426', '83', '69', '261', '371', '85', '151', '147', '427', '295', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.149_尖嘴狐仙.png',
    traitName: '灵魂灼伤',
    traitEffect: '冰系技能使敌方获得4层灼烧，火系技能使敌方获得2层冻结。',
  },
  {
    id: '155',
    name: '里奥',
    types: ['翼'],
    baseStats: { hp: 79, atk: 65, def: 77, spa: 65, spd: 50, spe: 75 },
    skills: ['428', '4', '195', '3', '206', '152', '110', '7', '167', '376', '171', '80', '169', '198', '200', '117', '118', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '15', '34', '35', '36', '115', '156', '245', '38', '320', '82', '155', '44', '204', '205', '121', '365', '153', '79', '276', '197', '114', '429', '430'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.150_里奥.png',
    traitName: '飓风',
    traitEffect: '对本精灵的技能，若其他翼系精灵携带相同技能，则获得迅捷。被敌方精灵击败时，自己额外损失1点魔力。',
  },
  {
    id: '156',
    name: '灵羽勇士',
    types: ['翼'],
    baseStats: { hp: 105, atk: 87, def: 102, spa: 87, spd: 66, spe: 100 },
    skills: ['428', '4', '195', '3', '206', '152', '110', '7', '167', '376', '171', '80', '169', '198', '200', '117', '118', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '15', '34', '35', '36', '115', '156', '245', '38', '320', '82', '155', '44', '204', '205', '121', '365', '153', '79', '276', '197', '114', '429', '430'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.151_灵羽勇士.png',
    traitName: '飓风',
    traitEffect: '对本精灵的技能，若其他翼系精灵携带相同技能，则获得迅捷。被敌方精灵击败时，自己额外损失1点魔力。',
  },
  {
    id: '157',
    name: '圣羽翼王',
    types: ['翼'],
    baseStats: { hp: 132, atk: 109, def: 128, spa: 109, spd: 83, spe: 125 },
    skills: ['428', '4', '195', '3', '206', '152', '110', '7', '167', '376', '171', '80', '169', '198', '200', '117', '118', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '15', '34', '35', '36', '115', '156', '245', '38', '320', '82', '155', '44', '204', '205', '121', '365', '153', '79', '276', '197', '114', '429', '430'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.152_圣羽翼王.png',
    traitName: '飓风',
    traitEffect: '对本精灵的技能，若其他翼系精灵携带相同技能，则获得迅捷。被敌方精灵击败时，自己额外损失1点魔力。',
  },
  {
    id: '158',
    name: '松仔',
    types: ['草', '武'],
    baseStats: { hp: 63, atk: 83, def: 77, spa: 34, spd: 60, spe: 63 },
    skills: ['267', '7', '24', '50', '3', '196', '268', '159', '431', '324', '285', '302', '60', '43', '118', '21', '22', '23', '174', '25', '26', '27', '28', '29', '74', '31', '32', '33', '51', '35', '36', '37', '38', '202', '64', '68', '232', '155', '432', '182', '433', '85', '89', '345', '223', '222'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.153_松仔.png',
    traitName: '野性感官',
    traitEffect: '应对成功后，下次行动先手+1。',
  },
  {
    id: '159',
    name: '松叶羊',
    types: ['草', '武'],
    baseStats: { hp: 84, atk: 111, def: 102, spa: 46, spd: 80, spe: 84 },
    skills: ['267', '7', '24', '50', '3', '196', '268', '159', '431', '324', '285', '302', '60', '43', '118', '21', '22', '23', '174', '25', '26', '27', '28', '29', '74', '31', '32', '33', '51', '35', '36', '37', '38', '202', '64', '68', '232', '155', '432', '182', '433', '85', '89', '345', '223', '222'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.154_松叶羊.png',
    traitName: '野性感官',
    traitEffect: '应对成功后，下次行动先手+1。',
  },
  {
    id: '160',
    name: '针叶巡林',
    types: ['草', '武'],
    baseStats: { hp: 105, atk: 139, def: 128, spa: 57, spd: 100, spe: 105 },
    skills: ['267', '7', '24', '50', '3', '196', '268', '159', '431', '324', '285', '302', '60', '43', '118', '21', '22', '23', '174', '25', '26', '27', '28', '29', '74', '31', '32', '33', '51', '35', '36', '37', '38', '202', '64', '68', '232', '155', '432', '182', '433', '85', '89', '345', '223', '222'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.155_针叶巡林.png',
    traitName: '野性感官',
    traitEffect: '应对成功后，下次行动先手+1。',
  },
  {
    id: '161',
    name: '小勇狮',
    types: ['火', '武'],
    baseStats: { hp: 82, atk: 31, def: 53, spa: 66, spd: 78, spe: 48 },
    skills: ['3', '168', '295', '48', '4', '434', '99', '42', '341', '435', '176', '425', '436', '127', '128', '22', '129', '174', '6', '132', '133', '134', '135', '94', '104', '105', '136', '51', '35', '120', '139', '157', '392', '38', '68', '143', '82', '69', '44', '437', '438', '218', '282', '179', '439', '114', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.156_小勇狮.png',
    traitName: '圣火骑士',
    traitEffect: '应对成功后，下次攻击威力翻倍。',
  },
  {
    id: '162',
    name: '炽焰狮',
    types: ['火', '武'],
    baseStats: { hp: 110, atk: 41, def: 70, spa: 89, spd: 104, spe: 64 },
    skills: ['3', '168', '295', '48', '4', '434', '99', '42', '341', '435', '176', '425', '436', '127', '128', '22', '129', '174', '6', '132', '133', '134', '135', '94', '104', '105', '136', '51', '35', '120', '139', '157', '392', '38', '68', '143', '82', '69', '44', '437', '438', '218', '282', '179', '439', '114', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.157_炽焰狮.png',
    traitName: '圣火骑士',
    traitEffect: '应对成功后，下次攻击威力翻倍。',
  },
  {
    id: '163',
    name: '炽心勇狮',
    types: ['火', '武'],
    baseStats: { hp: 137, atk: 51, def: 88, spa: 111, spd: 130, spe: 80 },
    skills: ['3', '168', '295', '48', '4', '434', '99', '42', '341', '435', '176', '425', '436', '127', '128', '22', '129', '174', '6', '132', '133', '134', '135', '94', '104', '105', '136', '51', '35', '120', '139', '157', '392', '38', '68', '143', '82', '69', '44', '437', '438', '218', '282', '179', '439', '114', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.158_炽心勇狮.png',
    traitName: '圣火骑士',
    traitEffect: '应对成功后，下次攻击威力翻倍。',
  },
  {
    id: '164',
    name: '水滴蛇',
    types: ['水', '武'],
    baseStats: { hp: 63, atk: 66, def: 62, spa: 62, spd: 62, spe: 63 },
    skills: ['7', '9', '302', '3', '68', '205', '440', '176', '159', '348', '257', '325', '124', '125', '436', '54', '66', '22', '67', '174', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '86', '138', '80', '343', '38', '143', '186', '315', '183', '84', '85', '145', '123', '47', '347', '151', '181', '4', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.159_水滴蛇.png',
    traitName: '思维之盾',
    traitEffect: '应对成功后，下次行动技能能耗-5。',
  },
  {
    id: '165',
    name: '水蛇锁',
    types: ['水', '武'],
    baseStats: { hp: 84, atk: 88, def: 83, spa: 83, spd: 83, spe: 84 },
    skills: ['7', '9', '302', '3', '68', '205', '440', '176', '159', '348', '257', '325', '124', '125', '436', '54', '66', '22', '67', '174', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '86', '138', '80', '343', '38', '143', '186', '315', '183', '84', '85', '145', '123', '47', '347', '151', '181', '4', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.160_水蛇锁.png',
    traitName: '思维之盾',
    traitEffect: '应对成功后，下次行动技能能耗-5。',
  },
  {
    id: '166',
    name: '游蛇魔使',
    types: ['水', '武'],
    baseStats: { hp: 105, atk: 110, def: 103, spa: 104, spd: 103, spe: 105 },
    skills: ['7', '9', '302', '3', '68', '205', '440', '176', '159', '348', '257', '325', '124', '125', '436', '54', '66', '22', '67', '174', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '86', '138', '80', '343', '38', '143', '186', '315', '183', '84', '85', '145', '123', '47', '347', '151', '181', '4', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.161_游蛇魔使.png',
    traitName: '思维之盾',
    traitEffect: '应对成功后，下次行动技能能耗-5。',
  },
  {
    id: '167',
    name: '公平鸽',
    types: ['普通'],
    baseStats: { hp: 113, atk: 93, def: 125, spa: 93, spd: 125, spe: 100 },
    skills: ['118', '38', '3', '196', '4', '288', '152', '127', '318', '7', '277', '234', '113', '164', '84', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '86', '138', '80', '157', '130', '143', '83', '302', '155', '159', '441', '339', '168', '153', '160', '90', '442', '264', '116'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.162_公平鸽.png',
    traitName: '衡量',
    traitEffect: '入场时，复制敌方的增益。在场时，若敌方获得增益自己也会获得。',
  },
  {
    id: '168',
    name: '小怂猫',
    types: ['武'],
    baseStats: { hp: 74, atk: 106, def: 89, spa: 101, spd: 76, spe: 76 },
    skills: ['168', '166', '3', '24', '68', '196', '165', '343', '159', '176', '84', '433', '432', '95', '342', '118', '21', '22', '23', '174', '25', '26', '27', '28', '29', '74', '31', '32', '33', '34', '35', '36', '37', '157', '38', '337', '202', '7', '232', '319', '44', '220', '153', '223', '50', '254', '222', '113', '279', '285'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.163_小怂猫.png',
    traitName: '威慑',
    traitEffect: '打断敌方时，被打断的技能进入2回合冷却。',
  },
  {
    id: '169',
    name: '怒目怂猫',
    types: ['武'],
    baseStats: { hp: 92, atk: 132, def: 111, spa: 126, spd: 95, spe: 95 },
    skills: ['168', '166', '3', '24', '68', '196', '165', '343', '159', '176', '84', '433', '432', '95', '342', '118', '21', '22', '23', '174', '25', '26', '27', '28', '29', '74', '31', '32', '33', '34', '35', '36', '37', '157', '38', '337', '202', '7', '232', '319', '44', '220', '153', '223', '50', '254', '222', '113', '279', '285'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.164_怒目怂猫.png',
    traitName: '威慑',
    traitEffect: '打断敌方时，被打断的技能进入2回合冷却。',
  },
  {
    id: '170',
    name: '小狮鹫（崖间地的样子）',
    types: ['翼'],
    baseStats: { hp: 61, atk: 69, def: 64, spa: 39, spd: 33, spe: 72 },
    skills: ['195', '161', '206', '106', '3', '151', '80', '110', '156', '197', '155', '200', '117', '1', '21', '22', '23', '130', '25', '103', '27', '13', '29', '30', '104', '105', '33', '51', '87', '36', '115', '245', '337', '202', '320', '68', '443', '109', '159', '44', '12', '153', '24', '276', '113'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.165_小狮鹫（崖间地的样子）.png',
    traitName: '乘风连击',
    traitEffect: '使用翼系技能后，获得连击数+1。',
  },
  {
    id: '171',
    name: '神圣狮鹫（崖间地的样子）',
    types: ['翼'],
    baseStats: { hp: 82, atk: 92, def: 86, spa: 51, spd: 44, spe: 96 },
    skills: ['195', '161', '206', '106', '3', '151', '80', '110', '156', '197', '155', '200', '117', '1', '21', '22', '23', '130', '25', '103', '27', '13', '29', '30', '104', '105', '33', '51', '87', '36', '115', '245', '337', '202', '320', '68', '443', '109', '159', '44', '12', '153', '24', '276', '113'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.166_神圣狮鹫（崖间地的样子）.png',
    traitName: '乘风连击',
    traitEffect: '使用翼系技能后，获得连击数+1。',
  },
  {
    id: '172',
    name: '皇家狮鹫（崖间地的样子）',
    types: ['翼'],
    baseStats: { hp: 102, atk: 116, def: 107, spa: 64, spd: 55, spe: 120 },
    skills: ['195', '161', '206', '106', '3', '151', '80', '110', '156', '197', '155', '200', '117', '1', '21', '22', '23', '130', '25', '103', '27', '13', '29', '30', '104', '105', '33', '51', '87', '36', '115', '245', '337', '202', '320', '68', '443', '109', '159', '44', '12', '153', '24', '276', '113'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.167_皇家狮鹫（崖间地的样子）.png',
    traitName: '乘风连击',
    traitEffect: '使用翼系技能后，获得连击数+1。',
  },
  {
    id: '173',
    name: '圆眼蜘蛛',
    types: ['虫'],
    baseStats: { hp: 55, atk: 37, def: 55, spa: 37, spd: 55, spe: 66 },
    skills: ['357', '249', '248', '306', '377', '7', '393', '386', '305', '308', '273', '93', '394', '310', '290', '118', '21', '22', '23', '24', '25', '103', '27', '28', '258', '74', '31', '32', '33', '34', '87', '36', '37', '210', '109', '26', '83', '155', '212', '338', '319', '85', '262', '105', '251', '359', '322', '276', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.168_圆眼蜘蛛.png',
    traitName: '毒腺',
    traitEffect: '使用能耗小于等于1的技能时，敌方获得4层中毒。',
  },
  {
    id: '174',
    name: '尖角蜘蛛',
    types: ['虫', '毒'],
    baseStats: { hp: 74, atk: 49, def: 73, spa: 49, spd: 73, spe: 88 },
    skills: ['357', '249', '248', '306', '377', '7', '393', '386', '305', '308', '273', '93', '394', '310', '290', '118', '21', '22', '23', '24', '25', '103', '27', '28', '258', '74', '31', '32', '33', '34', '87', '36', '37', '210', '109', '26', '83', '155', '212', '338', '319', '85', '262', '105', '251', '359', '322', '276', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.169_尖角蜘蛛.png',
    traitName: '毒腺',
    traitEffect: '使用能耗小于等于1的技能时，敌方获得4层中毒。',
  },
  {
    id: '175',
    name: '芋香巨角蛛',
    types: ['虫', '毒'],
    baseStats: { hp: 92, atk: 61, def: 91, spa: 61, spd: 91, spe: 110 },
    skills: ['357', '249', '248', '306', '377', '7', '393', '386', '305', '308', '273', '93', '394', '310', '290', '118', '21', '22', '23', '24', '25', '103', '27', '28', '258', '74', '31', '32', '33', '34', '87', '36', '37', '210', '109', '26', '83', '155', '212', '338', '319', '85', '262', '105', '251', '359', '322', '276', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.170_芋香巨角蛛.png',
    traitName: '毒腺',
    traitEffect: '使用能耗小于等于1的技能时，敌方获得4层中毒。',
  },
  {
    id: '176',
    name: '波波螺',
    types: ['地', '水'],
    baseStats: { hp: 67, atk: 59, def: 87, spa: 59, spd: 66, spe: 42 },
    skills: ['3', '36', '79', '14', '241', '9', '224', '45', '154', '120', '225', '228', '173', '372', '229', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '51', '35', '138', '175', '230', '214', '143', '257', '177', '104', '234', '172', '204', '237', '218', '275', '303', '264', '227', '407'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.171_波波螺.png',
    traitName: '消波块',
    traitEffect: '每携带1个水系技能进入战斗，地系技能能耗-1。',
  },
  {
    id: '177',
    name: '消波螺',
    types: ['地', '水'],
    baseStats: { hp: 89, atk: 78, def: 116, spa: 78, spd: 88, spe: 56 },
    skills: ['3', '36', '79', '14', '241', '9', '224', '45', '154', '120', '225', '228', '173', '372', '229', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '51', '35', '138', '175', '230', '214', '143', '257', '177', '104', '234', '172', '204', '237', '218', '275', '303', '264', '227', '407'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.172_消波螺.png',
    traitName: '消波块',
    traitEffect: '每携带1个水系技能进入战斗，地系技能能耗-1。',
  },
  {
    id: '178',
    name: '嗜波螺',
    types: ['地', '水'],
    baseStats: { hp: 112, atk: 98, def: 146, spa: 98, spd: 110, spe: 70 },
    skills: ['3', '36', '79', '14', '241', '9', '224', '45', '154', '120', '225', '228', '173', '372', '229', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '51', '35', '138', '175', '230', '214', '143', '257', '177', '104', '234', '172', '204', '237', '218', '275', '303', '264', '227', '407'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.173_嗜波螺.png',
    traitName: '消波块',
    traitEffect: '每携带1个水系技能进入战斗，地系技能能耗-1。',
  },
  {
    id: '179',
    name: '菇菇丁',
    types: ['地', '草'],
    baseStats: { hp: 89, atk: 61, def: 70, spa: 57, spd: 57, spe: 42 },
    skills: ['14', '3', '56', '8', '133', '225', '221', '137', '50', '89', '382', '193', '148', '287', '62', '20', '66', '22', '67', '68', '69', '103', '71', '72', '73', '74', '75', '76', '77', '51', '35', '79', '80', '81', '166', '289', '109', '188', '83', '372', '85', '86', '309', '241', '78', '153', '219', '222', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.174_菇菇丁.png',
    traitName: '多人宿舍',
    traitEffect: '自己的能量可以超过能量上限。',
  },
  {
    id: '180',
    name: '多菇丁',
    types: ['地', '草'],
    baseStats: { hp: 119, atk: 81, def: 93, spa: 76, spd: 76, spe: 56 },
    skills: ['14', '3', '56', '8', '133', '225', '221', '137', '50', '89', '382', '193', '148', '287', '62', '20', '66', '22', '67', '68', '69', '103', '71', '72', '73', '74', '75', '76', '77', '51', '35', '79', '80', '81', '166', '289', '109', '188', '83', '372', '85', '86', '309', '241', '78', '153', '219', '222', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.175_多菇丁.png',
    traitName: '多人宿舍',
    traitEffect: '自己的能量可以超过能量上限。',
  },
  {
    id: '181',
    name: '九幽菇',
    types: ['地', '草'],
    baseStats: { hp: 149, atk: 102, def: 116, spa: 95, spd: 95, spe: 70 },
    skills: ['14', '3', '56', '8', '133', '225', '221', '137', '50', '89', '382', '193', '148', '287', '62', '20', '66', '22', '67', '68', '69', '103', '71', '72', '73', '74', '75', '76', '77', '51', '35', '79', '80', '81', '166', '289', '109', '188', '83', '372', '85', '86', '309', '241', '78', '153', '219', '222', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.176_九幽菇.png',
    traitName: '多人宿舍',
    traitEffect: '自己的能量可以超过能量上限。',
  },
  {
    id: '182',
    name: '斑斑',
    types: ['翼'],
    baseStats: { hp: 71, atk: 90, def: 71, spa: 90, spd: 80, spe: 92 },
    skills: ['4', '265', '3', '196', '7', '206', '161', '167', '106', '110', '198', '199', '155', '200', '117', '118', '112', '22', '23', '24', '25', '26', '27', '28', '29', '74', '31', '32', '33', '34', '35', '36', '115', '337', '70', '271', '130', '109', '315', '212', '272', '84', '191', '168', '153', '242', '298', '366', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.177_斑斑.png',
    traitName: '逐魂鸟',
    traitEffect: '能耗小于等于1的攻击技能，无法对自己造成伤害。',
  },
  {
    id: '183',
    name: '斑枭',
    types: ['翼'],
    baseStats: { hp: 89, atk: 112, def: 89, spa: 112, spd: 100, spe: 115 },
    skills: ['4', '265', '3', '196', '7', '206', '161', '167', '106', '110', '198', '199', '155', '200', '117', '118', '112', '22', '23', '24', '25', '26', '27', '28', '29', '74', '31', '32', '33', '34', '35', '36', '115', '337', '70', '271', '130', '109', '315', '212', '272', '84', '191', '168', '153', '242', '298', '366', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.178_斑枭.png',
    traitName: '逐魂鸟',
    traitEffect: '能耗小于等于1的攻击技能，无法对自己造成伤害。',
  },
  {
    id: '184',
    name: '草头鸭',
    types: ['草'],
    baseStats: { hp: 92, atk: 79, def: 66, spa: 24, spd: 50, spe: 92 },
    skills: ['267', '268', '444', '7', '285', '153', '50', '60', '196', '324', '344', '343', '431', '43', '20', '21', '22', '23', '174', '25', '103', '71', '13', '29', '94', '104', '105', '33', '51', '87', '138', '115', '202', '214', '83', '341', '433', '85', '44', '204', '206', '125', '79', '151', '276', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.179_草头鸭.png',
    traitName: '得寸进尺',
    traitEffect: '天气为雨天，或处于其他水系环境中时，获得双攻+100%。',
  },
  {
    id: '185',
    name: '卷毛鸭',
    types: ['草', '武'],
    baseStats: { hp: 116, atk: 98, def: 83, spa: 29, spd: 63, spe: 115 },
    skills: ['267', '268', '444', '7', '285', '153', '50', '60', '196', '324', '344', '343', '431', '43', '20', '21', '22', '23', '174', '25', '103', '71', '13', '29', '94', '104', '105', '33', '51', '87', '138', '115', '202', '214', '83', '341', '433', '85', '44', '204', '206', '125', '79', '151', '276', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.180_卷毛鸭.png',
    traitName: '得寸进尺',
    traitEffect: '天气为雨天，或处于其他水系环境中时，获得双攻+100%。',
  },
  {
    id: '186',
    name: '海豹战士',
    types: ['武', '水'],
    baseStats: { hp: 72, atk: 91, def: 89, spa: 87, spd: 62, spe: 80 },
    skills: ['168', '4', '120', '36', '79', '196', '7', '179', '45', '68', '205', '436', '343', '341', '204', '127', '128', '22', '129', '174', '131', '132', '133', '28', '135', '74', '31', '32', '136', '137', '35', '138', '139', '387', '392', '140', '13', '130', '214', '176', '289', '44', '145', '173', '123', '153', '178', '3', '134'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.181_海豹战士.png',
    traitName: '身经百练',
    traitEffect: '己方精灵每应对1次，自己入场时水系和武系技能威力+20%。',
  },
  {
    id: '187',
    name: '海豹船长',
    types: ['武', '水'],
    baseStats: { hp: 90, atk: 113, def: 111, spa: 109, spd: 77, spe: 100 },
    skills: ['168', '4', '120', '36', '79', '196', '7', '179', '45', '68', '205', '436', '343', '341', '204', '127', '128', '22', '129', '174', '131', '132', '133', '28', '135', '74', '31', '32', '136', '137', '35', '138', '139', '387', '392', '140', '13', '130', '214', '176', '289', '44', '145', '173', '123', '153', '178', '3', '134'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.182_海豹船长.png',
    traitName: '身经百练',
    traitEffect: '己方精灵每应对1次，自己入场时水系和武系技能威力+20%。',
  },
  {
    id: '188',
    name: '号儿鱼',
    types: ['水'],
    baseStats: { hp: 109, atk: 27, def: 76, spa: 76, spd: 88, spe: 84 },
    skills: ['262', '119', '3', '170', '122', '163', '348', '123', '121', '47', '124', '125', '347', '54', '66', '22', '67', '68', '69', '207', '56', '72', '73', '74', '75', '76', '77', '78', '86', '138', '80', '445', '70', '214', '210', '155', '315', '183', '261', '406', '234', '103', '90', '4'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.183_号儿鱼.png',
    traitName: '泛音列',
    traitEffect: '使用状态技能后，敌方获得【聒噪】技能的效果，持续3回合。',
  },
  {
    id: '189',
    name: '圆号鱼',
    types: ['水'],
    baseStats: { hp: 136, atk: 34, def: 95, spa: 95, spd: 110, spe: 105 },
    skills: ['262', '119', '3', '170', '122', '163', '348', '123', '121', '47', '124', '125', '347', '54', '66', '22', '67', '68', '69', '207', '56', '72', '73', '74', '75', '76', '77', '78', '86', '138', '80', '445', '70', '214', '210', '155', '315', '183', '261', '406', '234', '103', '90', '4'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.184_圆号鱼.png',
    traitName: '泛音列',
    traitEffect: '使用状态技能后，敌方获得【聒噪】技能的效果，持续3回合。',
  },
  {
    id: '190',
    name: '甜田螺',
    types: ['水', '萌'],
    baseStats: { hp: 68, atk: 61, def: 49, spa: 64, spd: 74, spe: 54 },
    skills: ['123', '36', '76', '170', '4', '9', '348', '173', '235', '125', '256', '233', '252', '335', '204', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '259', '15', '137', '35', '138', '139', '38', '7', '319', '177', '44', '145', '122', '124', '126', '153', '263', '146', '380', '379', '322', '3', '304'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.185_甜田螺.png',
    traitName: '守护者',
    traitEffect: '己方其他精灵每有1层萌化，自己入场时全技能能耗-1。',
  },
  {
    id: '191',
    name: '壳乙螺',
    types: ['水', '萌'],
    baseStats: { hp: 91, atk: 81, def: 66, spa: 86, spd: 99, spe: 72 },
    skills: ['123', '36', '76', '170', '4', '9', '348', '173', '235', '125', '256', '233', '252', '335', '204', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '259', '15', '137', '35', '138', '139', '38', '7', '319', '177', '44', '145', '122', '124', '126', '153', '263', '146', '380', '379', '322', '3', '304'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.186_壳乙螺.png',
    traitName: '守护者',
    traitEffect: '己方其他精灵每有1层萌化，自己入场时全技能能耗-1。',
  },
  {
    id: '192',
    name: '卡洛儿',
    types: ['水', '萌'],
    baseStats: { hp: 114, atk: 102, def: 82, spa: 107, spd: 124, spe: 90 },
    skills: ['123', '36', '76', '170', '4', '9', '348', '173', '235', '125', '256', '233', '252', '335', '204', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '259', '15', '137', '35', '138', '139', '38', '7', '319', '177', '44', '145', '122', '124', '126', '153', '263', '146', '380', '379', '322', '3', '304'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.187_卡洛儿.png',
    traitName: '守护者',
    traitEffect: '己方其他精灵每有1层萌化，自己入场时全技能能耗-1。',
  },
  {
    id: '193',
    name: '棋棋（白子）',
    types: ['武', '地'],
    baseStats: { hp: 72, atk: 100, def: 70, spa: 36, spd: 56, spe: 100 },
    skills: ['301', '4', '3', '168', '24', '7', '51', '68', '1', '302', '118', '21', '22', '23', '174', '25', '26', '27', '28', '29', '74', '31', '32', '33', '34', '35', '36', '37', '38', '196', '55', '85', '278', '321'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.188_棋棋（白子）.png',
    traitName: '腾挪',
    traitEffect: '攻击技能应对1次后，回满状态，变为棋绮后。',
  },
  {
    id: '194',
    name: '棋骑士（白子）',
    types: ['武', '地'],
    baseStats: { hp: 90, atk: 126, def: 88, spa: 45, spd: 69, spe: 125 },
    skills: ['301', '4', '3', '168', '24', '7', '51', '68', '1', '302', '222', '159', '382', '339', '160', '228', '432', '232', '20', '21', '22', '23', '174', '25', '103', '27', '13', '29', '30', '407', '105', '33', '34', '87', '36', '115', '445', '38', '337', '196', '18', '229', '155', '431', '85', '12', '153', '221', '278', '276', '321', '94'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.189_棋骑士（白子）.png',
    traitName: '腾挪',
    traitEffect: '攻击技能应对1次后，回满状态，变为棋绮后。',
  },
  {
    id: '195',
    name: '棋齐垒（白子）',
    types: ['武', '地'],
    baseStats: { hp: 89, atk: 94, def: 116, spa: 38, spd: 77, spe: 75 },
    skills: ['301', '4', '3', '168', '24', '7', '51', '68', '1', '302', '231', '221', '382', '339', '178', '343', '341', '127', '128', '22', '129', '174', '131', '132', '133', '134', '135', '30', '104', '105', '136', '34', '35', '120', '175', '38', '196', '142', '436', '238', '228', '85', '44', '153', '224', '278', '276', '321', '94', '282', '179'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.190_棋齐垒（白子）.png',
    traitName: '保卫',
    traitEffect: '防御技能应对2次后，回满状态，变为棋绮后。',
  },
  {
    id: '196',
    name: '棋祈督（白子）',
    types: ['武', '地'],
    baseStats: { hp: 126, atk: 87, def: 90, spa: 87, spd: 72, spe: 85 },
    skills: ['301', '4', '3', '168', '24', '7', '51', '68', '1', '302', '222', '221', '225', '159', '237', '236', '160', '54', '66', '22', '67', '174', '69', '70', '56', '72', '73', '74', '75', '76', '77', '34', '86', '79', '80', '38', '196', '130', '176', '436', '82', '228', '16', '85', '241', '78', '287', '12', '153', '278', '321', '94', '179', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.191_棋祈督（白子）.png',
    traitName: '好象坏象',
    traitEffect: '状态技能应对1次后，回满状态，变为棋绮后。',
  },
  {
    id: '197',
    name: '棋绮后（白子）',
    types: ['武', '地'],
    baseStats: { hp: 93, atk: 84, def: 82, spa: 84, spd: 75, spe: 90 },
    skills: ['301', '4', '3', '168', '24', '7', '51', '68', '1', '302', '222', '221', '225', '159', '237', '236', '160', '54', '66', '22', '67', '174', '69', '103', '56', '72', '73', '74', '75', '76', '77', '34', '86', '79', '80', '343', '38', '196', '176', '436', '82', '372', '84', '16', '85', '44', '339', '12', '153', '278', '321', '94', '179', '325', '382'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.192_棋绮后（白子）.png',
    traitName: '渗透',
    traitEffect: '己方精灵每使用1次武系或地系技能，自己入场时获得攻防+5%。',
  },
  {
    id: '198',
    name: '奔波鼠',
    types: ['地'],
    baseStats: { hp: 72, atk: 37, def: 67, spa: 93, spd: 90, spe: 92 },
    skills: ['3', '118', '281', '220', '4', '224', '14', '221', '238', '225', '146', '241', '231', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '94', '31', '105', '136', '51', '35', '120', '175', '337', '230', '214', '142', '327', '177', '379', '357', '255', '218', '399', '253', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.193_奔波鼠.png',
    traitName: '奔波命',
    traitEffect: '使用防御技能后，回合结束时脱离。',
  },
  {
    id: '199',
    name: '流浪鼠',
    types: ['地'],
    baseStats: { hp: 90, atk: 46, def: 84, spa: 116, spd: 112, spe: 115 },
    skills: ['3', '118', '281', '220', '4', '224', '14', '221', '238', '225', '146', '241', '231', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '94', '31', '105', '136', '51', '35', '120', '175', '337', '230', '214', '142', '327', '177', '379', '357', '255', '218', '399', '253', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.194_流浪鼠.png',
    traitName: '奔波命',
    traitEffect: '使用防御技能后，回合结束时脱离。',
  },
  {
    id: '200',
    name: '呆小路',
    types: ['草', '萌'],
    baseStats: { hp: 52, atk: 60, def: 68, spa: 64, spd: 79, spe: 57 },
    skills: ['3', '208', '336', '27', '350', '32', '286', '105', '61', '215', '64', '275', '60', '335', '65', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '259', '77', '78', '86', '79', '80', '156', '38', '155', '85', '46', '153', '252', '263', '91', '442', '193', '418', '127', '165', '116', '446'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.195_呆小路.png',
    traitName: '营养液泡',
    traitEffect: '获得增益时，额外获得层数+2。',
  },
  {
    id: '201',
    name: '舞动路路',
    types: ['草', '萌'],
    baseStats: { hp: 69, atk: 80, def: 91, spa: 86, spd: 105, spe: 76 },
    skills: ['3', '208', '336', '27', '350', '32', '286', '105', '61', '215', '64', '275', '60', '335', '65', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '259', '77', '78', '86', '79', '80', '156', '38', '155', '85', '46', '153', '252', '263', '91', '442', '193', '418', '127', '165', '116', '446'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.196_舞动路路.png',
    traitName: '营养液泡',
    traitEffect: '获得增益时，额外获得层数+2。',
  },
  {
    id: '202',
    name: '白发路路',
    types: ['草', '萌'],
    baseStats: { hp: 86, atk: 100, def: 113, spa: 107, spd: 132, spe: 95 },
    skills: ['3', '208', '336', '27', '350', '32', '286', '105', '61', '215', '64', '275', '60', '335', '65', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '259', '77', '78', '86', '79', '80', '156', '38', '155', '85', '46', '153', '252', '263', '91', '442', '193', '418', '127', '165', '116', '446'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.197_白发路路.png',
    traitName: '营养液泡',
    traitEffect: '获得增益时，额外获得层数+2。',
  },
  {
    id: '203',
    name: '逗逗',
    types: ['萌'],
    baseStats: { hp: 48, atk: 70, def: 68, spa: 64, spd: 68, spe: 66 },
    skills: ['3', '259', '336', '254', '76', '319', '260', '127', '263', '252', '335', '418', '264', '154', '83', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '32', '77', '78', '86', '79', '80', '157', '355', '350', '214', '176', '302', '159', '84', '339', '153', '331', '440', '24', '10', '299', '179'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.198_逗逗.png',
    traitName: '鼓气',
    traitEffect: '使用能耗为3的技能时，获得攻防+20%。',
  },
  {
    id: '204',
    name: '气球猫',
    types: ['萌'],
    baseStats: { hp: 64, atk: 93, def: 90, spa: 86, spd: 90, spe: 88 },
    skills: ['3', '259', '336', '254', '76', '319', '260', '127', '263', '252', '335', '418', '264', '154', '83', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '32', '77', '78', '86', '79', '80', '157', '355', '350', '214', '176', '302', '159', '84', '339', '153', '331', '440', '24', '10', '299', '179'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.199_气球猫.png',
    traitName: '鼓气',
    traitEffect: '使用能耗为3的技能时，获得攻防+20%。',
  },
  {
    id: '205',
    name: '梦想三三',
    types: ['萌'],
    baseStats: { hp: 81, atk: 117, def: 113, spa: 107, spd: 113, spe: 110 },
    skills: ['3', '259', '336', '254', '76', '319', '260', '127', '263', '252', '335', '418', '264', '154', '83', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '32', '77', '78', '86', '79', '80', '157', '355', '350', '214', '176', '302', '159', '84', '339', '153', '331', '440', '24', '10', '299', '179'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.200_梦想三三.png',
    traitName: '鼓气',
    traitEffect: '使用能耗为3的技能时，获得攻防+20%。',
  },
  {
    id: '206',
    name: '花怨鳗',
    types: ['地', '草'],
    baseStats: { hp: 232, atk: 73, def: 110, spa: 73, spd: 90, spe: 52 },
    skills: ['3', '266', '281', '447', '237', '27', '241', '137', '14', '236', '227', '275', '232', '58', '43', '127', '112', '22', '129', '130', '131', '132', '71', '134', '135', '74', '31', '32', '136', '51', '35', '120', '139', '38', '230', '57', '142', '143', '186', '318', '228', '315', '261', '234', '153', '91', '164', '50', '218'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.201_花怨鳗.png',
    traitName: '铃兰晚钟',
    traitEffect: '首次入场时，失去自己一半的当前生命。',
  },
  {
    id: '207',
    name: '鳗尾兽',
    types: ['地', '草'],
    baseStats: { hp: 290, atk: 91, def: 138, spa: 91, spd: 113, spe: 65 },
    skills: ['3', '266', '281', '447', '237', '27', '241', '137', '14', '236', '227', '275', '232', '58', '43', '127', '112', '22', '129', '130', '131', '132', '71', '134', '135', '74', '31', '32', '136', '51', '35', '120', '139', '38', '230', '57', '142', '143', '186', '318', '228', '315', '261', '234', '153', '91', '164', '50', '218'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.202_鳗尾兽.png',
    traitName: '铃兰晚钟',
    traitEffect: '首次入场时，失去自己一半的当前生命。',
  },
  {
    id: '208',
    name: '伊雷龙',
    types: ['龙'],
    baseStats: { hp: 90, atk: 73, def: 55, spa: 152, spd: 79, spe: 72 },
    skills: ['442', '4', '448', '3', '441', '22', '446', '349', '449', '450', '83', '451', '146', '118', '317', '429', '333', '174', '352', '103', '71', '28', '258', '74', '31', '32', '353', '51', '87', '170', '115', '214', '57', '39', '375', '332', '371', '46', '89', '416', '90', '10', '299', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.203_伊雷龙.png',
    traitName: '嫉妒',
    traitEffect: '蓄力状态下，可以使用任一携带技能。',
  },
  {
    id: '209',
    name: '伊兰龙',
    types: ['龙'],
    baseStats: { hp: 112, atk: 91, def: 69, spa: 190, spd: 99, spe: 90 },
    skills: ['442', '4', '448', '3', '441', '22', '446', '349', '449', '450', '83', '451', '146', '118', '317', '429', '333', '174', '352', '103', '71', '28', '258', '74', '31', '32', '353', '51', '87', '170', '115', '214', '57', '39', '375', '332', '371', '46', '89', '416', '90', '10', '299', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.204_伊兰龙.png',
    traitName: '嫉妒',
    traitEffect: '蓄力状态下，可以使用任一携带技能。',
  },
  {
    id: '210',
    name: '拉特',
    types: ['电'],
    baseStats: { hp: 67, atk: 80, def: 62, spa: 80, spd: 78, spe: 100 },
    skills: ['3', '23', '4', '399', '299', '10', '403', '49', '67', '452', '330', '356', '114', '332', '118', '21', '22', '333', '24', '25', '26', '27', '72', '29', '74', '31', '259', '33', '34', '35', '36', '37', '156', '245', '38', '7', '444', '302', '159', '168', '153', '76', '328', '160', '263', '357', '322', '254', '303'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.205_拉特.png',
    traitName: '噼啪！',
    traitEffect: '入场后首次行动，所选技能使用次数+1。',
  },
  {
    id: '211',
    name: '酷拉',
    types: ['电'],
    baseStats: { hp: 83, atk: 100, def: 78, spa: 100, spd: 97, spe: 125 },
    skills: ['3', '23', '4', '399', '299', '10', '403', '49', '67', '452', '330', '356', '114', '332', '118', '21', '22', '333', '24', '25', '26', '27', '72', '29', '74', '31', '259', '33', '34', '35', '36', '37', '156', '245', '38', '7', '444', '302', '159', '168', '153', '76', '328', '160', '263', '357', '322', '254', '303'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.206_酷拉.png',
    traitName: '噼啪！',
    traitEffect: '入场后首次行动，所选技能使用次数+1。',
  },
  {
    id: '212',
    name: '闪电环',
    types: ['电'],
    baseStats: { hp: 64, atk: 49, def: 51, spa: 49, spd: 50, spe: 72 },
    skills: ['261', '400', '3', '297', '85', '49', '328', '196', '403', '453', '454', '355', '67', '329', '114', '332', '118', '21', '22', '333', '24', '25', '26', '27', '72', '29', '74', '31', '32', '33', '34', '35', '36', '37', '337', '202', '405', '70', '214', '150', '315', '212', '272', '111', '191', '103', '90', '242', '366', '147', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.207_闪电环.png',
    traitName: '防过载保护',
    traitEffect: '每次行动后脱离。',
  },
  {
    id: '213',
    name: '刺电环',
    types: ['电'],
    baseStats: { hp: 85, atk: 65, def: 68, spa: 65, spd: 67, spe: 96 },
    skills: ['261', '400', '3', '297', '85', '49', '328', '196', '403', '453', '454', '355', '67', '329', '114', '332', '118', '21', '22', '333', '24', '25', '26', '27', '72', '29', '74', '31', '32', '33', '34', '35', '36', '37', '337', '202', '405', '70', '214', '150', '315', '212', '272', '111', '191', '103', '90', '242', '366', '147', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.208_刺电环.png',
    traitName: '防过载保护',
    traitEffect: '每次行动后脱离。',
  },
  {
    id: '214',
    name: '荆棘电环',
    types: ['电'],
    baseStats: { hp: 106, atk: 81, def: 85, spa: 81, spd: 84, spe: 120 },
    skills: ['261', '400', '3', '297', '85', '49', '328', '196', '403', '453', '454', '355', '67', '329', '114', '332', '118', '21', '22', '333', '24', '25', '26', '27', '72', '29', '74', '31', '32', '33', '34', '35', '36', '37', '337', '202', '405', '70', '214', '150', '315', '212', '272', '111', '191', '103', '90', '242', '366', '147', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.209_荆棘电环.png',
    traitName: '防过载保护',
    traitEffect: '每次行动后脱离。',
  },
  {
    id: '215',
    name: '小箱怪',
    types: ['机械', '幻'],
    baseStats: { hp: 111, atk: 103, def: 122, spa: 103, spd: 122, spe: 64 },
    skills: ['406', '455', '416', '31', '75', '33', '396', '3', '353', '445', '136', '419', '374', '171', '456', '397', '127', '128', '22', '129', '130', '131', '132', '133', '134', '258', '74', '407', '32', '15', '137', '35', '120', '175', '38', '202', '230', '7', '108', '142', '381', '177', '104', '234', '220', '224', '264', '423', '279', '304'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.210_小箱怪.png',
    traitName: '虚假宝箱',
    traitEffect: '自己力竭时，敌方获得攻防+20%。',
  },
  {
    id: '216',
    name: '迷迷箱怪',
    types: ['机械', '幻'],
    baseStats: { hp: 138, atk: 129, def: 153, spa: 129, spd: 153, spe: 80 },
    skills: ['406', '455', '416', '31', '75', '33', '396', '3', '353', '445', '136', '419', '374', '171', '456', '397', '127', '128', '22', '129', '130', '131', '132', '133', '134', '258', '74', '407', '32', '15', '137', '35', '120', '175', '38', '202', '230', '7', '108', '142', '381', '177', '104', '234', '220', '224', '264', '423', '279', '304'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.211_迷迷箱怪.png',
    traitName: '虚假宝箱',
    traitEffect: '自己力竭时，敌方获得攻防+20%。',
  },
  {
    id: '217',
    name: '古钟蛇（本来的样子）',
    types: ['萌', '毒'],
    baseStats: { hp: 85, atk: 63, def: 64, spa: 63, spd: 91, spe: 80 },
    skills: ['32', '336', '35', '306', '149', '86', '254', '7', '219', '252', '319', '418', '335', '81', '310', '394', '118', '112', '22', '23', '24', '25', '26', '27', '28', '29', '74', '31', '259', '33', '34', '87', '36', '37', '187', '38', '411', '318', '155', '422', '182', '247', '85', '44', '153', '88', '276', '303', '3', '4', '362', '317'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.212_古钟蛇（本来的样子）.png',
    traitName: '拨浪鼓',
    traitEffect: '己方精灵每使用1次状态技能，自己入场时毒系和萌系技能威力+10。',
  },
  {
    id: '218',
    name: '寒音蛇（本来的样子）',
    types: ['萌', '毒'],
    baseStats: { hp: 106, atk: 79, def: 80, spa: 79, spd: 114, spe: 100 },
    skills: ['32', '336', '35', '306', '149', '86', '254', '7', '219', '252', '319', '418', '335', '81', '310', '394', '118', '112', '22', '23', '24', '25', '26', '27', '28', '29', '74', '31', '259', '33', '34', '87', '36', '37', '187', '38', '411', '318', '155', '422', '182', '247', '85', '44', '153', '88', '276', '303', '3', '4', '362', '317'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.213_寒音蛇（本来的样子）.png',
    traitName: '拨浪鼓',
    traitEffect: '己方精灵每使用1次状态技能，自己入场时毒系和萌系技能威力+10。',
  },
  {
    id: '219',
    name: '矮脚爬爬',
    types: ['虫'],
    baseStats: { hp: 80, atk: 117, def: 74, spa: 110, spd: 59, spe: 92 },
    skills: ['363', '113', '323', '258', '3', '380', '107', '184', '201', '358', '249', '290', '128', '368', '20', '112', '22', '23', '24', '25', '26', '27', '28', '29', '94', '31', '32', '33', '34', '35', '36', '37', '187', '202', '7', '214', '301', '293', '159', '341', '190', '393', '160', '248', '298'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.214_矮脚爬爬.png',
    traitName: '振奋虫心',
    traitEffect: '主动击败敌方后，己方队伍获得5次随机奉献。',
  },
  {
    id: '220',
    name: '恶魔红钻',
    types: ['虫', '恶'],
    baseStats: { hp: 100, atk: 147, def: 93, spa: 137, spd: 74, spe: 115 },
    skills: ['363', '113', '323', '258', '3', '380', '107', '184', '201', '358', '249', '290', '128', '368', '20', '112', '22', '23', '24', '25', '26', '27', '28', '29', '94', '31', '32', '33', '34', '35', '36', '37', '187', '202', '7', '214', '301', '293', '159', '341', '190', '393', '160', '248', '298'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.215_恶魔红钻.png',
    traitName: '振奋虫心',
    traitEffect: '主动击败敌方后，己方队伍获得5次随机奉献。',
  },
  {
    id: '221',
    name: '火尾瓦特',
    types: ['火'],
    baseStats: { hp: 63, atk: 70, def: 81, spa: 29, spd: 56, spe: 39 },
    skills: ['3', '25', '69', '443', '7', '149', '42', '102', '153', '100', '101', '52', '202', '1', '21', '22', '23', '174', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '187', '196', '68', '130', '214', '301', '246', '155', '247', '341', '44', '223', '276', '113'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.216_火尾瓦特.png',
    traitName: '蒸汽膨胀',
    traitEffect: '己方精灵每使用1次火系技能，自己入场时获得全技能威力+10。',
  },
  {
    id: '222',
    name: '火尾战士',
    types: ['火'],
    baseStats: { hp: 84, atk: 94, def: 108, spa: 39, spd: 74, spe: 52 },
    skills: ['3', '25', '69', '443', '7', '149', '42', '102', '153', '100', '101', '52', '202', '1', '21', '22', '23', '174', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '187', '196', '68', '130', '214', '301', '246', '155', '247', '341', '44', '223', '276', '113'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.217_火尾战士.png',
    traitName: '蒸汽膨胀',
    traitEffect: '己方精灵每使用1次火系技能，自己入场时获得全技能威力+10。',
  },
  {
    id: '223',
    name: '烈火守护',
    types: ['火'],
    baseStats: { hp: 105, atk: 117, def: 135, spa: 49, spd: 93, spe: 65 },
    skills: ['3', '25', '69', '443', '7', '149', '42', '102', '153', '100', '101', '52', '202', '1', '21', '22', '23', '174', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '187', '196', '68', '130', '214', '301', '246', '155', '247', '341', '44', '223', '276', '113'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.218_烈火守护.png',
    traitName: '蒸汽膨胀',
    traitEffect: '己方精灵每使用1次火系技能，自己入场时获得全技能威力+10。',
  },
  {
    id: '224',
    name: '里拉鳐',
    types: ['水'],
    baseStats: { hp: 118, atk: 82, def: 103, spa: 89, spd: 147, spe: 105 },
    skills: ['3', '274', '122', '36', '85', '205', '79', '126', '385', '54', '145', '234', '348', '148', '347', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '15', '78', '86', '138', '80', '387', '157', '370', '64', '214', '375', '41', '84', '177', '371', '47', '125', '237', '77', '147', '181', '198'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.219_里拉鳐.png',
    traitName: '吟游之弦',
    traitEffect: '赋予的印记不会替换其他印记，而是同时生效。',
  },
  {
    id: '225',
    name: '海枝枝（碧蓝珊瑚）',
    types: ['水', '幽'],
    baseStats: { hp: 78, atk: 58, def: 96, spa: 148, spd: 120, spe: 110 },
    skills: ['118', '119', '70', '4', '315', '210', '271', '348', '314', '47', '124', '145', '40', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '32', '353', '51', '87', '138', '115', '152', '28', '214', '257', '84', '44', '268', '209', '385', '211', '146', '90', '125', '303', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.220_海枝枝（碧蓝珊瑚）.png',
    traitName: '珊瑚骨',
    traitEffect: '敌方精灵离场时，自己获得全技能能耗-3。',
  },
  {
    id: '226',
    name: '多西',
    types: ['机械', '地'],
    baseStats: { hp: 64, atk: 73, def: 82, spa: 26, spd: 70, spe: 30 },
    skills: ['196', '75', '455', '457', '313', '382', '237', '238', '423', '456', '228', '240', '232', '127', '128', '22', '129', '130', '131', '103', '133', '134', '135', '94', '407', '105', '136', '51', '35', '120', '139', '231', '230', '214', '142', '143', '246', '44', '234', '180', '276', '227', '95', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.221_多西.png',
    traitName: '定向精炼',
    traitEffect: '己方精灵每使用1次防御技能，自己入场时机械系和地面系技能威力+10%。',
  },
  {
    id: '227',
    name: '库多西',
    types: ['机械', '地'],
    baseStats: { hp: 85, atk: 98, def: 109, spa: 34, spd: 93, spe: 40 },
    skills: ['196', '75', '455', '457', '313', '382', '237', '238', '423', '456', '228', '240', '232', '127', '128', '22', '129', '130', '131', '103', '133', '134', '135', '94', '407', '105', '136', '51', '35', '120', '139', '231', '230', '214', '142', '143', '246', '44', '234', '180', '276', '227', '95', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.222_库多西.png',
    traitName: '定向精炼',
    traitEffect: '己方精灵每使用1次防御技能，自己入场时机械系和地面系技能威力+10%。',
  },
  {
    id: '228',
    name: '波多西',
    types: ['机械', '地'],
    baseStats: { hp: 106, atk: 122, def: 136, spa: 43, spd: 116, spe: 50 },
    skills: ['196', '75', '455', '457', '313', '382', '237', '238', '423', '456', '228', '240', '232', '127', '128', '22', '129', '130', '131', '103', '133', '134', '135', '94', '407', '105', '136', '51', '35', '120', '139', '231', '230', '214', '142', '143', '246', '44', '234', '180', '276', '227', '95', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.223_波多西.png',
    traitName: '定向精炼',
    traitEffect: '己方精灵每使用1次防御技能，自己入场时机械系和地面系技能威力+10%。',
  },
  {
    id: '229',
    name: '小翼龙',
    types: ['龙', '翼'],
    baseStats: { hp: 66, atk: 91, def: 73, spa: 24, spd: 63, spe: 92 },
    skills: ['53', '7', '37', '80', '206', '446', '430', '449', '458', '199', '116', '451', '200', '1', '21', '448', '23', '174', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '156', '245', '152', '202', '214', '459', '83', '302', '155', '365', '153', '344', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.224_小翼龙.png',
    traitName: '暴食',
    traitEffect: '携带的龙系技能获得迅捷。',
  },
  {
    id: '230',
    name: '翼龙',
    types: ['龙', '翼'],
    baseStats: { hp: 83, atk: 114, def: 91, spa: 31, spd: 79, spe: 115 },
    skills: ['53', '7', '37', '80', '206', '446', '430', '449', '458', '199', '116', '451', '200', '1', '21', '448', '23', '174', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '156', '245', '152', '202', '214', '459', '83', '302', '155', '365', '153', '344', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.225_翼龙.png',
    traitName: '暴食',
    traitEffect: '携带的龙系技能获得迅捷。',
  },
  {
    id: '231',
    name: '电动长颈鹿',
    types: ['电'],
    baseStats: { hp: 55, atk: 59, def: 65, spa: 20, spd: 47, spe: 72 },
    skills: ['297', '299', '354', '3', '85', '49', '7', '196', '326', '330', '403', '276', '332', '20', '21', '22', '333', '24', '25', '103', '27', '72', '29', '30', '104', '105', '33', '51', '87', '36', '115', '38', '337', '202', '18', '293', '182', '111', '44', '78', '12', '153', '373', '66', '94', '279'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.226_电动长颈鹿.png',
    traitName: '蓄电池',
    traitEffect: '每入场1次，永久获得双攻+20%。',
  },
  {
    id: '232',
    name: '奔乐鹿',
    types: ['电'],
    baseStats: { hp: 73, atk: 79, def: 86, spa: 27, spd: 63, spe: 96 },
    skills: ['297', '299', '354', '3', '85', '49', '7', '196', '326', '330', '403', '276', '332', '20', '21', '22', '333', '24', '25', '103', '27', '72', '29', '30', '104', '105', '33', '51', '87', '36', '115', '38', '337', '202', '18', '293', '182', '111', '44', '78', '12', '153', '373', '66', '94', '279'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.227_奔乐鹿.png',
    traitName: '蓄电池',
    traitEffect: '每入场1次，永久获得双攻+20%。',
  },
  {
    id: '233',
    name: '爵士鹿',
    types: ['电'],
    baseStats: { hp: 92, atk: 99, def: 108, spa: 34, spd: 79, spe: 120 },
    skills: ['297', '299', '354', '3', '85', '49', '7', '196', '326', '330', '403', '276', '332', '20', '21', '22', '333', '24', '25', '103', '27', '72', '29', '30', '104', '105', '33', '51', '87', '36', '115', '38', '337', '202', '18', '293', '182', '111', '44', '78', '12', '153', '373', '66', '94', '279'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.228_爵士鹿.png',
    traitName: '蓄电池',
    traitEffect: '每入场1次，永久获得双攻+20%。',
  },
  {
    id: '234',
    name: '缇塔',
    types: ['机械'],
    baseStats: { hp: 73, atk: 99, def: 98, spa: 38, spd: 74, spe: 72 },
    skills: ['460', '406', '461', '3', '214', '196', '75', '445', '7', '457', '313', '456', '155', '114', '20', '21', '22', '23', '24', '352', '103', '27', '13', '29', '94', '407', '105', '33', '51', '87', '36', '115', '202', '232', '84', '44', '394', '25', '153', '221', '92', '223', '219', '276', '279', '452'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.229_缇塔.png',
    traitName: '向心力',
    traitEffect: '1号位和2号位技能获得传动1和威力+30。',
  },
  {
    id: '235',
    name: '声波缇塔',
    types: ['机械'],
    baseStats: { hp: 92, atk: 124, def: 122, spa: 48, spd: 92, spe: 90 },
    skills: ['460', '406', '461', '3', '214', '196', '75', '445', '7', '457', '313', '456', '155', '114', '20', '21', '22', '23', '24', '352', '103', '27', '13', '29', '94', '407', '105', '33', '51', '87', '36', '115', '202', '232', '84', '44', '394', '25', '153', '221', '92', '223', '219', '276', '279', '452'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.230_声波缇塔.png',
    traitName: '向心力',
    traitEffect: '1号位和2号位技能获得传动1和威力+30。',
  },
  {
    id: '236',
    name: '小鹬',
    types: ['翼'],
    baseStats: { hp: 56, atk: 38, def: 67, spa: 38, spd: 52, spe: 69 },
    skills: ['265', '262', '3', '37', '161', '217', '364', '139', '169', '106', '197', '113', '198', '110', '83', '54', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '86', '138', '115', '157', '337', '130', '142', '109', '155', '159', '85', '45', '168', '205', '365', '47', '153', '440', '216', '90', '125'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.231_小鹬.png',
    traitName: '起飞加速',
    traitEffect: '本场战斗首次使用的技能获得迅捷。',
  },
  {
    id: '237',
    name: '鄙目鹬',
    types: ['翼'],
    baseStats: { hp: 75, atk: 51, def: 90, spa: 51, spd: 70, spe: 92 },
    skills: ['265', '262', '3', '37', '161', '217', '364', '139', '169', '106', '197', '113', '198', '110', '83', '54', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '86', '138', '115', '157', '337', '130', '142', '109', '155', '159', '85', '45', '168', '205', '365', '47', '153', '440', '216', '90', '125'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.232_鄙目鹬.png',
    traitName: '起飞加速',
    traitEffect: '本场战斗首次使用的技能获得迅捷。',
  },
  {
    id: '238',
    name: '高脚鹬',
    types: ['翼'],
    baseStats: { hp: 94, atk: 63, def: 112, spa: 63, spd: 87, spe: 115 },
    skills: ['265', '262', '3', '37', '161', '217', '364', '139', '169', '106', '197', '113', '198', '110', '83', '54', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '86', '138', '115', '157', '337', '130', '142', '109', '155', '159', '85', '45', '168', '205', '365', '47', '153', '440', '216', '90', '125'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.233_高脚鹬.png',
    traitName: '起飞加速',
    traitEffect: '本场战斗首次使用的技能获得迅捷。',
  },
  {
    id: '239',
    name: '脆筒甜甜',
    types: ['冰'],
    baseStats: { hp: 72, atk: 67, def: 42, spa: 72, spd: 55, spe: 60 },
    skills: ['3', '398', '72', '41', '4', '410', '404', '411', '7', '149', '409', '417', '405', '402', '203', '384', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '259', '353', '51', '87', '170', '115', '337', '414', '70', '374', '39', '109', '269', '315', '212', '85', '252', '263', '90', '242', '254', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.234_脆筒甜甜.png',
    traitName: '加个雪球',
    traitEffect: '使敌方获得冻结时，也会使其获得2层冻结。',
  },
  {
    id: '240',
    name: '香草甜甜',
    types: ['冰'],
    baseStats: { hp: 96, atk: 90, def: 56, spa: 95, spd: 74, spe: 80 },
    skills: ['3', '398', '72', '41', '4', '410', '404', '411', '7', '149', '409', '417', '405', '402', '203', '384', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '259', '353', '51', '87', '170', '115', '337', '414', '70', '374', '39', '109', '269', '315', '212', '85', '252', '263', '90', '242', '254', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.235_香草甜甜.png',
    traitName: '加个雪球',
    traitEffect: '使敌方获得冻结时，也会使其获得2层冻结。',
  },
  {
    id: '241',
    name: '圣代甜甜',
    types: ['冰'],
    baseStats: { hp: 119, atk: 112, def: 70, spa: 119, spd: 92, spe: 100 },
    skills: ['3', '398', '72', '41', '4', '410', '404', '411', '7', '149', '409', '417', '405', '402', '203', '384', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '259', '353', '51', '87', '170', '115', '337', '414', '70', '374', '39', '109', '269', '315', '212', '85', '252', '263', '90', '242', '254', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.236_圣代甜甜.png',
    traitName: '加个雪球',
    traitEffect: '使敌方获得冻结时，也会使其获得2层冻结。',
  },
  {
    id: '242',
    name: '刺轮砣（上弦的样子）',
    types: ['毒', '萌'],
    baseStats: { hp: 100, atk: 80, def: 80, spa: 78, spd: 65, spe: 84 },
    skills: ['393', '213', '76', '305', '86', '395', '252', '3', '87', '307', '319', '81', '256', '108', '310', '20', '112', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '259', '77', '78', '35', '79', '80', '54', '166', '214', '142', '83', '257', '84', '85', '309', '123', '122', '47', '9', '347', '90', '170', '418', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.237_刺轮砣（上弦的样子）.png',
    traitName: '耐活王',
    traitEffect: '敌方受到中毒效果伤害时，自己回复等量生命。',
  },
  {
    id: '243',
    name: '月亮砣（上弦的样子）',
    types: ['毒', '萌'],
    baseStats: { hp: 125, atk: 100, def: 100, spa: 98, spd: 81, spe: 105 },
    skills: ['393', '213', '76', '305', '86', '395', '252', '3', '87', '307', '319', '81', '256', '108', '310', '20', '112', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '259', '77', '78', '35', '79', '80', '54', '166', '214', '142', '83', '257', '84', '85', '309', '123', '122', '47', '9', '347', '90', '170', '418', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.238_月亮砣（上弦的样子）.png',
    traitName: '耐活王',
    traitEffect: '敌方受到中毒效果伤害时，自己回复等量生命。',
  },
  {
    id: '244',
    name: '豆丁鱼',
    types: ['水', '龙'],
    baseStats: { hp: 45, atk: 70, def: 67, spa: 74, spd: 70, spe: 75 },
    skills: ['4', '9', '448', '441', '196', '348', '205', '446', '430', '47', '116', '450', '451', '204', '40', '118', '21', '429', '23', '24', '25', '26', '27', '28', '29', '74', '31', '32', '33', '34', '35', '138', '115', '106', '38', '7', '22', '277', '150', '83', '155', '110', '121', '49', '169', '10', '303', '3', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.239_豆丁鱼.png',
    traitName: '洄游',
    traitEffect: '每次进入蓄力状态，获得全技能能耗永久-1。',
  },
  {
    id: '245',
    name: '快鳍鱼',
    types: ['水', '龙'],
    baseStats: { hp: 60, atk: 93, def: 89, spa: 99, spd: 93, spe: 100 },
    skills: ['4', '9', '448', '441', '196', '348', '205', '446', '430', '47', '116', '450', '451', '204', '40', '118', '21', '429', '23', '24', '25', '26', '27', '28', '29', '74', '31', '32', '33', '34', '35', '138', '115', '106', '38', '7', '22', '277', '150', '83', '155', '110', '121', '49', '169', '10', '303', '3', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.240_快鳍鱼.png',
    traitName: '洄游',
    traitEffect: '每次进入蓄力状态，获得全技能能耗永久-1。',
  },
  {
    id: '246',
    name: '龙鱼',
    types: ['水', '龙'],
    baseStats: { hp: 75, atk: 116, def: 112, spa: 123, spd: 116, spe: 125 },
    skills: ['4', '9', '448', '441', '196', '348', '205', '446', '430', '47', '116', '450', '451', '204', '40', '118', '21', '429', '23', '24', '25', '26', '27', '28', '29', '74', '31', '32', '33', '34', '35', '138', '115', '106', '38', '7', '22', '277', '150', '83', '155', '110', '121', '49', '169', '10', '303', '3', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.241_龙鱼.png',
    traitName: '洄游',
    traitEffect: '每次进入蓄力状态，获得全技能能耗永久-1。',
  },
  {
    id: '247',
    name: '胆小鳗鱼',
    types: ['电', '水'],
    baseStats: { hp: 68, atk: 92, def: 83, spa: 92, spd: 90, spe: 92 },
    skills: ['3', '36', '79', '49', '328', '293', '129', '355', '365', '331', '334', '172', '123', '356', '332', '127', '128', '22', '333', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '35', '138', '175', '143', '109', '120', '220', '385', '126', '9', '262', '153', '224', '283', '218', '51', '326', '303', '304'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.242_胆小鳗鱼.png',
    traitName: '生物电',
    traitEffect: '携带的电系技能获得迸发：能耗-2。',
  },
  {
    id: '248',
    name: '闪电鳗鱼',
    types: ['电', '水'],
    baseStats: { hp: 85, atk: 115, def: 104, spa: 115, spd: 112, spe: 115 },
    skills: ['3', '36', '79', '49', '328', '293', '129', '355', '365', '331', '334', '172', '123', '356', '332', '127', '128', '22', '333', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '35', '138', '175', '143', '109', '120', '220', '385', '126', '9', '262', '153', '224', '283', '218', '51', '326', '303', '304'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.243_闪电鳗鱼.png',
    traitName: '生物电',
    traitEffect: '携带的电系技能获得迸发：能耗-2。',
  },
  {
    id: '249',
    name: '翡翠水母',
    types: ['水', '毒'],
    baseStats: { hp: 108, atk: 30, def: 75, spa: 68, spd: 109, spe: 76 },
    skills: ['119', '122', '213', '93', '306', '88', '123', '462', '307', '349', '310', '362', '40', '127', '128', '22', '333', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '87', '138', '175', '392', '142', '109', '233', '121', '173', '47', '126', '283', '79', '218', '3', '259'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.244_翡翠水母.png',
    traitName: '扩散侵蚀',
    traitEffect: '使用水系技能后，敌方获得中毒，获得层数等于中毒印记层数的2倍。',
  },
  {
    id: '250',
    name: '琉璃水母',
    types: ['水', '毒'],
    baseStats: { hp: 134, atk: 37, def: 93, spa: 85, spd: 136, spe: 95 },
    skills: ['119', '122', '213', '93', '306', '88', '123', '462', '307', '349', '310', '362', '40', '127', '128', '22', '333', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '87', '138', '175', '392', '142', '109', '233', '121', '173', '47', '126', '283', '79', '218', '3', '259'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.245_琉璃水母.png',
    traitName: '扩散侵蚀',
    traitEffect: '使用水系技能后，敌方获得中毒，获得层数等于中毒印记层数的2倍。',
  },
  {
    id: '251',
    name: '裘洛',
    types: ['毒'],
    baseStats: { hp: 44, atk: 56, def: 39, spa: 50, spd: 48, spe: 75 },
    skills: ['305', '306', '3', '149', '86', '219', '92', '88', '307', '217', '153', '310', '81', '338', '394', '118', '112', '22', '23', '24', '25', '26', '27', '28', '29', '74', '31', '32', '33', '34', '87', '36', '37', '196', '109', '444', '83', '332', '272', '85', '111', '191', '168', '49', '192', '10', '330', '114', '243'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.246_裘洛.png',
    traitName: '蚀刻',
    traitEffect: '回合结束时，敌方每2层中毒转化为1层中毒印记。',
  },
  {
    id: '252',
    name: '裘力',
    types: ['毒'],
    baseStats: { hp: 59, atk: 74, def: 52, spa: 67, spd: 64, spe: 100 },
    skills: ['305', '306', '3', '149', '86', '219', '92', '88', '307', '217', '153', '310', '81', '338', '394', '118', '112', '22', '23', '24', '25', '26', '27', '28', '29', '74', '31', '32', '33', '34', '87', '36', '37', '196', '109', '444', '83', '332', '272', '85', '111', '191', '168', '49', '192', '10', '330', '114', '243'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.247_裘力.png',
    traitName: '蚀刻',
    traitEffect: '回合结束时，敌方每2层中毒转化为1层中毒印记。',
  },
  {
    id: '253',
    name: '裘卡',
    types: ['毒'],
    baseStats: { hp: 73, atk: 93, def: 65, spa: 83, spd: 81, spe: 125 },
    skills: ['305', '306', '3', '149', '86', '219', '92', '88', '307', '217', '153', '310', '81', '338', '394', '118', '112', '22', '23', '24', '25', '26', '27', '28', '29', '74', '31', '32', '33', '34', '87', '36', '37', '196', '109', '444', '83', '332', '272', '85', '111', '191', '168', '49', '192', '10', '330', '114', '243'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.248_裘卡.png',
    traitName: '蚀刻',
    traitEffect: '回合结束时，敌方每2层中毒转化为1层中毒印记。',
  },
  {
    id: '254',
    name: '可爱猿',
    types: ['火'],
    baseStats: { hp: 100, atk: 97, def: 86, spa: 43, spd: 67, spe: 36 },
    skills: ['7', '463', '98', '3', '294', '196', '42', '296', '424', '100', '101', '52', '99', '20', '21', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '259', '33', '51', '87', '36', '115', '445', '337', '202', '108', '214', '232', '228', '293', '155', '85', '44', '256', '252', '254', '276', '222', '382'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.249_可爱猿.png',
    traitName: '散热',
    traitEffect: '初始能量为0，入场前己方精灵每放1次火系技能，回复3能量。',
  },
  {
    id: '255',
    name: '炽热猿',
    types: ['火'],
    baseStats: { hp: 133, atk: 130, def: 115, spa: 57, spd: 89, spe: 48 },
    skills: ['7', '463', '98', '3', '294', '196', '42', '296', '424', '100', '101', '52', '99', '20', '21', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '259', '33', '51', '87', '36', '115', '445', '337', '202', '108', '214', '232', '228', '293', '155', '85', '44', '256', '252', '254', '276', '222', '382'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.250_炽热猿.png',
    traitName: '散热',
    traitEffect: '初始能量为0，入场前己方精灵每放1次火系技能，回复3能量。',
  },
  {
    id: '256',
    name: '火焰猿',
    types: ['火'],
    baseStats: { hp: 167, atk: 162, def: 143, spa: 72, spd: 111, spe: 60 },
    skills: ['7', '463', '98', '3', '294', '196', '42', '296', '424', '100', '101', '52', '99', '20', '21', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '259', '33', '51', '87', '36', '115', '445', '337', '202', '108', '214', '232', '228', '293', '155', '85', '44', '256', '252', '254', '276', '222', '382'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.251_火焰猿.png',
    traitName: '散热',
    traitEffect: '初始能量为0，入场前己方精灵每放1次火系技能，回复3能量。',
  },
  {
    id: '257',
    name: '布鲁斯',
    types: ['冰'],
    baseStats: { hp: 44, atk: 60, def: 68, spa: 16, spd: 53, spe: 54 },
    skills: ['13', '72', '196', '3', '7', '387', '383', '410', '147', '411', '388', '413', '203', '1', '21', '22', '23', '24', '25', '103', '27', '28', '29', '94', '104', '105', '33', '51', '87', '36', '115', '445', '337', '202', '107', '214', '182', '85', '111', '44', '153', '90', '223', '276', '366'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.252_布鲁斯.png',
    traitName: '冰钻',
    traitEffect: '敌方携带技能总能耗每有1点，自己攻击时威力+10%。',
  },
  {
    id: '258',
    name: '雪顶布鲁斯',
    types: ['冰'],
    baseStats: { hp: 58, atk: 81, def: 91, spa: 22, spd: 70, spe: 72 },
    skills: ['13', '72', '196', '3', '7', '387', '383', '410', '147', '411', '388', '413', '203', '1', '21', '22', '23', '24', '25', '103', '27', '28', '29', '94', '104', '105', '33', '51', '87', '36', '115', '445', '337', '202', '107', '214', '182', '85', '111', '44', '153', '90', '223', '276', '366'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.253_雪顶布鲁斯.png',
    traitName: '冰钻',
    traitEffect: '敌方携带技能总能耗每有1点，自己攻击时威力+10%。',
  },
  {
    id: '259',
    name: '冰钻布鲁斯',
    types: ['冰'],
    baseStats: { hp: 73, atk: 101, def: 114, spa: 27, spd: 88, spe: 90 },
    skills: ['13', '72', '196', '3', '7', '387', '383', '410', '147', '411', '388', '413', '203', '1', '21', '22', '23', '24', '25', '103', '27', '28', '29', '94', '104', '105', '33', '51', '87', '36', '115', '445', '337', '202', '107', '214', '182', '85', '111', '44', '153', '90', '223', '276', '366'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.254_冰钻布鲁斯.png',
    traitName: '冰钻',
    traitEffect: '敌方携带技能总能耗每有1点，自己攻击时威力+10%。',
  },
  {
    id: '260',
    name: '治愈兔',
    types: ['火', '萌'],
    baseStats: { hp: 67, atk: 28, def: 60, spa: 73, spd: 76, spe: 54 },
    skills: ['464', '69', '259', '352', '3', '336', '319', '294', '418', '263', '426', '311', '425', '20', '66', '22', '67', '68', '6', '103', '56', '72', '73', '74', '407', '32', '77', '78', '86', '79', '80', '424', '109', '82', '83', '84', '177', '85', '12', '131', '465', '252', '264', '427', '4'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.255_治愈兔.png',
    traitName: '仁心',
    traitEffect: '敌方受到灼烧伤害时，自己回复等量生命。',
  },
  {
    id: '261',
    name: '红丝绒',
    types: ['火', '萌'],
    baseStats: { hp: 90, atk: 38, def: 80, spa: 98, spd: 101, spe: 72 },
    skills: ['464', '69', '259', '352', '3', '336', '319', '294', '418', '263', '426', '311', '425', '20', '66', '22', '67', '68', '6', '103', '56', '72', '73', '74', '407', '32', '77', '78', '86', '79', '80', '424', '109', '82', '83', '84', '177', '85', '12', '131', '465', '252', '264', '427', '4'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.256_红丝绒.png',
    traitName: '仁心',
    traitEffect: '敌方受到灼烧伤害时，自己回复等量生命。',
  },
  {
    id: '262',
    name: '红绒十字',
    types: ['火', '萌'],
    baseStats: { hp: 112, atk: 47, def: 100, spa: 122, spd: 127, spe: 90 },
    skills: ['464', '69', '259', '352', '3', '336', '319', '294', '418', '263', '426', '311', '425', '20', '66', '22', '67', '68', '6', '103', '56', '72', '73', '74', '407', '32', '77', '78', '86', '79', '80', '424', '109', '82', '83', '84', '177', '85', '12', '131', '465', '252', '264', '427', '4'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.257_红绒十字.png',
    traitName: '仁心',
    traitEffect: '敌方受到灼烧伤害时，自己回复等量生命。',
  },
  {
    id: '263',
    name: '乌达（极昼的样子）',
    types: ['恶', '火'],
    baseStats: { hp: 80, atk: 95, def: 70, spa: 49, spd: 42, spe: 33 },
    skills: ['463', '112', '66', '7', '293', '42', '292', '185', '97', '244', '184', '52', '111', '20', '21', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '37', '152', '107', '130', '214', '444', '155', '159', '300', '153', '298', '276', '3', '115'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.258_乌达（极昼的样子）.png',
    traitName: '恶魔的晚宴',
    traitEffect: '主动击败敌方精灵时，自己获得双攻+50%。',
  },
  {
    id: '264',
    name: '迷你乌（极昼的样子）',
    types: ['恶', '火'],
    baseStats: { hp: 107, atk: 126, def: 93, spa: 66, spd: 56, spe: 44 },
    skills: ['463', '112', '66', '7', '293', '42', '292', '185', '97', '244', '184', '52', '111', '20', '21', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '37', '152', '107', '130', '214', '444', '155', '159', '300', '153', '298', '276', '3', '115'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.259_迷你乌（极昼的样子）.png',
    traitName: '恶魔的晚宴',
    traitEffect: '主动击败敌方精灵时，自己获得双攻+50%。',
  },
  {
    id: '265',
    name: '乌拉塔（极昼的样子）',
    types: ['恶', '火'],
    baseStats: { hp: 134, atk: 158, def: 116, spa: 82, spd: 70, spe: 55 },
    skills: ['463', '112', '66', '7', '293', '42', '292', '185', '97', '244', '184', '52', '111', '20', '21', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '37', '152', '107', '130', '214', '444', '155', '159', '300', '153', '298', '276', '3', '115'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.260_乌拉塔（极昼的样子）.png',
    traitName: '恶魔的晚宴',
    traitEffect: '主动击败敌方精灵时，自己获得双攻+50%。',
  },
  {
    id: '266',
    name: '螺旋帕帕',
    types: ['机械', '翼'],
    baseStats: { hp: 88, atk: 55, def: 79, spa: 8, spd: 67, spe: 80 },
    skills: ['457', '406', '461', '166', '206', '80', '420', '313', '115', '198', '337', '199', '202', '1', '21', '22', '333', '24', '25', '103', '27', '13', '29', '94', '407', '105', '33', '51', '87', '36', '37', '214', '153', '49', '90', '345', '254', '299', '276', '423', '3', '114', '165', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.261_螺旋帕帕.png',
    traitName: '翼轴',
    traitEffect: '1号位技能获得迅捷和传动1。',
  },
  {
    id: '267',
    name: '帕帕斯卡',
    types: ['机械', '翼'],
    baseStats: { hp: 110, atk: 68, def: 99, spa: 10, spd: 84, spe: 100 },
    skills: ['457', '406', '461', '166', '206', '80', '420', '313', '115', '198', '337', '199', '202', '1', '21', '22', '333', '24', '25', '103', '27', '13', '29', '94', '407', '105', '33', '51', '87', '36', '37', '214', '153', '49', '90', '345', '254', '299', '276', '423', '3', '114', '165', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.262_帕帕斯卡.png',
    traitName: '翼轴',
    traitEffect: '1号位技能获得迅捷和传动1。',
  },
  {
    id: '268',
    name: '机械方方',
    types: ['机械'],
    baseStats: { hp: 62, atk: 81, def: 76, spa: 32, spd: 60, spe: 51 },
    skills: ['104', '406', '3', '196', '75', '457', '7', '420', '313', '157', '421', '151', '83', '54', '66', '22', '23', '68', '69', '70', '56', '72', '73', '94', '407', '259', '77', '78', '86', '79', '80', '109', '85', '44', '76', '49', '331', '336', '90', '254', '299', '127', '395', '67'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.263_机械方方.png',
    traitName: '盲拧',
    traitEffect: '回合开始时，技能顺序打乱，4号位的技能能耗-4。',
  },
  {
    id: '269',
    name: '多彩方方',
    types: ['机械'],
    baseStats: { hp: 82, atk: 108, def: 101, spa: 43, spd: 80, spe: 68 },
    skills: ['104', '406', '3', '196', '75', '457', '7', '420', '313', '157', '421', '151', '83', '54', '66', '22', '23', '68', '69', '70', '56', '72', '73', '94', '407', '259', '77', '78', '86', '79', '80', '109', '85', '44', '76', '49', '331', '336', '90', '254', '299', '127', '395', '67'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.264_多彩方方.png',
    traitName: '盲拧',
    traitEffect: '回合开始时，技能顺序打乱，4号位的技能能耗-4。',
  },
  {
    id: '270',
    name: '立方人',
    types: ['机械'],
    baseStats: { hp: 103, atk: 135, def: 127, spa: 54, spd: 101, spe: 85 },
    skills: ['104', '406', '3', '196', '75', '457', '7', '420', '313', '157', '421', '151', '83', '54', '66', '22', '23', '68', '69', '70', '56', '72', '73', '94', '407', '259', '77', '78', '86', '79', '80', '109', '85', '44', '76', '49', '331', '336', '90', '254', '299', '127', '395', '67'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.265_立方人.png',
    traitName: '盲拧',
    traitEffect: '回合开始时，技能顺序打乱，4号位的技能能耗-4。',
  },
  {
    id: '271',
    name: '可立鸡',
    types: ['火'],
    baseStats: { hp: 65, atk: 79, def: 55, spa: 79, spd: 52, spe: 66 },
    skills: ['25', '7', '443', '294', '24', '153', '196', '159', '97', '340', '101', '118', '21', '22', '23', '174', '6', '26', '27', '28', '29', '74', '31', '32', '33', '34', '35', '36', '115', '337', '109', '155', '42', '85', '376', '344', '200', '223', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.266_可立鸡.png',
    traitName: '指挥家',
    traitEffect: '应对成功后，永久获得双攻+20%。',
  },
  {
    id: '272',
    name: '晕晕鸡',
    types: ['火'],
    baseStats: { hp: 86, atk: 106, def: 74, spa: 106, spd: 70, spe: 88 },
    skills: ['25', '7', '443', '294', '24', '153', '196', '159', '97', '340', '101', '118', '21', '22', '23', '174', '6', '26', '27', '28', '29', '74', '31', '32', '33', '34', '35', '36', '115', '337', '109', '155', '42', '85', '376', '344', '200', '223', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.267_晕晕鸡.png',
    traitName: '指挥家',
    traitEffect: '应对成功后，永久获得双攻+20%。',
  },
  {
    id: '273',
    name: '绅士鸡',
    types: ['火', '武'],
    baseStats: { hp: 108, atk: 132, def: 92, spa: 132, spd: 87, spe: 110 },
    skills: ['25', '7', '443', '294', '24', '153', '196', '159', '97', '340', '101', '295', '52', '432', '316', '48', '343', '118', '21', '22', '23', '174', '6', '26', '27', '28', '29', '74', '31', '32', '33', '34', '35', '36', '37', '337', '109', '102', '155', '42', '342', '433', '85', '376', '220', '344', '200', '169', '223', '3', '115'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.268_绅士鸡.png',
    traitName: '指挥家',
    traitEffect: '应对成功后，永久获得双攻+20%。',
  },
  {
    id: '274',
    name: '武者鸡',
    types: ['火', '武'],
    baseStats: { hp: 121, atk: 144, def: 92, spa: 58, spd: 70, spe: 95 },
    skills: ['25', '7', '443', '294', '24', '153', '196', '159', '97', '340', '101', '130', '52', '432', '1', '21', '22', '23', '174', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '337', '195', '109', '155', '42', '431', '85', '376', '344', '200', '223', '3', '295'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.269_武者鸡.png',
    traitName: '斗技',
    traitEffect: '应对成功后，获得全技能威力永久+20。',
  },
  {
    id: '275',
    name: '优优',
    types: ['地', '光'],
    baseStats: { hp: 81, atk: 35, def: 84, spa: 89, spd: 104, spe: 92 },
    skills: ['281', '221', '2', '220', '3', '14', '222', '224', '16', '12', '82', '237', '287', '54', '66', '22', '67', '174', '69', '70', '71', '72', '73', '74', '75', '76', '77', '51', '86', '79', '80', '157', '260', '214', '234', '241', '90', '418', '264', '227', '113', '304', '259', '4'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.270_优优.png',
    traitName: '哨兵',
    traitEffect: '回合开始时若敌方技能足够击败自己，自己获得速度+50，行动后脱离。',
  },
  {
    id: '276',
    name: '绒光优优',
    types: ['地', '光'],
    baseStats: { hp: 101, atk: 43, def: 105, spa: 111, spd: 130, spe: 115 },
    skills: ['281', '221', '2', '220', '3', '14', '222', '224', '16', '12', '82', '237', '287', '54', '66', '22', '67', '174', '69', '70', '71', '72', '73', '74', '75', '76', '77', '51', '86', '79', '80', '157', '260', '214', '234', '241', '90', '418', '264', '227', '113', '304', '259', '4'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.271_绒光优优.png',
    traitName: '哨兵',
    traitEffect: '回合开始时若敌方技能足够击败自己，自己获得速度+50，行动后脱离。',
  },
  {
    id: '277',
    name: '噼啪鸟',
    types: ['电', '翼'],
    baseStats: { hp: 78, atk: 116, def: 85, spa: 109, spd: 85, spe: 145 },
    skills: ['4', '49', '355', '299', '110', '403', '167', '376', '288', '80', '453', '169', '200', '332', '117', '118', '21', '22', '333', '24', '25', '26', '27', '72', '29', '74', '31', '32', '33', '34', '35', '36', '115', '337', '7', '214', '75', '85', '406', '206', '90', '442', '399', '313', '197', '3', '114', '67', '116'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.272_噼啪鸟.png',
    traitName: '连续负荷',
    traitEffect: '自己技能的迸发效果延长1回合。',
  },
  {
    id: '278',
    name: '深蓝鲸',
    types: ['水'],
    baseStats: { hp: 129, atk: 40, def: 119, spa: 115, spd: 135, spe: 50 },
    skills: ['119', '3', '4', '45', '462', '304', '125', '120', '121', '145', '126', '40', '173', '20', '128', '22', '129', '174', '131', '132', '133', '13', '135', '74', '31', '32', '15', '137', '35', '138', '139', '38', '140', '28', '176', '41', '44', '124', '146', '79', '147', '127', '179', '134', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.273_深蓝鲸.png',
    traitName: '倾轧',
    traitEffect: '携带的技能受能耗变化效果的影响翻倍。',
  },
  {
    id: '279',
    name: '格兰种子',
    types: ['草'],
    baseStats: { hp: 65, atk: 31, def: 48, spa: 74, spd: 67, spe: 36 },
    skills: ['85', '50', '8', '268', '337', '61', '57', '286', '65', '60', '114', '43', '118', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '353', '34', '87', '170', '115', '38', '318', '84', '86', '12', '88', '146', '280', '93', '51', '303', '3', '4', '362'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.274_格兰种子.png',
    traitName: '生长',
    traitEffect: '回合结束时，回复12%生命。',
  },
  {
    id: '280',
    name: '格兰花',
    types: ['草'],
    baseStats: { hp: 86, atk: 42, def: 64, spa: 99, spd: 90, spe: 48 },
    skills: ['85', '50', '8', '268', '337', '61', '57', '286', '65', '60', '114', '43', '118', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '353', '34', '87', '170', '115', '38', '318', '84', '86', '12', '88', '146', '280', '93', '51', '303', '3', '4', '362'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.275_格兰花.png',
    traitName: '生长',
    traitEffect: '回合结束时，回复12%生命。',
  },
  {
    id: '281',
    name: '格兰球',
    types: ['草'],
    baseStats: { hp: 108, atk: 52, def: 80, spa: 124, spd: 112, spe: 60 },
    skills: ['85', '50', '8', '268', '337', '61', '57', '286', '65', '60', '114', '43', '118', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '353', '34', '87', '170', '115', '38', '318', '84', '86', '12', '88', '146', '280', '93', '51', '303', '3', '4', '362'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.276_格兰球.png',
    traitName: '生长',
    traitEffect: '回合结束时，回复12%生命。',
  },
  {
    id: '282',
    name: '地鼠（枯水期的样子）',
    types: ['地'],
    baseStats: { hp: 66, atk: 71, def: 61, spa: 31, spd: 42, spe: 66 },
    skills: ['53', '85', '279', '221', '196', '3', '226', '236', '78', '148', '232', '237', '373', '372', '1', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '35', '36', '115', '156', '461', '202', '214', '406', '394', '86', '87', '241', '153', '90', '219', '276', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.277_地鼠（枯水期的样子）.png',
    traitName: '警惕',
    traitEffect: '回合结束时，若自己能量为0则脱离。',
  },
  {
    id: '283',
    name: '遁鼠（枯水期的样子）',
    types: ['地'],
    baseStats: { hp: 88, atk: 95, def: 82, spa: 41, spd: 56, spe: 88 },
    skills: ['53', '85', '279', '221', '196', '3', '226', '236', '78', '148', '232', '237', '373', '372', '1', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '35', '36', '115', '156', '461', '202', '214', '406', '394', '86', '87', '241', '153', '90', '219', '276', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.278_遁鼠（枯水期的样子）.png',
    traitName: '警惕',
    traitEffect: '回合结束时，若自己能量为0则脱离。',
  },
  {
    id: '284',
    name: '遁地鼠（枯水期的样子）',
    types: ['地'],
    baseStats: { hp: 110, atk: 119, def: 102, spa: 51, spd: 70, spe: 110 },
    skills: ['53', '85', '279', '221', '196', '3', '226', '236', '78', '148', '232', '237', '373', '372', '1', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '35', '36', '115', '156', '461', '202', '214', '406', '394', '86', '87', '241', '153', '90', '219', '276', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.279_遁地鼠（枯水期的样子）.png',
    traitName: '警惕',
    traitEffect: '回合结束时，若自己能量为0则脱离。',
  },
  {
    id: '285',
    name: '墨鱿士',
    types: ['幽'],
    baseStats: { hp: 103, atk: 84, def: 105, spa: 34, spd: 79, spe: 56 },
    skills: ['242', '70', '395', '76', '112', '3', '345', '26', '107', '254', '132', '186', '181', '54', '66', '22', '67', '68', '69', '103', '71', '72', '73', '74', '75', '259', '15', '51', '86', '79', '80', '157', '337', '7', '374', '214', '277', '210', '300', '416'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.280_墨鱿士.png',
    traitName: '涂鸦',
    traitEffect: '使用非本系技能时威力+50%。',
  },
  {
    id: '286',
    name: '混乱鱿彩',
    types: ['幽', '恶'],
    baseStats: { hp: 129, atk: 105, def: 131, spa: 42, spd: 99, spe: 70 },
    skills: ['242', '70', '395', '76', '112', '3', '345', '26', '107', '254', '132', '186', '181', '187', '246', '183', '54', '21', '22', '67', '68', '69', '103', '71', '72', '73', '74', '75', '259', '15', '51', '86', '79', '80', '157', '370', '337', '7', '374', '214', '277', '210', '396', '190', '191', '300', '416', '90', '390'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.281_混乱鱿彩.png',
    traitName: '涂鸦',
    traitEffect: '使用非本系技能时威力+50%。',
  },
  {
    id: '287',
    name: '秩序鱿墨',
    types: ['幽', '萌'],
    baseStats: { hp: 78, atk: 120, def: 124, spa: 39, spd: 113, spe: 130 },
    skills: ['242', '70', '395', '76', '112', '3', '345', '26', '107', '254', '132', '186', '181', '233', '235', '177', '127', '128', '22', '129', '130', '131', '103', '133', '134', '135', '74', '104', '259', '77', '137', '35', '120', '175', '157', '337', '202', '136', '7', '374', '214', '142', '277', '143', '210', '212', '300', '416', '218'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.282_秩序鱿墨.png',
    traitName: '绝对秩序',
    traitEffect: '受到非敌方系别的技能攻击时伤害-50%。',
  },
  {
    id: '288',
    name: '小甲虫',
    types: ['虫'],
    baseStats: { hp: 98, atk: 71, def: 97, spa: 31, spd: 61, spe: 60 },
    skills: ['248', '3', '323', '258', '249', '135', '380', '253', '142', '359', '379', '361', '377', '20', '128', '22', '129', '130', '131', '132', '133', '134', '29', '94', '104', '105', '136', '137', '35', '120', '175', '199', '38', '337', '7', '143', '110', '177', '184', '300', '139', '180', '218', '364'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.283_小甲虫.png',
    traitName: '坚韧铠甲',
    traitEffect: '每受到1次攻击伤害，己方队伍获得1次随机奉献。',
  },
  {
    id: '289',
    name: '铠甲虫',
    types: ['虫'],
    baseStats: { hp: 122, atk: 88, def: 121, spa: 39, spd: 77, spe: 75 },
    skills: ['248', '3', '323', '258', '249', '135', '380', '253', '142', '359', '379', '361', '377', '20', '128', '22', '129', '130', '131', '132', '133', '134', '29', '94', '104', '105', '136', '137', '35', '120', '175', '199', '38', '337', '7', '143', '110', '177', '184', '300', '139', '180', '218', '364'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.284_铠甲虫.png',
    traitName: '坚韧铠甲',
    traitEffect: '每受到1次攻击伤害，己方队伍获得1次随机奉献。',
  },
  {
    id: '290',
    name: '圣剑侍从',
    types: ['机械'],
    baseStats: { hp: 139, atk: 116, def: 139, spa: 111, spd: 139, spe: 52 },
    skills: ['4', '3', '104', '407', '75', '196', '54', '457', '7', '445', '165', '419', '313', '423', '421', '456', '20', '21', '22', '23', '24', '25', '103', '27', '28', '29', '94', '31', '105', '33', '51', '87', '36', '115', '202', '411', '13', '214', '229', '82', '83', '44', '12', '280', '163', '303', '222', '11', '225', '382'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.285_圣剑侍从.png',
    traitName: '正位宝剑',
    traitEffect: '仅可以使用1号位技能。',
  },
  {
    id: '291',
    name: '圣剑-X',
    types: ['机械'],
    baseStats: { hp: 174, atk: 144, def: 173, spa: 139, spd: 173, spe: 65 },
    skills: ['4', '3', '104', '407', '75', '196', '54', '457', '7', '445', '165', '419', '313', '423', '421', '456', '20', '21', '22', '23', '24', '25', '103', '27', '28', '29', '94', '31', '105', '33', '51', '87', '36', '115', '202', '411', '13', '214', '229', '82', '83', '44', '12', '280', '163', '303', '222', '11', '225', '382'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.286_圣剑-X.png',
    traitName: '正位宝剑',
    traitEffect: '仅可以使用1号位技能。',
  },
  {
    id: '292',
    name: '吸泥鸥',
    types: ['地', '翼'],
    baseStats: { hp: 99, atk: 89, def: 87, spa: 33, spd: 71, spe: 76 },
    skills: ['7', '223', '195', '106', '196', '221', '206', '78', '110', '382', '228', '200', '232', '1', '112', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '337', '229', '109', '315', '84', '85', '111', '44', '191', '80', '276', '366', '222', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.287_吸泥鸥.png',
    traitName: '无差别过滤',
    traitEffect: '在场时，所有精灵连击数固定为2。',
  },
  {
    id: '293',
    name: '泥吼牙',
    types: ['地', '翼'],
    baseStats: { hp: 124, atk: 112, def: 109, spa: 41, spd: 88, spe: 95 },
    skills: ['7', '223', '195', '106', '196', '221', '206', '78', '110', '382', '228', '200', '232', '1', '112', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '337', '229', '109', '315', '84', '85', '111', '44', '191', '80', '276', '366', '222', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.288_泥吼牙.png',
    traitName: '无差别过滤',
    traitEffect: '在场时，所有精灵连击数固定为2。',
  },
  {
    id: '294',
    name: '大头骨龙',
    types: ['龙', '幽'],
    baseStats: { hp: 96, atk: 109, def: 84, spa: 40, spd: 65, spe: 48 },
    skills: ['466', '242', '181', '186', '441', '429', '449', '132', '26', '196', '467', '116', '459', '127', '128', '448', '129', '130', '131', '103', '133', '134', '135', '94', '104', '105', '136', '137', '35', '120', '139', '38', '202', '7', '142', '143', '189', '177', '44', '49', '331', '216', '113', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.289_大头骨龙.png',
    traitName: '不朽',
    traitEffect: '力竭3回合后复活。',
  },
  {
    id: '295',
    name: '寂灭骨龙',
    types: ['龙', '幽'],
    baseStats: { hp: 120, atk: 137, def: 104, spa: 50, spd: 81, spe: 60 },
    skills: ['466', '242', '181', '186', '441', '429', '449', '132', '26', '196', '467', '116', '459', '127', '128', '448', '129', '130', '131', '103', '133', '134', '135', '94', '104', '105', '136', '137', '35', '120', '139', '38', '202', '7', '142', '143', '189', '177', '44', '49', '331', '216', '113', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.290_寂灭骨龙.png',
    traitName: '不朽',
    traitEffect: '力竭3回合后复活。',
  },
  {
    id: '296',
    name: '厉毒小萝',
    types: ['毒', '恶'],
    baseStats: { hp: 67, atk: 64, def: 81, spa: 17, spd: 59, spe: 108 },
    skills: ['7', '393', '243', '92', '182', '191', '219', '309', '151', '244', '338', '394', '298', '20', '112', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '156', '152', '337', '202', '107', '214', '155', '153', '206', '447', '200', '276', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.291_厉毒小萝.png',
    traitName: '侵蚀',
    traitEffect: '敌方每有1层中毒效果，自己获得连击数+1。',
  },
  {
    id: '297',
    name: '厉毒修萝',
    types: ['毒', '恶'],
    baseStats: { hp: 84, atk: 80, def: 101, spa: 21, spd: 74, spe: 135 },
    skills: ['7', '393', '243', '92', '182', '191', '219', '309', '151', '244', '338', '394', '298', '20', '112', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '156', '152', '337', '202', '107', '214', '155', '153', '206', '447', '200', '276', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.292_厉毒修萝.png',
    traitName: '侵蚀',
    traitEffect: '敌方每有1层中毒效果，自己获得连击数+1。',
  },
  {
    id: '298',
    name: '小帕尔',
    types: ['恶'],
    baseStats: { hp: 78, atk: 76, def: 79, spa: 34, spd: 52, spe: 60 },
    skills: ['7', '363', '3', '112', '187', '196', '191', '184', '194', '246', '185', '247', '111', '468', '20', '21', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '199', '459', '109', '83', '69', '293', '44', '100', '276', '113', '52', '467', '116', '446', '429'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.293_小帕尔.png',
    traitName: '付给恶魔的赎价',
    traitEffect: '击败敌方精灵时，敌方额外损失1点魔力。被敌方精灵击败时，自己额外损失1点魔力。',
  },
  {
    id: '299',
    name: '帕尔萨斯',
    types: ['恶'],
    baseStats: { hp: 104, atk: 102, def: 105, spa: 46, spd: 70, spe: 80 },
    skills: ['7', '363', '3', '112', '187', '196', '191', '184', '194', '246', '185', '247', '111', '468', '20', '21', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '199', '459', '109', '83', '69', '293', '44', '100', '276', '113', '52', '467', '116', '446', '429'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.294_帕尔萨斯.png',
    traitName: '付给恶魔的赎价',
    traitEffect: '击败敌方精灵时，敌方额外损失1点魔力。被敌方精灵击败时，自己额外损失1点魔力。',
  },
  {
    id: '300',
    name: '龙息帕尔',
    types: ['恶'],
    baseStats: { hp: 130, atk: 127, def: 131, spa: 57, spd: 87, spe: 100 },
    skills: ['7', '363', '3', '112', '187', '196', '191', '184', '194', '246', '185', '247', '111', '468', '20', '21', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '199', '459', '109', '83', '69', '293', '44', '100', '276', '113', '52', '467', '116', '446', '429'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.295_龙息帕尔.png',
    traitName: '付给恶魔的赎价',
    traitEffect: '击败敌方精灵时，敌方额外损失1点魔力。被敌方精灵击败时，自己额外损失1点魔力。',
  },
  {
    id: '301',
    name: '毛头小蛛',
    types: ['虫', '地'],
    baseStats: { hp: 85, atk: 80, def: 93, spa: 27, spd: 79, spe: 88 },
    skills: ['380', '386', '3', '258', '253', '322', '241', '238', '226', '359', '379', '228', '361', '127', '128', '22', '129', '130', '131', '132', '133', '134', '29', '94', '104', '105', '136', '51', '35', '120', '175', '156', '231', '337', '214', '232', '240', '26', '189', '135', '234', '137', '153', '227', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.296_毛头小蛛.png',
    traitName: '扫拖一体',
    traitEffect: '回合结束时驱散敌方1层印记，且驱散后己方队伍获得1次随机奉献。',
  },
  {
    id: '302',
    name: '捕尘长绒',
    types: ['虫', '地'],
    baseStats: { hp: 106, atk: 100, def: 116, spa: 34, spd: 99, spe: 110 },
    skills: ['380', '386', '3', '258', '253', '322', '241', '238', '226', '359', '379', '228', '361', '127', '128', '22', '129', '130', '131', '132', '133', '134', '29', '94', '104', '105', '136', '51', '35', '120', '175', '156', '231', '337', '214', '232', '240', '26', '189', '135', '234', '137', '153', '227', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.297_捕尘长绒.png',
    traitName: '扫拖一体',
    traitEffect: '回合结束时驱散敌方1层印记，且驱散后己方队伍获得1次随机奉献。',
  },
  {
    id: '303',
    name: '食尘短绒',
    types: ['虫', '地'],
    baseStats: { hp: 109, atk: 105, def: 113, spa: 37, spd: 97, spe: 115 },
    skills: ['380', '386', '3', '258', '253', '322', '241', '238', '226', '359', '379', '228', '361', '127', '128', '22', '129', '130', '131', '132', '133', '134', '29', '94', '104', '105', '136', '51', '35', '120', '175', '156', '231', '337', '214', '232', '240', '26', '189', '135', '234', '137', '153', '227', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.298_食尘短绒.png',
    traitName: '特殊清洁场景',
    traitEffect: '回合结束时偷取敌方1层印记。',
  },
  {
    id: '304',
    name: '画精灵',
    types: ['普通'],
    baseStats: { hp: 61, atk: 32, def: 56, spa: 78, spd: 72, spe: 72 },
    skills: ['55', '4', '3', '196', '7', '452', '157', '163', '83', '146', '153', '20', '21', '22', '23', '24', '25', '207', '27', '28', '29', '74', '31', '32', '33', '34', '35', '36', '37', '38', '166', '271', '277', '210', '26', '155', '315', '212', '349', '211', '103', '345', '217', '148', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.299_画精灵.png',
    traitName: '灰色肖像',
    traitEffect: '攻击会使敌方已有的减益层数+3。',
  },
  {
    id: '305',
    name: '画像守护',
    types: ['普通'],
    baseStats: { hp: 81, atk: 42, def: 75, spa: 104, spd: 96, spe: 96 },
    skills: ['55', '4', '3', '196', '7', '452', '157', '163', '83', '146', '153', '20', '21', '22', '23', '24', '25', '207', '27', '28', '29', '74', '31', '32', '33', '34', '35', '36', '37', '38', '166', '271', '277', '210', '26', '155', '315', '212', '349', '211', '103', '345', '217', '148', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.300_画像守护.png',
    traitName: '灰色肖像',
    traitEffect: '攻击会使敌方已有的减益层数+3。',
  },
  {
    id: '306',
    name: '画间法师手',
    types: ['普通', '幻'],
    baseStats: { hp: 101, atk: 53, def: 94, spa: 131, spd: 120, spe: 120 },
    skills: ['55', '4', '3', '196', '7', '452', '157', '163', '83', '146', '371', '353', '153', '375', '397', '20', '317', '22', '351', '174', '352', '207', '71', '72', '258', '74', '31', '32', '15', '51', '86', '170', '115', '38', '166', '130', '176', '277', '144', '369', '155', '315', '257', '44', '168', '349', '103', '345', '217', '77', '303', '148', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.301_画间法师手.png',
    traitName: '灰色肖像',
    traitEffect: '攻击会使敌方已有的减益层数+3。',
  },
  {
    id: '307',
    name: '画间沉铁兽',
    types: ['普通', '武'],
    baseStats: { hp: 100, atk: 160, def: 100, spa: 67, spd: 76, spe: 105 },
    skills: ['55', '4', '3', '196', '7', '452', '157', '163', '83', '340', '146', '159', '130', '153', '302', '432', '20', '21', '22', '23', '174', '25', '207', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '38', '166', '108', '277', '26', '155', '212', '371', '44', '339', '349', '103', '344', '391', '345', '217', '77', '276', '148', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.302_画间沉铁兽.png',
    traitName: '变形活画',
    traitEffect: '攻击时，敌方每有1层增益，本次技能威力+10%。',
  },
  {
    id: '308',
    name: '书魔虫',
    types: ['普通'],
    baseStats: { hp: 67, atk: 75, def: 48, spa: 75, spd: 73, spe: 57 },
    skills: ['416', '4', '3', '196', '163', '7', '345', '127', '289', '277', '276', '146', '20', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '35', '120', '115', '54', '152', '38', '142', '143', '375', '270', '341', '177', '349', '164', '218', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.303_书魔虫.png',
    traitName: '图书守卫者',
    traitEffect: '入场时，若自己魔力值为1，自己获得双攻+50%。',
  },
  {
    id: '309',
    name: '书卷守护',
    types: ['普通'],
    baseStats: { hp: 89, atk: 100, def: 64, spa: 100, spd: 98, spe: 76 },
    skills: ['416', '4', '3', '196', '163', '7', '345', '127', '289', '277', '276', '146', '20', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '35', '120', '115', '54', '152', '38', '142', '143', '375', '270', '341', '177', '349', '164', '218', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.304_书卷守护.png',
    traitName: '图书守卫者',
    traitEffect: '入场时，若自己魔力值为1，自己获得双攻+50%。',
  },
  {
    id: '310',
    name: '古卷执政官',
    types: ['普通', '幻'],
    baseStats: { hp: 111, atk: 125, def: 80, spa: 125, spd: 122, spe: 95 },
    skills: ['416', '4', '3', '196', '163', '7', '345', '127', '391', '136', '289', '277', '276', '146', '397', '20', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '15', '137', '35', '120', '115', '54', '152', '38', '176', '39', '375', '82', '270', '341', '177', '44', '349', '164', '218', '94', '179', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.305_古卷执政官.png',
    traitName: '图书守卫者',
    traitEffect: '入场时，若自己魔力值为1，自己获得双攻+50%。',
  },
  {
    id: '311',
    name: '古卷匣魔像',
    types: ['普通', '武'],
    baseStats: { hp: 114, atk: 109, def: 134, spa: 109, spd: 89, spe: 95 },
    skills: ['416', '4', '3', '196', '163', '7', '345', '218', '302', '130', '179', '289', '277', '276', '146', '20', '128', '22', '129', '174', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '35', '120', '175', '54', '152', '38', '176', '436', '143', '375', '444', '270', '272', '341', '177', '349', '164', '180', '127', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.306_古卷匣魔像.png',
    traitName: '构装契约者',
    traitEffect: '入场时，若敌方魔力值为1，自己获得双防+50%。',
  },
  {
    id: '312',
    name: '绒绒',
    types: ['光', '虫'],
    baseStats: { hp: 58, atk: 42, def: 49, spa: 44, spd: 80, spe: 69 },
    skills: ['280', '73', '282', '357', '250', '377', '7', '273', '12', '358', '322', '291', '5', '16', '74', '18', '54', '66', '22', '67', '68', '69', '70', '56', '72', '258', '30', '75', '259', '77', '78', '86', '79', '80', '214', '83', '155', '110', '84', '85', '262', '90', '379', '386', '264', '3', '198', '323', '4', '265'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.307_绒绒.png',
    traitName: '绒粉星光',
    traitEffect: '攻击时，若敌方血脉是非本系的系别血脉，技能威力+100%。',
  },
  {
    id: '313',
    name: '小绒茧',
    types: ['光', '虫'],
    baseStats: { hp: 77, atk: 56, def: 65, spa: 58, spd: 106, spe: 92 },
    skills: ['280', '73', '282', '357', '250', '377', '7', '273', '12', '358', '322', '291', '5', '16', '74', '18', '54', '66', '22', '67', '68', '69', '70', '56', '72', '258', '30', '75', '259', '77', '78', '86', '79', '80', '214', '83', '155', '110', '84', '85', '262', '90', '379', '386', '264', '3', '198', '323', '4', '265'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.308_小绒茧.png',
    traitName: '绒粉星光',
    traitEffect: '攻击时，若敌方血脉是非本系的系别血脉，技能威力+100%。',
  },
  {
    id: '314',
    name: '绒仙子',
    types: ['光', '虫'],
    baseStats: { hp: 96, atk: 71, def: 81, spa: 73, spd: 133, spe: 115 },
    skills: ['280', '73', '282', '357', '250', '377', '7', '273', '12', '358', '322', '291', '5', '16', '74', '18', '54', '66', '22', '67', '68', '69', '70', '56', '72', '258', '30', '75', '259', '77', '78', '86', '79', '80', '214', '83', '155', '110', '84', '85', '262', '90', '379', '386', '264', '3', '198', '323', '4', '265'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.309_绒仙子.png',
    traitName: '绒粉星光',
    traitEffect: '攻击时，若敌方血脉是非本系的系别血脉，技能威力+100%。',
  },
  {
    id: '315',
    name: '犀角鸟',
    types: ['光'],
    baseStats: { hp: 63, atk: 88, def: 67, spa: 40, spd: 44, spe: 66 },
    skills: ['7', '94', '196', '3', '12', '320', '156', '18', '153', '19', '155', '202', '1', '21', '22', '23', '24', '25', '103', '27', '13', '29', '30', '104', '105', '15', '51', '87', '36', '115', '106', '337', '230', '109', '444', '433', '371', '85', '416', '90', '80', '276', '198', '364'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.310_犀角鸟.png',
    traitName: '月光审判',
    traitEffect: '攻击时，若敌方血脉是首领血脉，技能威力+100%。',
  },
  {
    id: '316',
    name: '光纤兽',
    types: ['光'],
    baseStats: { hp: 83, atk: 117, def: 90, spa: 54, spd: 58, spe: 88 },
    skills: ['7', '94', '196', '3', '12', '320', '156', '18', '153', '19', '155', '202', '1', '21', '22', '23', '24', '25', '103', '27', '13', '29', '30', '104', '105', '15', '51', '87', '36', '115', '106', '337', '230', '109', '444', '433', '371', '85', '416', '90', '80', '276', '198', '364'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.311_光纤兽.png',
    traitName: '月光审判',
    traitEffect: '攻击时，若敌方血脉是首领血脉，技能威力+100%。',
  },
  {
    id: '317',
    name: '疾光千兽',
    types: ['光'],
    baseStats: { hp: 104, atk: 146, def: 112, spa: 67, spd: 73, spe: 110 },
    skills: ['7', '94', '196', '3', '12', '320', '156', '18', '153', '19', '155', '202', '1', '21', '22', '23', '24', '25', '103', '27', '13', '29', '30', '104', '105', '15', '51', '87', '36', '115', '106', '337', '230', '109', '444', '433', '371', '85', '416', '90', '80', '276', '198', '364'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.312_疾光千兽.png',
    traitName: '月光审判',
    traitEffect: '攻击时，若敌方血脉是首领血脉，技能威力+100%。',
  },
  {
    id: '318',
    name: '果冻',
    types: ['水'],
    baseStats: { hp: 81, atk: 26, def: 75, spa: 81, spd: 78, spe: 96 },
    skills: ['274', '122', '3', '273', '36', '123', '170', '9', '204', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '87', '138', '139', '7', '109', '40', '205', '121', '173', '146', '79', '218', '163', '114', '4'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.313_果冻.png',
    traitName: '茶多酚',
    traitEffect: '离场后，更换入场的精灵回复20%生命且免疫寄生。',
  },
  {
    id: '319',
    name: '抹茶布丁',
    types: ['水', '草'],
    baseStats: { hp: 101, atk: 32, def: 94, spa: 101, spd: 98, spe: 120 },
    skills: ['274', '122', '3', '273', '36', '123', '170', '9', '204', '286', '133', '8', '57', '127', '128', '22', '129', '130', '131', '132', '71', '134', '135', '74', '31', '32', '136', '137', '87', '138', '139', '65', '7', '109', '40', '233', '205', '121', '173', '263', '146', '91', '79', '218', '163', '114', '4', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.314_抹茶布丁.png',
    traitName: '茶多酚',
    traitEffect: '离场后，更换入场的精灵回复20%生命且免疫寄生。',
  },
  {
    id: '320',
    name: '椰浆布丁',
    types: ['水', '冰'],
    baseStats: { hp: 133, atk: 34, def: 81, spa: 89, spd: 105, spe: 120 },
    skills: ['274', '122', '3', '273', '36', '123', '170', '9', '204', '401', '412', '28', '41', '127', '128', '22', '129', '130', '131', '132', '133', '13', '135', '74', '31', '32', '136', '137', '87', '138', '139', '140', '7', '109', '40', '422', '233', '205', '121', '173', '263', '146', '79', '218', '163', '114', '4', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.315_椰浆布丁.png',
    traitName: '吉利丁片',
    traitEffect: '离场后，更换入场的精灵获得双防+20%且免疫冻结。',
  },
  {
    id: '321',
    name: '熔岩布丁',
    types: ['水', '火'],
    baseStats: { hp: 128, atk: 87, def: 112, spa: 33, spd: 84, spe: 120 },
    skills: ['274', '122', '3', '273', '36', '123', '170', '9', '204', '42', '434', '97', '131', '127', '128', '22', '129', '130', '6', '132', '133', '134', '135', '74', '31', '32', '136', '137', '87', '138', '139', '7', '98', '109', '40', '233', '205', '121', '173', '146', '79', '218', '163', '254', '114', '295', '4', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.316_熔岩布丁.png',
    traitName: '美拉德反应',
    traitEffect: '离场后，更换入场的精灵获得双攻+20%且免疫灼烧。',
  },
  {
    id: '322',
    name: '星尘虫',
    types: ['虫'],
    baseStats: { hp: 49, atk: 47, def: 46, spa: 47, spd: 58, spe: 60 },
    skills: ['3', '377', '283', '323', '73', '251', '54', '135', '380', '253', '196', '379', '255', '360', '142', '290', '127', '128', '22', '129', '130', '131', '132', '133', '134', '258', '74', '31', '32', '136', '137', '35', '120', '139', '245', '38', '230', '39', '238', '288', '44', '220', '153', '221', '224', '416', '223', '359', '303', '225'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.317_星尘虫.png',
    traitName: '契约的形状',
    traitEffect: '根据捕捉所用的咕噜球，入场时获得不同效果。',
  },
  {
    id: '323',
    name: '落星虫',
    types: ['虫'],
    baseStats: { hp: 65, atk: 62, def: 61, spa: 62, spd: 77, spe: 80 },
    skills: ['3', '377', '283', '323', '73', '251', '54', '135', '380', '253', '196', '379', '255', '360', '142', '290', '127', '128', '22', '129', '130', '131', '132', '133', '134', '258', '74', '31', '32', '136', '137', '35', '120', '139', '245', '38', '230', '39', '238', '288', '44', '220', '153', '221', '224', '416', '223', '359', '303', '225'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.318_落星虫.png',
    traitName: '契约的形状',
    traitEffect: '根据捕捉所用的咕噜球，入场时获得不同效果。',
  },
  {
    id: '324',
    name: '陨星虫',
    types: ['虫'],
    baseStats: { hp: 81, atk: 78, def: 76, spa: 78, spd: 96, spe: 100 },
    skills: ['3', '377', '283', '323', '73', '251', '54', '135', '380', '253', '196', '379', '255', '360', '142', '290', '127', '128', '22', '129', '130', '131', '132', '133', '134', '258', '74', '31', '32', '136', '137', '35', '120', '139', '245', '38', '230', '39', '238', '288', '44', '220', '153', '221', '224', '416', '223', '359', '303', '225'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.319_陨星虫.png',
    traitName: '契约的形状',
    traitEffect: '根据捕捉所用的咕噜球，入场时获得不同效果。',
  },
  {
    id: '325',
    name: '双灯鱼',
    types: ['水', '电'],
    baseStats: { hp: 102, atk: 55, def: 57, spa: 111, spd: 93, spe: 84 },
    skills: ['4', '274', '399', '454', '217', '47', '337', '125', '462', '334', '329', '172', '332', '145', '20', '317', '22', '333', '174', '352', '103', '71', '72', '258', '74', '31', '32', '353', '51', '87', '138', '115', '187', '38', '155', '315', '348', '272', '84', '124', '283', '298', '95', '3', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.320_双灯鱼.png',
    traitName: '对流',
    traitEffect: '自己的能耗增加变为能耗降低；能耗降低变为能耗增加。',
  },
  {
    id: '326',
    name: '利灯鱼',
    types: ['水', '电'],
    baseStats: { hp: 128, atk: 68, def: 71, spa: 138, spd: 116, spe: 105 },
    skills: ['4', '274', '399', '454', '217', '47', '337', '125', '462', '334', '329', '172', '332', '145', '20', '317', '22', '333', '174', '352', '103', '71', '72', '258', '74', '31', '32', '353', '51', '87', '138', '115', '187', '38', '155', '315', '348', '272', '84', '124', '283', '298', '95', '3', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.321_利灯鱼.png',
    traitName: '对流',
    traitEffect: '自己的能耗增加变为能耗降低；能耗降低变为能耗增加。',
  },
  {
    id: '327',
    name: '月牙雪熊',
    types: ['冰', '幻'],
    baseStats: { hp: 126, atk: 97, def: 141, spa: 39, spd: 103, spe: 80 },
    skills: ['3', '408', '416', '387', '72', '405', '410', '396', '136', '391', '141', '374', '203', '127', '128', '22', '129', '130', '131', '132', '133', '13', '135', '94', '104', '105', '15', '137', '87', '120', '175', '202', '196', '140', '7', '108', '142', '238', '109', '177', '218', '77', '409', '382'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.322_月牙雪熊.png',
    traitName: '月牙雪糕',
    traitEffect: '使用攻击技能时，敌方每层冻结视为1层额外星陨印记。',
  },
  {
    id: '328',
    name: '嗜光嗡嗡',
    types: ['恶', '光'],
    baseStats: { hp: 75, atk: 83, def: 50, spa: 83, spd: 90, spe: 92 },
    skills: ['4', '366', '317', '66', '363', '12', '5', '107', '196', '190', '17', '18', '469', '368', '298', '118', '112', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '337', '320', '7', '318', '109', '258', '185', '262', '153', '93', '290', '359', '322', '219', '276', '3', '114', '194'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.323_嗜光嗡嗡.png',
    traitName: '血型吸引',
    traitEffect: '敌方每携带1种系别的技能，自己攻击时威力+10。',
  },
  {
    id: '329',
    name: '窃光蚊',
    types: ['恶', '光'],
    baseStats: { hp: 93, atk: 104, def: 63, spa: 104, spd: 113, spe: 115 },
    skills: ['4', '366', '317', '66', '363', '12', '5', '107', '196', '190', '17', '18', '469', '368', '298', '118', '112', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '337', '320', '7', '318', '109', '258', '185', '262', '153', '93', '290', '359', '322', '219', '276', '3', '114', '194'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.324_窃光蚊.png',
    traitName: '血型吸引',
    traitEffect: '敌方每携带1种系别的技能，自己攻击时威力+10。',
  },
  {
    id: '330',
    name: '柴渣虫',
    types: ['火', '草'],
    baseStats: { hp: 108, atk: 96, def: 82, spa: 38, spd: 58, spe: 80 },
    skills: ['3', '208', '25', '295', '69', '131', '296', '424', '91', '50', '58', '437', '43', '127', '128', '22', '129', '130', '6', '132', '71', '134', '135', '74', '31', '32', '136', '137', '87', '138', '139', '337', '7', '143', '109', '102', '189', '177', '434', '89', '133', '218', '151', '242', '285'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.325_柴渣虫.png',
    traitName: '煤渣草',
    traitEffect: '在场时，所有灼烧的衰减变为增长。',
  },
  {
    id: '331',
    name: '燃薪虫',
    types: ['火', '草'],
    baseStats: { hp: 135, atk: 120, def: 103, spa: 48, spd: 73, spe: 100 },
    skills: ['3', '208', '25', '295', '69', '131', '296', '424', '91', '50', '58', '437', '43', '127', '128', '22', '129', '130', '6', '132', '71', '134', '135', '74', '31', '32', '136', '137', '87', '138', '139', '337', '7', '143', '109', '102', '189', '177', '434', '89', '133', '218', '151', '242', '285'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.326_燃薪虫.png',
    traitName: '煤渣草',
    traitEffect: '在场时，所有灼烧的衰减变为增长。',
  },
  {
    id: '332',
    name: '空空颅',
    types: ['幽'],
    baseStats: { hp: 70, atk: 7, def: 54, spa: 37, spd: 64, spe: 48 },
    skills: ['3', '103', '70', '211', '4', '304', '85', '269', '210', '314', '181', '212', '155', '118', '21', '22', '23', '24', '25', '207', '27', '28', '29', '74', '31', '32', '33', '34', '35', '36', '37', '187', '337', '214', '144', '42', '99', '272', '311', '465', '146', '90', '298', '439', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.327_空空颅.png',
    traitName: '搜刮',
    traitEffect: '敌方每使用1次【聚能】技能或更换精灵，自己入场时获得魔攻+20%。',
  },
  {
    id: '333',
    name: '夜宿颅',
    types: ['幽'],
    baseStats: { hp: 94, atk: 9, def: 72, spa: 49, spd: 85, spe: 64 },
    skills: ['3', '103', '70', '211', '4', '304', '85', '269', '210', '314', '181', '212', '155', '118', '21', '22', '23', '24', '25', '207', '27', '28', '29', '74', '31', '32', '33', '34', '35', '36', '37', '187', '337', '214', '144', '42', '99', '272', '311', '465', '146', '90', '298', '439', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.328_夜宿颅.png',
    traitName: '搜刮',
    traitEffect: '敌方每使用1次【聚能】技能或更换精灵，自己入场时获得魔攻+20%。',
  },
  {
    id: '334',
    name: '夜枭',
    types: ['幽'],
    baseStats: { hp: 117, atk: 10, def: 90, spa: 61, spd: 106, spe: 80 },
    skills: ['3', '103', '70', '211', '4', '304', '85', '269', '210', '314', '181', '212', '155', '118', '21', '22', '23', '24', '25', '207', '27', '28', '29', '74', '31', '32', '33', '34', '35', '36', '37', '187', '337', '214', '144', '42', '99', '272', '311', '465', '146', '90', '298', '439', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.329_夜枭.png',
    traitName: '搜刮',
    traitEffect: '敌方每使用1次【聚能】技能或更换精灵，自己入场时获得魔攻+20%。',
  },
  {
    id: '335',
    name: '粉粉星',
    types: ['电', '幻'],
    baseStats: { hp: 93, atk: 54, def: 57, spa: 102, spd: 101, spe: 88 },
    skills: ['10', '371', '331', '353', '4', '327', '299', '375', '326', '329', '77', '349', '67', '20', '66', '22', '333', '68', '69', '70', '56', '72', '73', '74', '75', '76', '15', '78', '86', '79', '80', '370', '38', '454', '142', '39', '82', '83', '369', '155', '85', '90', '192', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.330_粉粉星.png',
    traitName: '星地善良',
    traitEffect: '回合结束时，若场上的己方精灵能量等于0，自己立即替换此精灵。',
  },
  {
    id: '336',
    name: '小皮球',
    types: ['电', '幻'],
    baseStats: { hp: 116, atk: 68, def: 71, spa: 127, spd: 126, spe: 110 },
    skills: ['10', '371', '331', '353', '4', '327', '299', '375', '326', '329', '77', '349', '67', '20', '66', '22', '333', '68', '69', '70', '56', '72', '73', '74', '75', '76', '15', '78', '86', '79', '80', '370', '38', '454', '142', '39', '82', '83', '369', '155', '85', '90', '192', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.331_小皮球.png',
    traitName: '星地善良',
    traitEffect: '回合结束时，若场上的己方精灵能量等于0，自己立即替换此精灵。',
  },
  {
    id: '337',
    name: '贝瑟',
    types: ['机械', '火'],
    baseStats: { hp: 79, atk: 46, def: 51, spa: 78, spd: 98, spe: 33 },
    skills: ['31', '406', '455', '419', '69', '311', '294', '3', '337', '421', '465', '426', '438', '20', '66', '22', '67', '68', '6', '103', '56', '72', '73', '74', '407', '76', '77', '78', '86', '79', '80', '157', '370', '424', '214', '75', '381', '177', '371', '85', '44', '131', '101', '313', '4', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.332_贝瑟.png',
    traitName: '贪心算法',
    traitEffect: '1号位技能获得传动1，且使用后使敌方获得6层灼烧。',
  },
  {
    id: '338',
    name: '贝加尔',
    types: ['机械', '火'],
    baseStats: { hp: 105, atk: 61, def: 68, spa: 104, spd: 130, spe: 44 },
    skills: ['31', '406', '455', '419', '69', '311', '294', '3', '337', '421', '465', '426', '438', '20', '66', '22', '67', '68', '6', '103', '56', '72', '73', '74', '407', '76', '77', '78', '86', '79', '80', '157', '370', '424', '214', '75', '381', '177', '371', '85', '44', '131', '101', '313', '4', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.333_贝加尔.png',
    traitName: '贪心算法',
    traitEffect: '1号位技能获得传动1，且使用后使敌方获得6层灼烧。',
  },
  {
    id: '339',
    name: '贝古斯',
    types: ['机械', '火'],
    baseStats: { hp: 132, atk: 76, def: 85, spa: 130, spd: 163, spe: 55 },
    skills: ['31', '406', '455', '419', '69', '311', '294', '3', '337', '421', '465', '426', '438', '20', '66', '22', '67', '68', '6', '103', '56', '72', '73', '74', '407', '76', '77', '78', '86', '79', '80', '157', '370', '424', '214', '75', '381', '177', '371', '85', '44', '131', '101', '313', '4', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.334_贝古斯.png',
    traitName: '贪心算法',
    traitEffect: '1号位技能获得传动1，且使用后使敌方获得6层灼烧。',
  },
  {
    id: '340',
    name: '粉星仔',
    types: ['幻'],
    baseStats: { hp: 80, atk: 63, def: 58, spa: 119, spd: 102, spe: 92 },
    skills: ['118', '371', '3', '375', '4', '39', '77', '144', '370', '54', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '15', '78', '86', '79', '80', '38', '142', '143', '261', '85', '316', '48', '101', '90'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.335_粉星仔.png',
    traitName: '双向光速',
    traitEffect: '在场时，所有回合结束时触发，触发次数+1。',
  },
  {
    id: '341',
    name: '粉耳星兔',
    types: ['幻'],
    baseStats: { hp: 100, atk: 79, def: 73, spa: 148, spd: 127, spe: 115 },
    skills: ['118', '371', '3', '375', '4', '39', '77', '144', '370', '390', '304', '152', '369', '54', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '15', '78', '86', '79', '80', '38', '142', '143', '61', '155', '261', '85', '145', '316', '48', '101', '90', '93'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.336_粉耳星兔.png',
    traitName: '双向光速',
    traitEffect: '在场时，所有回合结束时触发，触发次数+1。',
  },
  {
    id: '342',
    name: '落陨星兔',
    types: ['幻', '幽'],
    baseStats: { hp: 93, atk: 61, def: 87, spa: 125, spd: 141, spe: 130 },
    skills: ['118', '371', '3', '375', '4', '39', '77', '144', '370', '315', '210', '211', '183', '181', '54', '66', '22', '67', '68', '69', '103', '56', '72', '73', '74', '75', '76', '15', '78', '86', '79', '115', '152', '38', '142', '369', '155', '261', '85', '44', '316', '48', '101', '90', '132'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.337_落陨星兔.png',
    traitName: '陨落',
    traitEffect: '在场时，双方回合结束时触发的效果，触发次数-1。',
  },
  {
    id: '343',
    name: '布瓜蝌',
    types: ['幻'],
    baseStats: { hp: 91, atk: 84, def: 81, spa: 35, spd: 55, spe: 96 },
    skills: ['416', '7', '389', '163', '3', '391', '371', '390', '202', '374', '369', '370', '245', '20', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '15', '51', '87', '170', '115', '106', '54', '38', '214', '232', '109', '155', '110', '12', '221', '279', '382', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.338_布瓜蝌.png',
    traitName: '张弛有度',
    traitEffect: '周末时自己获得双攻+40%，其他时间获得双防+40%。',
  },
  {
    id: '344',
    name: '上岸蛙',
    types: ['幻'],
    baseStats: { hp: 114, atk: 106, def: 101, spa: 44, spd: 69, spe: 120 },
    skills: ['416', '7', '389', '163', '3', '391', '371', '390', '202', '374', '369', '370', '245', '20', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '15', '51', '87', '170', '115', '106', '54', '38', '214', '232', '109', '155', '110', '12', '221', '279', '382', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.339_上岸蛙.png',
    traitName: '张弛有度',
    traitEffect: '周末时自己获得双攻+40%，其他时间获得双防+40%。',
  },
  {
    id: '345',
    name: '火红尾',
    types: ['火'],
    baseStats: { hp: 67, atk: 56, def: 70, spa: 129, spd: 89, spe: 100 },
    skills: ['464', '4', '427', '3', '312', '69', '283', '437', '424', '439', '294', '99', '426', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '5', '454', '82', '269', '332', '155', '85', '385', '146', '10', '303', '2'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.340_火红尾.png',
    traitName: '天通地明',
    traitEffect: '攻击时，若敌方血脉是污染血脉，技能威力+100%。',
  },
  {
    id: '346',
    name: '雅丹鬃',
    types: ['火'],
    baseStats: { hp: 83, atk: 70, def: 88, spa: 162, spd: 111, spe: 125 },
    skills: ['464', '4', '427', '3', '312', '69', '283', '437', '424', '439', '294', '99', '426', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '5', '454', '82', '269', '332', '155', '85', '385', '146', '10', '303', '2'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.341_雅丹鬃.png',
    traitName: '天通地明',
    traitEffect: '攻击时，若敌方血脉是污染血脉，技能威力+100%。',
  },
  {
    id: '347',
    name: '春团',
    types: ['草'],
    baseStats: { hp: 48, atk: 51, def: 65, spa: 57, spd: 57, spe: 63 },
    skills: ['209', '85', '3', '95', '268', '447', '54', '58', '8', '89', '59', '61', '43', '188', '193', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '259', '77', '78', '86', '79', '80', '337', '7', '130', '176', '109', '83', '177', '339', '76', '60', '235', '263', '192', '418', '254', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.342_春团.png',
    traitName: '系统发育',
    traitEffect: '获得能量或生命时，会将等量的能量或生命随机分配给场下的精灵。',
  },
  {
    id: '348',
    name: '春兔',
    types: ['草'],
    baseStats: { hp: 63, atk: 68, def: 87, spa: 76, spd: 77, spe: 84 },
    skills: ['209', '85', '3', '95', '268', '447', '54', '58', '8', '89', '59', '61', '43', '188', '193', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '259', '77', '78', '86', '79', '80', '337', '7', '130', '176', '109', '83', '177', '339', '76', '60', '235', '263', '192', '418', '254', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.343_春兔.png',
    traitName: '系统发育',
    traitEffect: '获得能量或生命时，会将等量的能量或生命随机分配给场下的精灵。',
  },
  {
    id: '349',
    name: '春花兔',
    types: ['草'],
    baseStats: { hp: 79, atk: 85, def: 103, spa: 95, spd: 90, spe: 105 },
    skills: ['209', '85', '3', '95', '268', '447', '54', '58', '8', '89', '59', '61', '43', '188', '193', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '259', '77', '78', '86', '79', '80', '337', '7', '130', '176', '109', '83', '177', '339', '76', '60', '235', '263', '192', '418', '254', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.344_春花兔.png',
    traitName: '系统发育',
    traitEffect: '获得能量或生命时，会将等量的能量或生命随机分配给场下的精灵。',
  },
  {
    id: '350',
    name: '幽星光',
    types: ['幻'],
    baseStats: { hp: 49, atk: 21, def: 48, spa: 63, spd: 63, spe: 75 },
    skills: ['4', '265', '353', '364', '196', '106', '375', '77', '167', '370', '39', '169', '397', '20', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '15', '51', '87', '170', '115', '38', '337', '210', '381', '144', '82', '369', '315', '153', '303', '264', '3', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.345_幽星光.png',
    traitName: '守望星',
    traitEffect: '触发星陨时消耗一半层数，仍造成满层伤害。',
  },
  {
    id: '351',
    name: '曜星光',
    types: ['幻', '翼'],
    baseStats: { hp: 65, atk: 28, def: 64, spa: 84, spd: 84, spe: 100 },
    skills: ['4', '265', '353', '364', '196', '106', '375', '77', '167', '370', '39', '169', '397', '20', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '15', '51', '87', '170', '115', '38', '337', '210', '381', '144', '82', '369', '315', '153', '303', '264', '3', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.346_曜星光.png',
    traitName: '守望星',
    traitEffect: '触发星陨时消耗一半层数，仍造成满层伤害。',
  },
  {
    id: '352',
    name: '暮星辰',
    types: ['幻', '翼'],
    baseStats: { hp: 81, atk: 35, def: 80, spa: 106, spd: 105, spe: 125 },
    skills: ['4', '265', '353', '364', '196', '106', '375', '77', '167', '370', '39', '169', '397', '20', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '15', '51', '87', '170', '115', '38', '337', '210', '381', '144', '82', '369', '315', '153', '303', '264', '3', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.347_暮星辰.png',
    traitName: '守望星',
    traitEffect: '触发星陨时消耗一半层数，仍造成满层伤害。',
  },
  {
    id: '353',
    name: '板板壳（蜕皮时的样子）',
    types: ['水'],
    baseStats: { hp: 88, atk: 24, def: 56, spa: 72, spd: 59, spe: 48 },
    skills: ['170', '3', '4', '45', '122', '171', '120', '172', '125', '121', '123', '40', '173', '20', '128', '22', '129', '174', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '87', '138', '175', '68', '176', '109', '177', '44', '8', '168', '178', '146', '58', '127', '179', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.012_板板壳（蜕皮时的样子）.png',
    traitName: '缩壳',
    traitEffect: '携带的防御技能能耗-2。',
  },
  {
    id: '354',
    name: '咔咔壳（蜕皮时的样子）',
    types: ['水'],
    baseStats: { hp: 117, atk: 31, def: 75, spa: 96, spd: 79, spe: 64 },
    skills: ['170', '3', '4', '45', '122', '171', '120', '172', '125', '121', '123', '40', '173', '20', '128', '22', '129', '174', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '87', '138', '175', '68', '176', '109', '177', '44', '8', '168', '178', '146', '58', '127', '179', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.013_咔咔壳（蜕皮时的样子）.png',
    traitName: '缩壳',
    traitEffect: '携带的防御技能能耗-2。',
  },
  {
    id: '355',
    name: '水泡壳（蜕皮时的样子）',
    types: ['水'],
    baseStats: { hp: 146, atk: 39, def: 93, spa: 121, spd: 98, spe: 80 },
    skills: ['170', '3', '4', '45', '122', '171', '120', '172', '125', '121', '123', '40', '173', '20', '128', '22', '129', '174', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '87', '138', '175', '68', '176', '109', '177', '44', '8', '168', '178', '146', '58', '127', '179', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.014_水泡壳（蜕皮时的样子）.png',
    traitName: '缩壳',
    traitEffect: '携带的防御技能能耗-2。',
  },
  {
    id: '356',
    name: '雪绒鸟（春天的样子）',
    types: ['翼'],
    baseStats: { hp: 56, atk: 77, def: 58, spa: 26, spd: 49, spe: 69 },
    skills: ['195', '7', '196', '106', '3', '110', '80', '197', '198', '199', '155', '200', '117', '20', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '201', '152', '38', '202', '43', '182', '44', '204', '205', '9', '153', '206', '89', '59', '79'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.018_雪绒鸟（春天的样子）.png',
    traitName: '顺风',
    traitEffect: '若先于敌方攻击，本次技能威力+50%。',
  },
  {
    id: '357',
    name: '雪绒鸟（夏天的样子）',
    types: ['翼'],
    baseStats: { hp: 59, atk: 80, def: 58, spa: 32, spd: 41, spe: 69 },
    skills: ['195', '7', '196', '106', '3', '110', '80', '197', '198', '199', '155', '200', '117', '20', '21', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '201', '152', '38', '202', '42', '182', '44', '204', '205', '9', '153', '206', '79', '52', '295'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.018_雪绒鸟（夏天的样子）.png',
    traitName: '顺风',
    traitEffect: '若先于敌方攻击，本次技能威力+50%。',
  },
  {
    id: '358',
    name: '雪绒鸟（秋天的样子）',
    types: ['翼'],
    baseStats: { hp: 54, atk: 76, def: 59, spa: 25, spd: 51, spe: 69 },
    skills: ['195', '7', '196', '106', '3', '110', '80', '197', '198', '199', '155', '200', '117', '20', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '201', '152', '38', '202', '182', '44', '204', '205', '78', '9', '153', '206', '221', '79', '279'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.018_雪绒鸟（秋天的样子）.png',
    traitName: '顺风',
    traitEffect: '若先于敌方攻击，本次技能威力+50%。',
  },
  {
    id: '359',
    name: '冬羽雀（春天的样子）',
    types: ['翼'],
    baseStats: { hp: 75, atk: 103, def: 78, spa: 35, spd: 65, spe: 92 },
    skills: ['195', '7', '196', '106', '3', '110', '80', '197', '198', '199', '155', '200', '117', '20', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '201', '152', '38', '202', '43', '182', '44', '204', '205', '9', '153', '206', '89', '59', '79'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.019_冬羽雀（春天的样子）.png',
    traitName: '顺风',
    traitEffect: '若先于敌方攻击，本次技能威力+50%。',
  },
  {
    id: '360',
    name: '冬羽雀（夏天的样子）',
    types: ['翼'],
    baseStats: { hp: 79, atk: 107, def: 77, spa: 43, spd: 55, spe: 92 },
    skills: ['195', '7', '196', '106', '3', '110', '80', '197', '198', '199', '155', '200', '117', '20', '21', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '201', '152', '38', '202', '42', '182', '44', '204', '205', '9', '153', '206', '79', '52', '295'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.019_冬羽雀（夏天的样子）.png',
    traitName: '顺风',
    traitEffect: '若先于敌方攻击，本次技能威力+50%。',
  },
  {
    id: '361',
    name: '冬羽雀（秋天的样子）',
    types: ['翼'],
    baseStats: { hp: 72, atk: 102, def: 78, spa: 34, spd: 68, spe: 92 },
    skills: ['195', '7', '196', '106', '3', '110', '80', '197', '198', '199', '155', '200', '117', '20', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '201', '152', '38', '202', '182', '44', '204', '205', '78', '9', '153', '206', '221', '79', '279'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.019_冬羽雀（秋天的样子）.png',
    traitName: '顺风',
    traitEffect: '若先于敌方攻击，本次技能威力+50%。',
  },
  {
    id: '362',
    name: '岚鸟（春天的样子）',
    types: ['翼'],
    baseStats: { hp: 93, atk: 128, def: 97, spa: 44, spd: 81, spe: 115 },
    skills: ['195', '7', '196', '106', '3', '110', '80', '197', '198', '199', '155', '200', '117', '20', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '201', '152', '38', '202', '43', '182', '44', '204', '205', '9', '153', '206', '89', '59', '79'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.020_岚鸟（春天的样子）.png',
    traitName: '顺风',
    traitEffect: '若先于敌方攻击，本次技能威力+50%。',
  },
  {
    id: '363',
    name: '岚鸟（夏天的样子）',
    types: ['翼'],
    baseStats: { hp: 99, atk: 133, def: 96, spa: 54, spd: 69, spe: 115 },
    skills: ['195', '7', '196', '106', '3', '110', '80', '197', '198', '199', '155', '200', '117', '20', '21', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '201', '152', '38', '202', '42', '182', '44', '204', '205', '9', '153', '206', '79', '52', '295'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.020_岚鸟（夏天的样子）.png',
    traitName: '顺风',
    traitEffect: '若先于敌方攻击，本次技能威力+50%。',
  },
  {
    id: '364',
    name: '岚鸟（秋天的样子）',
    types: ['翼'],
    baseStats: { hp: 90, atk: 127, def: 98, spa: 42, spd: 85, spe: 115 },
    skills: ['195', '7', '196', '106', '3', '110', '80', '197', '198', '199', '155', '200', '117', '20', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '201', '152', '38', '202', '182', '44', '204', '205', '78', '9', '153', '206', '221', '79', '279'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.020_岚鸟（秋天的样子）.png',
    traitName: '顺风',
    traitEffect: '若先于敌方攻击，本次技能威力+50%。',
  },
  {
    id: '365',
    name: '石肤蜥（球球尾巴的样子）',
    types: ['地'],
    baseStats: { hp: 68, atk: 54, def: 64, spa: 53, spd: 44, spe: 60 },
    skills: ['3', '220', '221', '162', '222', '223', '224', '225', '226', '227', '158', '228', '218', '229', '230', '20', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '51', '35', '120', '175', '231', '7', '171', '143', '232', '109', '233', '177', '234', '88', '235', '105', '92', '93', '127'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.024_石肤蜥（球球尾巴的样子）.png',
    traitName: '刺肤',
    traitEffect: '每受到1次攻击，对攻击自己的精灵造成50威力物理伤害。',
  },
  {
    id: '366',
    name: '石刺蜥（球球尾巴的样子）',
    types: ['地'],
    baseStats: { hp: 91, atk: 72, def: 85, spa: 71, spd: 59, spe: 80 },
    skills: ['3', '220', '221', '162', '222', '223', '224', '225', '226', '227', '158', '228', '218', '229', '230', '20', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '51', '35', '120', '175', '231', '7', '171', '143', '232', '109', '233', '177', '234', '88', '235', '105', '92', '93', '127'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.025_石刺蜥（球球尾巴的样子）.png',
    traitName: '刺肤',
    traitEffect: '每受到1次攻击，对攻击自己的精灵造成50威力物理伤害。',
  },
  {
    id: '367',
    name: '石冠王蜥（球球尾巴的样子）',
    types: ['地'],
    baseStats: { hp: 113, atk: 90, def: 106, spa: 89, spd: 74, spe: 100 },
    skills: ['3', '220', '221', '162', '222', '223', '224', '225', '226', '227', '158', '228', '218', '229', '230', '20', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '51', '35', '120', '175', '231', '7', '171', '143', '232', '109', '233', '177', '234', '88', '235', '105', '92', '93', '127'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.026_石冠王蜥（球球尾巴的样子）.png',
    traitName: '刺肤',
    traitEffect: '每受到1次攻击，对攻击自己的精灵造成50威力物理伤害。',
  },
  {
    id: '368',
    name: '化蝶（幽冥眼的样子）',
    types: ['虫', '萌'],
    baseStats: { hp: 43, atk: 42, def: 67, spa: 42, spd: 70, spe: 105 },
    skills: ['248', '249', '3', '29', '250', '251', '252', '135', '32', '253', '254', '76', '255', '256', '257', '54', '66', '22', '67', '68', '69', '70', '56', '72', '258', '74', '75', '259', '77', '78', '86', '79', '80', '260', '214', '150', '143', '83', '155', '84', '261', '85', '234', '262', '263', '90', '264', '197', '265'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.034_化蝶（幽冥眼的样子）.png',
    traitName: '化茧',
    traitEffect: '受到致命伤害时，获得1层萌化，并免疫此次伤害。',
  },
  {
    id: '369',
    name: '化蝶（喵喵的样子）',
    types: ['虫', '萌'],
    baseStats: { hp: 49, atk: 47, def: 67, spa: 41, spd: 67, spe: 95 },
    skills: ['248', '249', '3', '29', '250', '251', '252', '135', '32', '253', '254', '76', '255', '256', '257', '54', '66', '22', '67', '68', '69', '70', '56', '72', '258', '74', '75', '259', '77', '78', '86', '79', '80', '260', '214', '150', '143', '83', '155', '84', '261', '85', '234', '262', '263', '90', '264', '197', '265'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.034_化蝶（喵喵的样子）.png',
    traitName: '化茧',
    traitEffect: '受到致命伤害时，获得1层萌化，并免疫此次伤害。',
  },
  {
    id: '370',
    name: '化蝶（奇丽花的样子）',
    types: ['虫', '萌'],
    baseStats: { hp: 55, atk: 46, def: 62, spa: 44, spd: 65, spe: 90 },
    skills: ['248', '249', '3', '29', '250', '251', '252', '135', '32', '253', '254', '76', '255', '256', '257', '54', '66', '22', '67', '68', '69', '70', '56', '72', '258', '74', '75', '259', '77', '78', '86', '79', '80', '260', '214', '150', '143', '83', '155', '84', '261', '85', '234', '262', '263', '90', '264', '197', '265'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.034_化蝶（奇丽花的样子）.png',
    traitName: '化茧',
    traitEffect: '受到致命伤害时，获得1层萌化，并免疫此次伤害。',
  },
  {
    id: '371',
    name: '晶石蜗（莲花刚玉的样子）',
    types: ['光', '地'],
    baseStats: { hp: 94, atk: 97, def: 137, spa: 101, spd: 91, spe: 65 },
    skills: ['4', '280', '137', '281', '12', '94', '237', '238', '34', '51', '282', '162', '11', '232', '127', '128', '22', '129', '130', '131', '132', '58', '134', '258', '30', '31', '32', '136', '220', '35', '120', '175', '202', '230', '171', '143', '109', '82', '233', '335', '44', '263', '283', '133', '218', '284', '227', '113', '3', '279'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.040_晶石蜗（莲花刚玉的样子）.png',
    traitName: '偏振',
    traitEffect: '受到自己携带技能系别的攻击伤害-40%。',
  },
  {
    id: '372',
    name: '晶石蜗（星彩榴石的样子）',
    types: ['光', '地'],
    baseStats: { hp: 97, atk: 101, def: 128, spa: 101, spd: 91, spe: 65 },
    skills: ['4', '280', '137', '281', '12', '94', '237', '238', '34', '51', '282', '162', '11', '232', '127', '128', '22', '129', '130', '434', '132', '133', '134', '258', '30', '31', '32', '136', '220', '35', '120', '175', '202', '230', '171', '98', '143', '109', '82', '44', '131', '312', '283', '180', '218', '284', '227', '113', '3', '279'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.040_晶石蜗（星彩榴石的样子）.png',
    traitName: '偏振',
    traitEffect: '受到自己携带技能系别的攻击伤害-40%。',
  },
  {
    id: '373',
    name: '晶石蜗（火山琉璃的样子）',
    types: ['光', '地'],
    baseStats: { hp: 97, atk: 97, def: 132, spa: 101, spd: 91, spe: 65 },
    skills: ['4', '280', '137', '281', '12', '94', '237', '238', '34', '51', '282', '162', '11', '232', '127', '128', '22', '129', '130', '131', '132', '133', '134', '258', '30', '31', '32', '136', '220', '35', '120', '175', '213', '202', '230', '171', '143', '109', '82', '315', '189', '44', '211', '283', '218', '284', '227', '113', '3', '279'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.040_晶石蜗（火山琉璃的样子）.png',
    traitName: '偏振',
    traitEffect: '受到自己携带技能系别的攻击伤害-40%。',
  },
  {
    id: '374',
    name: '晶石蜗（蓝锥矿的样子）',
    types: ['光', '地'],
    baseStats: { hp: 99, atk: 97, def: 124, spa: 107, spd: 91, spe: 65 },
    skills: ['4', '280', '137', '281', '12', '94', '237', '238', '34', '51', '282', '162', '11', '232', '127', '128', '22', '129', '130', '131', '132', '133', '134', '258', '30', '31', '32', '77', '220', '35', '120', '175', '202', '136', '230', '171', '143', '109', '375', '82', '44', '391', '283', '455', '218', '284', '227', '113', '3', '279'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.040_晶石蜗（蓝锥矿的样子）.png',
    traitName: '偏振',
    traitEffect: '受到自己携带技能系别的攻击伤害-40%。',
  },
  {
    id: '375',
    name: '晶石蜗（烧蓝黄金的样子）',
    types: ['光', '地'],
    baseStats: { hp: 95, atk: 97, def: 130, spa: 102, spd: 91, spe: 70 },
    skills: ['4', '280', '137', '281', '12', '94', '237', '238', '34', '51', '282', '162', '11', '232', '127', '128', '22', '129', '130', '131', '132', '133', '134', '258', '30', '31', '32', '136', '220', '35', '120', '175', '355', '202', '230', '171', '143', '109', '82', '44', '331', '178', '283', '218', '10', '284', '227', '113', '3', '279'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.040_晶石蜗（烧蓝黄金的样子）.png',
    traitName: '偏振',
    traitEffect: '受到自己携带技能系别的攻击伤害-40%。',
  },
  {
    id: '376',
    name: '丢丢（沙地附近的样子）',
    types: ['草'],
    baseStats: { hp: 44, atk: 42, def: 55, spa: 12, spd: 43, spe: 75 },
    skills: ['7', '223', '279', '221', '59', '188', '285', '63', '288', '60', '215', '232', '43', '1', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '214', '289', '258', '236', '84', '85', '153', '290', '291', '276', '222', '3', '243'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.044_丢丢（沙地附近的样子）.png',
    traitName: '诈死',
    traitEffect: '自己力竭时，少损失1点魔力。',
  },
  {
    id: '377',
    name: '丢丢（雪山附近的样子）',
    types: ['草'],
    baseStats: { hp: 46, atk: 41, def: 48, spa: 8, spd: 44, spe: 81 },
    skills: ['408', '7', '59', '383', '285', '63', '410', '147', '288', '60', '215', '203', '43', '415', '1', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '411', '214', '289', '188', '258', '84', '85', '153', '290', '291', '276', '3', '243'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.044_丢丢（雪山附近的样子）.png',
    traitName: '诈死',
    traitEffect: '自己力竭时，少损失1点魔力。',
  },
  {
    id: '378',
    name: '丢丢（火山附近的样子）',
    types: ['草'],
    baseStats: { hp: 0, atk: 0, def: 0, spa: 0, spd: 0, spe: 0 },
    skills: [],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.044_丢丢（火山附近的样子）.png',
    traitName: '诈死',
    traitEffect: '自己力竭时，少损失1点魔力。',
  },
  {
    id: '379',
    name: '卡卡虫（沙地附近的样子）',
    types: ['草'],
    baseStats: { hp: 58, atk: 56, def: 74, spa: 16, spd: 57, spe: 100 },
    skills: ['7', '223', '279', '221', '59', '188', '285', '63', '288', '60', '215', '232', '43', '1', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '214', '289', '258', '236', '84', '85', '153', '290', '291', '276', '222', '3', '243'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.045_卡卡虫（沙地附近的样子）.png',
    traitName: '诈死',
    traitEffect: '自己力竭时，少损失1点魔力。',
  },
  {
    id: '380',
    name: '卡卡虫（雪山附近的样子）',
    types: ['草'],
    baseStats: { hp: 62, atk: 54, def: 64, spa: 11, spd: 58, spe: 108 },
    skills: ['408', '7', '59', '383', '285', '63', '410', '147', '288', '60', '215', '203', '43', '415', '1', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '411', '214', '289', '188', '258', '84', '85', '153', '290', '291', '276', '3', '243'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.045_卡卡虫（雪山附近的样子）.png',
    traitName: '诈死',
    traitEffect: '自己力竭时，少损失1点魔力。',
  },
  {
    id: '381',
    name: '卡卡虫（火山附近的样子）',
    types: ['草'],
    baseStats: { hp: 0, atk: 0, def: 0, spa: 0, spd: 0, spe: 0 },
    skills: [],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.045_卡卡虫（火山附近的样子）.png',
    traitName: '诈死',
    traitEffect: '自己力竭时，少损失1点魔力。',
  },
  {
    id: '382',
    name: '卡瓦重（沙地附近的样子）',
    types: ['草'],
    baseStats: { hp: 73, atk: 70, def: 92, spa: 20, spd: 71, spe: 125 },
    skills: ['7', '223', '279', '221', '59', '188', '285', '63', '288', '60', '215', '232', '43', '1', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '214', '289', '258', '236', '84', '85', '153', '290', '291', '276', '222', '3', '243'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.046_卡瓦重（沙地附近的样子）.png',
    traitName: '诈死',
    traitEffect: '自己力竭时，少损失1点魔力。',
  },
  {
    id: '383',
    name: '卡瓦重（雪山附近的样子）',
    types: ['草'],
    baseStats: { hp: 77, atk: 68, def: 79, spa: 14, spd: 73, spe: 135 },
    skills: ['408', '7', '59', '383', '285', '63', '410', '147', '288', '60', '215', '203', '43', '415', '1', '21', '22', '23', '24', '25', '103', '71', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '411', '214', '289', '188', '258', '84', '85', '153', '290', '291', '276', '3', '243'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.046_卡瓦重（雪山附近的样子）.png',
    traitName: '诈死',
    traitEffect: '自己力竭时，少损失1点魔力。',
  },
  {
    id: '384',
    name: '卡瓦重（火山附近的样子）',
    types: ['草'],
    baseStats: { hp: 0, atk: 0, def: 0, spa: 0, spd: 0, spe: 0 },
    skills: [],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.046_卡瓦重（火山附近的样子）.png',
    traitName: '诈死',
    traitEffect: '自己力竭时，少损失1点魔力。',
  },
  {
    id: '385',
    name: '暗影灵面（闭眼的样子）',
    types: ['幽'],
    baseStats: { hp: 84, atk: 30, def: 83, spa: 96, spd: 88, spe: 92 },
    skills: ['3', '207', '70', '163', '214', '269', '192', '189', '314', '210', '315', '181', '183', '54', '112', '22', '67', '68', '6', '103', '56', '72', '73', '74', '75', '76', '77', '78', '86', '79', '80', '107', '142', '69', '272', '84', '261', '190', '367', '316', '262', '101', '216', '90', '66'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.055_暗影灵面（闭眼的样子）.png',
    traitName: '惊吓',
    traitEffect: '能量等于0的精灵，无法对自己造成伤害。',
  },
  {
    id: '386',
    name: '幽冥眼（闭眼的样子）',
    types: ['幽'],
    baseStats: { hp: 105, atk: 38, def: 104, spa: 120, spd: 110, spe: 115 },
    skills: ['3', '207', '70', '163', '214', '269', '192', '189', '314', '210', '315', '181', '183', '54', '112', '22', '67', '68', '6', '103', '56', '72', '73', '74', '75', '76', '77', '78', '86', '79', '80', '107', '142', '69', '272', '84', '261', '190', '367', '316', '262', '101', '216', '90', '66'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.056_幽冥眼（闭眼的样子）.png',
    traitName: '惊吓',
    traitEffect: '能量等于0的精灵，无法对自己造成伤害。',
  },
  {
    id: '387',
    name: '梦游（穿星星睡衣的样子）',
    types: ['幽'],
    baseStats: { hp: 0, atk: 0, def: 0, spa: 0, spd: 0, spe: 0 },
    skills: [],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.057_梦游（穿星星睡衣的样子）.png',
    traitName: '做噩梦',
    traitEffect: '敌方精灵离场后，更换入场的精灵失去3能量。',
  },
  {
    id: '388',
    name: '梦悠悠（穿星星睡衣的样子）',
    types: ['幽'],
    baseStats: { hp: 0, atk: 0, def: 0, spa: 0, spd: 0, spe: 0 },
    skills: [],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.058_梦悠悠（穿星星睡衣的样子）.png',
    traitName: '做噩梦',
    traitEffect: '敌方精灵离场后，更换入场的精灵失去3能量。',
  },
  {
    id: '389',
    name: '蹦蹦种子（彩玉球形态）',
    types: ['草', '毒'],
    baseStats: { hp: 62, atk: 61, def: 44, spa: 66, spd: 63, spe: 51 },
    skills: ['268', '209', '87', '86', '3', '267', '61', '133', '57', '324', '92', '310', '81', '62', '193', '308', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '130', '109', '83', '159', '85', '234', '8', '309', '168', '153', '60', '89', '50', '151', '163', '127', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.063_蹦蹦种子（彩玉球形态）.png',
    traitName: '生物碱',
    traitEffect: '使用草系技能时，敌方获得2层中毒。',
  },
  {
    id: '390',
    name: '蹦蹦种子（短毛球形态）',
    types: ['草', '毒'],
    baseStats: { hp: 57, atk: 62, def: 48, spa: 66, spd: 67, spe: 48 },
    skills: ['268', '209', '87', '86', '3', '267', '61', '133', '57', '324', '92', '310', '81', '62', '193', '308', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '130', '109', '83', '159', '85', '234', '8', '309', '168', '153', '60', '89', '50', '151', '163', '127', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.063_蹦蹦种子（短毛球形态）.png',
    traitName: '生物碱',
    traitEffect: '使用草系技能时，敌方获得2层中毒。',
  },
  {
    id: '391',
    name: '蹦蹦种子（象牙球形态）',
    types: ['草', '毒'],
    baseStats: { hp: 59, atk: 60, def: 44, spa: 66, spd: 63, spe: 54 },
    skills: ['268', '209', '87', '86', '3', '267', '61', '133', '57', '324', '92', '310', '81', '62', '193', '308', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '130', '109', '83', '159', '85', '234', '8', '309', '168', '153', '60', '89', '50', '151', '163', '127', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.063_蹦蹦种子（象牙球形态）.png',
    traitName: '生物碱',
    traitEffect: '使用草系技能时，敌方获得2层中毒。',
  },
  {
    id: '392',
    name: '蹦蹦草（彩玉球形态）',
    types: ['草', '毒'],
    baseStats: { hp: 83, atk: 81, def: 59, spa: 87, spd: 84, spe: 68 },
    skills: ['268', '209', '87', '86', '3', '267', '61', '133', '57', '324', '92', '310', '81', '62', '193', '308', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '130', '109', '83', '159', '85', '234', '8', '309', '168', '153', '60', '89', '50', '151', '163', '127', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.064_蹦蹦草（彩玉球形态）.png',
    traitName: '生物碱',
    traitEffect: '使用草系技能时，敌方获得2层中毒。',
  },
  {
    id: '393',
    name: '蹦蹦草（短毛球形态）',
    types: ['草', '毒'],
    baseStats: { hp: 76, atk: 82, def: 64, spa: 87, spd: 90, spe: 64 },
    skills: ['268', '209', '87', '86', '3', '267', '61', '133', '57', '324', '92', '310', '81', '62', '193', '308', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '130', '109', '83', '159', '85', '234', '8', '309', '168', '153', '60', '89', '50', '151', '163', '127', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.064_蹦蹦草（短毛球形态）.png',
    traitName: '生物碱',
    traitEffect: '使用草系技能时，敌方获得2层中毒。',
  },
  {
    id: '394',
    name: '蹦蹦草（象牙球形态）',
    types: ['草', '毒'],
    baseStats: { hp: 79, atk: 80, def: 59, spa: 88, spd: 84, spe: 72 },
    skills: ['268', '209', '87', '86', '3', '267', '61', '133', '57', '324', '92', '310', '81', '62', '193', '308', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '130', '109', '83', '159', '85', '234', '8', '309', '168', '153', '60', '89', '50', '151', '163', '127', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.064_蹦蹦草（象牙球形态）.png',
    traitName: '生物碱',
    traitEffect: '使用草系技能时，敌方获得2层中毒。',
  },
  {
    id: '395',
    name: '蹦蹦花（彩玉球形态）',
    types: ['草', '毒'],
    baseStats: { hp: 103, atk: 101, def: 73, spa: 109, spd: 105, spe: 85 },
    skills: ['268', '209', '87', '86', '3', '267', '61', '133', '57', '324', '92', '310', '81', '62', '193', '308', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '130', '109', '83', '159', '85', '234', '8', '309', '168', '153', '60', '89', '50', '151', '163', '127', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.065_蹦蹦花（彩玉球形态）.png',
    traitName: '生物碱',
    traitEffect: '使用草系技能时，敌方获得2层中毒。',
  },
  {
    id: '396',
    name: '蹦蹦花（短毛球形态）',
    types: ['草', '毒'],
    baseStats: { hp: 95, atk: 103, def: 80, spa: 109, spd: 112, spe: 80 },
    skills: ['268', '209', '87', '86', '3', '267', '61', '133', '57', '324', '92', '310', '81', '62', '193', '308', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '130', '109', '83', '159', '85', '234', '8', '309', '168', '153', '60', '89', '50', '151', '163', '127', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.065_蹦蹦花（短毛球形态）.png',
    traitName: '生物碱',
    traitEffect: '使用草系技能时，敌方获得2层中毒。',
  },
  {
    id: '397',
    name: '蹦蹦花（象牙球形态）',
    types: ['草', '毒'],
    baseStats: { hp: 99, atk: 100, def: 73, spa: 110, spd: 106, spe: 90 },
    skills: ['268', '209', '87', '86', '3', '267', '61', '133', '57', '324', '92', '310', '81', '62', '193', '308', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '130', '109', '83', '159', '85', '234', '8', '309', '168', '153', '60', '89', '50', '151', '163', '127', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.065_蹦蹦花（象牙球形态）.png',
    traitName: '生物碱',
    traitEffect: '使用草系技能时，敌方获得2层中毒。',
  },
  {
    id: '398',
    name: '海盔虫（磨损的样子）',
    types: ['水', '毒'],
    baseStats: { hp: 70, atk: 25, def: 44, spa: 60, spd: 64, spe: 63 },
    skills: ['3', '119', '79', '93', '92', '163', '307', '123', '310', '309', '124', '347', '338', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '87', '138', '80', '81', '107', '166', '109', '83', '348', '272', '85', '190', '47', '349', '90', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.076_海盔虫（磨损的样子）.png',
    traitName: '溶解扩散',
    traitEffect: '每携带1个毒系技能进入战斗，水系技能使敌方获得1层中毒。',
  },
  {
    id: '399',
    name: '刺盔虫（磨损的样子）',
    types: ['水', '毒'],
    baseStats: { hp: 94, atk: 33, def: 59, spa: 80, spd: 85, spe: 84 },
    skills: ['3', '119', '79', '93', '92', '163', '307', '123', '310', '309', '124', '347', '338', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '87', '138', '80', '81', '107', '166', '109', '83', '348', '272', '85', '190', '47', '349', '90', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.077_刺盔虫（磨损的样子）.png',
    traitName: '溶解扩散',
    traitEffect: '每携带1个毒系技能进入战斗，水系技能使敌方获得1层中毒。',
  },
  {
    id: '400',
    name: '千棘盔（磨损的样子）',
    types: ['水', '毒'],
    baseStats: { hp: 117, atk: 41, def: 74, spa: 100, spd: 107, spe: 105 },
    skills: ['3', '119', '79', '93', '92', '163', '307', '123', '310', '309', '124', '347', '338', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '87', '138', '80', '81', '107', '166', '109', '83', '348', '272', '85', '190', '47', '349', '90', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.078_千棘盔（磨损的样子）.png',
    traitName: '溶解扩散',
    traitEffect: '每携带1个毒系技能进入战斗，水系技能使敌方获得1层中毒。',
  },
  {
    id: '401',
    name: '小星光（月光能量的样子）',
    types: ['电'],
    baseStats: { hp: 64, atk: 76, def: 72, spa: 85, spd: 96, spe: 100 },
    skills: ['4', '297', '10', '12', '3', '354', '403', '5', '454', '82', '74', '320', '17', '356', '332', '118', '21', '22', '333', '174', '25', '26', '27', '72', '29', '30', '31', '32', '33', '34', '35', '36', '37', '156', '245', '152', '186', '318', '109', '302', '159', '85', '168', '153', '160', '314', '330', '114', '67'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.080_小星光（月光能量的样子）.png',
    traitName: '电流刺激',
    traitEffect: '携带的攻击技能获得迸发：威力+40。',
  },
  {
    id: '402',
    name: '星光狮（月光能量的样子）',
    types: ['电'],
    baseStats: { hp: 80, atk: 95, def: 90, spa: 107, spd: 120, spe: 125 },
    skills: ['4', '297', '10', '12', '3', '354', '403', '5', '454', '82', '74', '320', '17', '356', '332', '118', '21', '22', '333', '174', '25', '26', '27', '72', '29', '30', '31', '32', '33', '34', '35', '36', '37', '156', '245', '152', '186', '318', '109', '302', '159', '85', '168', '153', '160', '314', '330', '114', '67'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.081_星光狮（月光能量的样子）.png',
    traitName: '电流刺激',
    traitEffect: '携带的攻击技能获得迸发：威力+40。',
  },
  {
    id: '403',
    name: '旋叶虫（枯叶的样子）',
    types: ['普通', '虫'],
    baseStats: { hp: 57, atk: 15, def: 61, spa: 67, spd: 52, spe: 72 },
    skills: ['357', '192', '118', '3', '73', '322', '84', '162', '255', '148', '278', '303', '20', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '353', '51', '87', '170', '115', '156', '157', '152', '337', '109', '375', '268', '234', '153', '60', '361', '27', '114', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.118_旋叶虫（枯叶的样子）.png',
    traitName: '共鸣',
    traitEffect: '携带的【虫鸣】技能威力+20。',
  },
  {
    id: '404',
    name: '蓬叶虫（枯叶的样子）',
    types: ['普通', '虫'],
    baseStats: { hp: 76, atk: 20, def: 82, spa: 89, spd: 70, spe: 96 },
    skills: ['357', '192', '118', '3', '73', '322', '84', '162', '255', '148', '278', '303', '20', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '353', '51', '87', '170', '115', '156', '157', '152', '337', '109', '375', '268', '234', '153', '60', '361', '27', '114', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.119_蓬叶虫（枯叶的样子）.png',
    traitName: '共鸣',
    traitEffect: '携带的【虫鸣】技能威力+20。',
  },
  {
    id: '405',
    name: '风滚暮虫（枯叶的样子）',
    types: ['普通', '虫'],
    baseStats: { hp: 95, atk: 25, def: 102, spa: 111, spd: 87, spe: 120 },
    skills: ['357', '192', '118', '3', '73', '322', '84', '162', '255', '148', '278', '303', '20', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '353', '51', '87', '170', '115', '156', '157', '152', '337', '109', '375', '268', '234', '153', '60', '361', '27', '114', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.120_风滚暮虫（枯叶的样子）.png',
    traitName: '共鸣',
    traitEffect: '携带的【虫鸣】技能威力+20。',
  },
  {
    id: '406',
    name: '小怂猫（山间竹林的样子）',
    types: ['武'],
    baseStats: { hp: 0, atk: 0, def: 0, spa: 0, spd: 0, spe: 0 },
    skills: [],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.163_小怂猫（山间竹林的样子）.png',
    traitName: '威慑',
    traitEffect: '打断敌方时，被打断的技能进入2回合冷却。',
  },
  {
    id: '407',
    name: '怒目怂猫（山间竹林的样子）',
    types: ['武'],
    baseStats: { hp: 0, atk: 0, def: 0, spa: 0, spd: 0, spe: 0 },
    skills: [],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.164_怒目怂猫（山间竹林的样子）.png',
    traitName: '威慑',
    traitEffect: '打断敌方时，被打断的技能进入2回合冷却。',
  },
  {
    id: '408',
    name: '小狮鹫（高山地的样子）',
    types: ['翼'],
    baseStats: { hp: 62, atk: 66, def: 62, spa: 32, spd: 36, spe: 75 },
    skills: ['195', '161', '206', '106', '3', '151', '80', '110', '156', '197', '155', '200', '117', '1', '21', '22', '23', '130', '25', '103', '27', '13', '29', '30', '104', '105', '33', '51', '87', '36', '115', '245', '337', '202', '320', '68', '443', '109', '159', '44', '12', '153', '24', '276', '113'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.165_小狮鹫（高山地的样子）.png',
    traitName: '乘风连击',
    traitEffect: '使用翼系技能后，获得连击数+1。',
  },
  {
    id: '409',
    name: '神圣狮鹫（高山地的样子）',
    types: ['翼'],
    baseStats: { hp: 83, atk: 88, def: 82, spa: 42, spd: 48, spe: 100 },
    skills: ['195', '161', '206', '106', '3', '151', '80', '110', '156', '197', '155', '200', '117', '1', '21', '22', '23', '130', '25', '103', '27', '13', '29', '30', '104', '105', '33', '51', '87', '36', '115', '245', '337', '202', '320', '68', '443', '109', '159', '44', '12', '153', '24', '276', '113'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.166_神圣狮鹫（高山地的样子）.png',
    traitName: '乘风连击',
    traitEffect: '使用翼系技能后，获得连击数+1。',
  },
  {
    id: '410',
    name: '皇家狮鹫（高山地的样子）',
    types: ['翼'],
    baseStats: { hp: 103, atk: 110, def: 103, spa: 53, spd: 60, spe: 125 },
    skills: ['195', '161', '206', '106', '3', '151', '80', '110', '156', '197', '155', '200', '117', '1', '21', '22', '23', '130', '25', '103', '27', '13', '29', '30', '104', '105', '33', '51', '87', '36', '115', '245', '337', '202', '320', '68', '443', '109', '159', '44', '12', '153', '24', '276', '113'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.167_皇家狮鹫（高山地的样子）.png',
    traitName: '乘风连击',
    traitEffect: '使用翼系技能后，获得连击数+1。',
  },
  {
    id: '411',
    name: '波波螺（被污染的样子）',
    types: ['地', '水'],
    baseStats: { hp: 64, atk: 57, def: 64, spa: 57, spd: 86, spe: 42 },
    skills: ['3', '36', '79', '14', '241', '9', '224', '45', '154', '120', '225', '228', '173', '372', '229', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '51', '35', '138', '175', '230', '214', '143', '257', '177', '104', '234', '172', '204', '237', '218', '275', '303', '264', '227', '407'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.171_波波螺（被污染的样子）.png',
    traitName: '消波块',
    traitEffect: '每携带1个水系技能进入战斗，地系技能能耗-1。',
  },
  {
    id: '412',
    name: '消波螺（被污染的样子）',
    types: ['地', '水'],
    baseStats: { hp: 85, atk: 76, def: 85, spa: 76, spd: 115, spe: 56 },
    skills: ['3', '36', '79', '14', '241', '9', '224', '45', '154', '120', '225', '228', '173', '372', '229', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '51', '35', '138', '175', '230', '214', '143', '257', '177', '104', '234', '172', '204', '237', '218', '275', '303', '264', '227', '407'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.172_消波螺（被污染的样子）.png',
    traitName: '消波块',
    traitEffect: '每携带1个水系技能进入战斗，地系技能能耗-1。',
  },
  {
    id: '413',
    name: '嗜波螺（被污染的样子）',
    types: ['地', '水'],
    baseStats: { hp: 107, atk: 95, def: 106, spa: 95, spd: 144, spe: 70 },
    skills: ['3', '36', '79', '14', '241', '9', '224', '45', '154', '120', '225', '228', '173', '372', '229', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '51', '35', '138', '175', '230', '214', '143', '257', '177', '104', '234', '172', '204', '237', '218', '275', '303', '264', '227', '407'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.173_嗜波螺（被污染的样子）.png',
    traitName: '消波块',
    traitEffect: '每携带1个水系技能进入战斗，地系技能能耗-1。',
  },
  {
    id: '414',
    name: '棋棋（黑子）',
    types: ['武', '地'],
    baseStats: { hp: 66, atk: 97, def: 67, spa: 35, spd: 53, spe: 100 },
    skills: ['301', '4', '3', '168', '24', '7', '51', '68', '1', '302', '118', '21', '22', '23', '174', '25', '26', '27', '28', '29', '74', '31', '32', '33', '34', '35', '36', '37', '38', '196', '55', '85', '278', '321'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.188_棋棋（黑子）.png',
    traitName: '腾挪',
    traitEffect: '攻击技能应对1次后，回满状态，变为棋绮后。',
  },
  {
    id: '415',
    name: '棋骑士（黑子）',
    types: ['武', '地'],
    baseStats: { hp: 83, atk: 121, def: 84, spa: 43, spd: 66, spe: 125 },
    skills: ['301', '4', '3', '168', '24', '7', '51', '68', '1', '302', '222', '159', '382', '339', '160', '228', '432', '232', '20', '21', '22', '23', '174', '25', '103', '27', '13', '29', '94', '407', '105', '33', '34', '87', '36', '115', '445', '38', '337', '196', '107', '229', '155', '247', '431', '85', '153', '221', '278', '276', '366', '321'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.189_棋骑士（黑子）.png',
    traitName: '腾挪',
    traitEffect: '攻击技能应对1次后，回满状态，变为棋绮后。',
  },
  {
    id: '416',
    name: '棋齐垒（黑子）',
    types: ['武', '地'],
    baseStats: { hp: 89, atk: 94, def: 116, spa: 38, spd: 77, spe: 75 },
    skills: ['301', '4', '3', '168', '24', '7', '51', '68', '1', '302', '231', '221', '382', '159', '178', '343', '341', '127', '128', '22', '129', '174', '131', '132', '133', '134', '135', '94', '104', '105', '136', '34', '35', '120', '175', '38', '196', '142', '436', '238', '228', '85', '44', '153', '224', '180', '278', '112', '276', '321', '179'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.190_棋齐垒（黑子）.png',
    traitName: '保卫',
    traitEffect: '防御技能应对2次后，回满状态，变为棋绮后。',
  },
  {
    id: '417',
    name: '棋祈督（黑子）',
    types: ['武', '地'],
    baseStats: { hp: 126, atk: 87, def: 90, spa: 87, spd: 72, spe: 85 },
    skills: ['301', '4', '3', '168', '24', '7', '51', '68', '1', '302', '222', '221', '225', '159', '237', '236', '160', '54', '66', '22', '67', '174', '69', '70', '56', '72', '73', '74', '75', '76', '77', '34', '86', '79', '80', '38', '196', '107', '130', '176', '436', '228', '182', '85', '190', '241', '78', '287', '153', '278', '112', '321', '179', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.191_棋祈督（黑子）.png',
    traitName: '好象坏象',
    traitEffect: '状态技能应对1次后，回满状态，变为棋绮后。',
  },
  {
    id: '418',
    name: '棋绮后（黑子）',
    types: ['武', '地'],
    baseStats: { hp: 93, atk: 84, def: 82, spa: 84, spd: 75, spe: 90 },
    skills: ['301', '4', '3', '168', '24', '7', '51', '68', '1', '302', '222', '221', '225', '159', '237', '236', '160', '54', '66', '22', '67', '174', '69', '103', '56', '72', '73', '74', '75', '76', '77', '34', '86', '79', '80', '343', '38', '196', '107', '176', '436', '372', '84', '182', '85', '190', '44', '339', '153', '278', '112', '321', '179', '325', '382'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.192_棋绮后（黑子）.png',
    traitName: '渗透',
    traitEffect: '己方精灵每使用1次武系或地系技能，自己入场时获得攻防+5%。',
  },
  {
    id: '419',
    name: '古钟蛇（本命年的样子）',
    types: ['萌', '毒'],
    baseStats: { hp: 0, atk: 0, def: 0, spa: 0, spd: 0, spe: 0 },
    skills: [],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.212_古钟蛇（本命年的样子）.png',
    traitName: '拨浪鼓',
    traitEffect: '己方精灵每使用1次状态技能，自己入场时毒系和萌系技能威力+10。',
  },
  {
    id: '420',
    name: '寒音蛇（本命年的样子）',
    types: ['萌', '毒'],
    baseStats: { hp: 0, atk: 0, def: 0, spa: 0, spd: 0, spe: 0 },
    skills: [],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.213_寒音蛇（本命年的样子）.png',
    traitName: '拨浪鼓',
    traitEffect: '己方精灵每使用1次状态技能，自己入场时毒系和萌系技能威力+10。',
  },
  {
    id: '421',
    name: '海枝枝（杏黄百合）',
    types: ['水', '幽'],
    baseStats: { hp: 91, atk: 48, def: 104, spa: 125, spd: 129, spe: 110 },
    skills: ['118', '119', '70', '4', '315', '210', '271', '348', '314', '47', '124', '145', '40', '20', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '353', '51', '87', '138', '115', '152', '214', '257', '84', '44', '268', '209', '220', '385', '211', '146', '90', '125', '303', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.220_海枝枝（杏黄百合）.png',
    traitName: '珊瑚骨',
    traitEffect: '敌方精灵离场时，自己获得全技能能耗-3。',
  },
  {
    id: '422',
    name: '海枝枝（洋红沙丁）',
    types: ['水', '幽'],
    baseStats: { hp: 97, atk: 62, def: 84, spa: 136, spd: 121, spe: 110 },
    skills: ['118', '119', '70', '4', '315', '210', '271', '348', '314', '47', '124', '145', '40', '20', '317', '22', '351', '174', '6', '103', '71', '28', '258', '74', '31', '32', '353', '51', '87', '138', '115', '152', '214', '257', '84', '44', '268', '209', '385', '352', '211', '146', '90', '125', '303', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.220_海枝枝（洋红沙丁）.png',
    traitName: '珊瑚骨',
    traitEffect: '敌方精灵离场时，自己获得全技能能耗-3。',
  },
  {
    id: '423',
    name: '海枝枝（翠绿纶布）',
    types: ['水', '幽'],
    baseStats: { hp: 90, atk: 53, def: 92, spa: 135, spd: 113, spe: 120 },
    skills: ['118', '119', '70', '4', '315', '210', '271', '348', '314', '47', '124', '145', '40', '20', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '353', '51', '87', '138', '115', '152', '214', '257', '84', '44', '268', '209', '385', '211', '146', '90', '125', '322', '303', '3'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.220_海枝枝（翠绿纶布）.png',
    traitName: '珊瑚骨',
    traitEffect: '敌方精灵离场时，自己获得全技能能耗-3。',
  },
  {
    id: '424',
    name: '香草甜甜（杨桃饰品）',
    types: ['冰'],
    baseStats: { hp: 88, atk: 92, def: 58, spa: 96, spd: 77, spe: 80 },
    skills: ['3', '398', '72', '41', '4', '410', '404', '411', '7', '149', '409', '417', '405', '402', '203', '384', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '259', '353', '51', '87', '170', '115', '337', '414', '70', '374', '39', '109', '269', '315', '212', '85', '252', '263', '90', '242', '254', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.235_香草甜甜（杨桃饰品）.png',
    traitName: '加个雪球',
    traitEffect: '使敌方获得冻结时，也会使其获得2层冻结。',
  },
  {
    id: '425',
    name: '香草甜甜（蓝莓饰品）',
    types: ['冰'],
    baseStats: { hp: 91, atk: 94, def: 63, spa: 88, spd: 74, spe: 80 },
    skills: ['3', '398', '72', '41', '4', '410', '404', '411', '7', '149', '409', '417', '405', '402', '203', '384', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '259', '353', '51', '87', '170', '115', '337', '414', '70', '374', '39', '109', '269', '315', '212', '85', '252', '263', '90', '242', '254', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.235_香草甜甜（蓝莓饰品）.png',
    traitName: '加个雪球',
    traitEffect: '使敌方获得冻结时，也会使其获得2层冻结。',
  },
  {
    id: '426',
    name: '圣代甜甜（樱桃草莓口味）',
    types: ['冰'],
    baseStats: { hp: 107, atk: 120, def: 81, spa: 110, spd: 96, spe: 100 },
    skills: ['3', '398', '72', '41', '4', '410', '404', '411', '7', '149', '409', '417', '405', '402', '203', '384', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '259', '353', '51', '87', '170', '115', '337', '414', '70', '374', '39', '109', '269', '315', '212', '85', '252', '263', '90', '242', '254', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.236_圣代甜甜（樱桃草莓口味）.png',
    traitName: '加个雪球',
    traitEffect: '使敌方获得冻结时，也会使其获得2层冻结。',
  },
  {
    id: '427',
    name: '圣代甜甜（樱桃抹茶口味）',
    types: ['冰'],
    baseStats: { hp: 113, atk: 112, def: 79, spa: 110, spd: 92, spe: 105 },
    skills: ['3', '398', '72', '41', '4', '410', '404', '411', '7', '149', '409', '417', '405', '402', '203', '384', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '259', '353', '51', '87', '170', '115', '337', '414', '70', '374', '39', '109', '269', '315', '212', '85', '252', '263', '90', '242', '254', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.236_圣代甜甜（樱桃抹茶口味）.png',
    traitName: '加个雪球',
    traitEffect: '使敌方获得冻结时，也会使其获得2层冻结。',
  },
  {
    id: '428',
    name: '圣代甜甜（蓝莓巧克力口味）',
    types: ['冰'],
    baseStats: { hp: 114, atk: 117, def: 79, spa: 110, spd: 92, spe: 100 },
    skills: ['3', '398', '72', '41', '4', '410', '404', '411', '7', '149', '409', '417', '405', '402', '203', '384', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '259', '353', '51', '87', '170', '115', '337', '414', '70', '374', '39', '109', '269', '315', '212', '85', '252', '263', '90', '242', '254', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.236_圣代甜甜（蓝莓巧克力口味）.png',
    traitName: '加个雪球',
    traitEffect: '使敌方获得冻结时，也会使其获得2层冻结。',
  },
  {
    id: '429',
    name: '圣代甜甜（蓝莓草莓口味）',
    types: ['冰'],
    baseStats: { hp: 113, atk: 109, def: 90, spa: 100, spd: 96, spe: 100 },
    skills: ['3', '398', '72', '41', '4', '410', '404', '411', '7', '149', '409', '417', '405', '402', '203', '384', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '259', '353', '51', '87', '170', '115', '337', '414', '70', '374', '39', '109', '269', '315', '212', '85', '252', '263', '90', '242', '254', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.236_圣代甜甜（蓝莓草莓口味）.png',
    traitName: '加个雪球',
    traitEffect: '使敌方获得冻结时，也会使其获得2层冻结。',
  },
  {
    id: '430',
    name: '圣代甜甜（蓝莓抹茶口味）',
    types: ['冰'],
    baseStats: { hp: 121, atk: 100, def: 86, spa: 101, spd: 92, spe: 105 },
    skills: ['3', '398', '72', '41', '4', '410', '404', '411', '7', '149', '409', '417', '405', '402', '203', '384', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '259', '353', '51', '87', '170', '115', '337', '414', '70', '374', '39', '109', '269', '315', '212', '85', '252', '263', '90', '242', '254', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.236_圣代甜甜（蓝莓抹茶口味）.png',
    traitName: '加个雪球',
    traitEffect: '使敌方获得冻结时，也会使其获得2层冻结。',
  },
  {
    id: '431',
    name: '圣代甜甜（杨桃巧克力口味）',
    types: ['冰'],
    baseStats: { hp: 110, atk: 116, def: 73, spa: 120, spd: 96, spe: 100 },
    skills: ['3', '398', '72', '41', '4', '410', '404', '411', '7', '149', '409', '417', '405', '402', '203', '384', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '259', '353', '51', '87', '170', '115', '337', '414', '70', '374', '39', '109', '269', '315', '212', '85', '252', '263', '90', '242', '254', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.236_圣代甜甜（杨桃巧克力口味）.png',
    traitName: '加个雪球',
    traitEffect: '使敌方获得冻结时，也会使其获得2层冻结。',
  },
  {
    id: '432',
    name: '圣代甜甜（杨桃草莓口味）',
    types: ['冰'],
    baseStats: { hp: 108, atk: 110, def: 84, spa: 110, spd: 99, spe: 100 },
    skills: ['3', '398', '72', '41', '4', '410', '404', '411', '7', '149', '409', '417', '405', '402', '203', '384', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '259', '353', '51', '87', '170', '115', '337', '414', '70', '374', '39', '109', '269', '315', '212', '85', '252', '263', '90', '242', '254', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.236_圣代甜甜（杨桃草莓口味）.png',
    traitName: '加个雪球',
    traitEffect: '使敌方获得冻结时，也会使其获得2层冻结。',
  },
  {
    id: '433',
    name: '圣代甜甜（杨桃抹茶口味）',
    types: ['冰'],
    baseStats: { hp: 110, atk: 107, def: 82, spa: 110, spd: 96, spe: 105 },
    skills: ['3', '398', '72', '41', '4', '410', '404', '411', '7', '149', '409', '417', '405', '402', '203', '384', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '259', '353', '51', '87', '170', '115', '337', '414', '70', '374', '39', '109', '269', '315', '212', '85', '252', '263', '90', '242', '254', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.236_圣代甜甜（杨桃抹茶口味）.png',
    traitName: '加个雪球',
    traitEffect: '使敌方获得冻结时，也会使其获得2层冻结。',
  },
  {
    id: '434',
    name: '刺轮砣（下弦的样子）',
    types: ['毒', '萌'],
    baseStats: { hp: 100, atk: 78, def: 65, spa: 80, spd: 80, spe: 84 },
    skills: ['393', '213', '76', '305', '86', '395', '252', '3', '87', '307', '319', '81', '256', '108', '310', '20', '112', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '259', '77', '78', '35', '79', '80', '54', '166', '214', '142', '83', '257', '84', '85', '309', '123', '122', '47', '9', '347', '90', '170', '418', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.237_刺轮砣（下弦的样子）.png',
    traitName: '耐活王',
    traitEffect: '敌方受到中毒效果伤害时，自己回复等量生命。',
  },
  {
    id: '435',
    name: '月亮砣（下弦的样子）',
    types: ['毒', '萌'],
    baseStats: { hp: 125, atk: 98, def: 81, spa: 100, spd: 100, spe: 105 },
    skills: ['393', '213', '76', '305', '86', '395', '252', '3', '87', '307', '319', '81', '256', '108', '310', '20', '112', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '259', '77', '78', '35', '79', '80', '54', '166', '214', '142', '83', '257', '84', '85', '309', '123', '122', '47', '9', '347', '90', '170', '418', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.238_月亮砣（下弦的样子）.png',
    traitName: '耐活王',
    traitEffect: '敌方受到中毒效果伤害时，自己回复等量生命。',
  },
  {
    id: '436',
    name: '乌达（极夜的样子）',
    types: ['恶', '火'],
    baseStats: { hp: 96, atk: 95, def: 64, spa: 55, spd: 34, spe: 30 },
    skills: ['408', '404', '112', '66', '293', '7', '387', '185', '244', '411', '184', '413', '111', '20', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '37', '152', '107', '130', '109', '444', '155', '159', '300', '153', '298', '276', '3', '115'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.258_乌达（极夜的样子）.png',
    traitName: '恶魔的晚宴',
    traitEffect: '主动击败敌方精灵时，自己获得双攻+50%。',
  },
  {
    id: '437',
    name: '迷你乌（极夜的样子）',
    types: ['恶', '火'],
    baseStats: { hp: 128, atk: 126, def: 85, spa: 73, spd: 46, spe: 40 },
    skills: ['408', '404', '112', '66', '293', '7', '387', '185', '244', '411', '184', '413', '111', '20', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '37', '152', '107', '130', '109', '444', '155', '159', '300', '153', '298', '276', '3', '115'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.259_迷你乌（极夜的样子）.png',
    traitName: '恶魔的晚宴',
    traitEffect: '主动击败敌方精灵时，自己获得双攻+50%。',
  },
  {
    id: '438',
    name: '乌拉塔（极夜的样子）',
    types: ['恶', '火'],
    baseStats: { hp: 160, atk: 158, def: 106, spa: 91, spd: 57, spe: 50 },
    skills: ['408', '404', '112', '66', '293', '7', '387', '185', '244', '411', '184', '413', '111', '20', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '37', '152', '107', '130', '109', '444', '155', '159', '300', '153', '298', '276', '3', '115'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.260_乌拉塔（极夜的样子）.png',
    traitName: '恶魔的晚宴',
    traitEffect: '主动击败敌方精灵时，自己获得双攻+50%。',
  },
  {
    id: '439',
    name: '地鼠（储水期的样子）',
    types: ['地'],
    baseStats: { hp: 59, atk: 71, def: 61, spa: 23, spd: 57, spe: 60 },
    skills: ['53', '85', '279', '221', '196', '3', '226', '236', '78', '148', '232', '237', '373', '372', '1', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '35', '138', '115', '156', '214', '394', '86', '87', '241', '36', '122', '9', '90', '192', '219', '276', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.277_地鼠（储水期的样子）.png',
    traitName: '警惕',
    traitEffect: '回合结束时，若自己能量为0则脱离。',
  },
  {
    id: '440',
    name: '地鼠（储水期的样子）',
    types: ['地'],
    baseStats: { hp: 59, atk: 71, def: 61, spa: 23, spd: 57, spe: 60 },
    skills: ['53', '85', '279', '221', '196', '3', '226', '236', '78', '148', '232', '237', '373', '372', '1', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '35', '138', '115', '156', '214', '394', '86', '87', '241', '36', '122', '9', '90', '192', '219', '276', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.277_地鼠（储水期的样子）.png',
    traitName: '警惕',
    traitEffect: '回合结束时，若自己能量为0则脱离。',
  },
  {
    id: '441',
    name: '遁鼠（储水期的样子）',
    types: ['地'],
    baseStats: { hp: 79, atk: 94, def: 82, spa: 30, spd: 77, spe: 80 },
    skills: ['53', '85', '279', '221', '196', '3', '226', '236', '78', '148', '232', '237', '373', '372', '1', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '35', '138', '115', '156', '214', '394', '86', '87', '241', '36', '122', '9', '90', '192', '219', '276', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.278_遁鼠（储水期的样子）.png',
    traitName: '警惕',
    traitEffect: '回合结束时，若自己能量为0则脱离。',
  },
  {
    id: '442',
    name: '遁鼠（储水期的样子）',
    types: ['地'],
    baseStats: { hp: 79, atk: 94, def: 82, spa: 30, spd: 77, spe: 80 },
    skills: ['53', '85', '279', '221', '196', '3', '226', '236', '78', '148', '232', '237', '373', '372', '1', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '35', '138', '115', '156', '214', '394', '86', '87', '241', '36', '122', '9', '90', '192', '219', '276', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.278_遁鼠（储水期的样子）.png',
    traitName: '警惕',
    traitEffect: '回合结束时，若自己能量为0则脱离。',
  },
  {
    id: '443',
    name: '遁地鼠（储水期的样子）',
    types: ['地'],
    baseStats: { hp: 99, atk: 118, def: 102, spa: 38, spd: 96, spe: 100 },
    skills: ['53', '85', '279', '221', '196', '3', '226', '236', '78', '148', '232', '237', '373', '372', '1', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '35', '138', '115', '156', '214', '394', '86', '87', '241', '36', '122', '9', '90', '192', '219', '276', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.279_遁地鼠（储水期的样子）.png',
    traitName: '警惕',
    traitEffect: '回合结束时，若自己能量为0则脱离。',
  },
  {
    id: '444',
    name: '遁地鼠（储水期的样子）',
    types: ['地'],
    baseStats: { hp: 99, atk: 118, def: 102, spa: 38, spd: 96, spe: 100 },
    skills: ['53', '85', '279', '221', '196', '3', '226', '236', '78', '148', '232', '237', '373', '372', '1', '21', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '35', '138', '115', '156', '214', '394', '86', '87', '241', '36', '122', '9', '90', '192', '219', '276', '323'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.279_遁地鼠（储水期的样子）.png',
    traitName: '警惕',
    traitEffect: '回合结束时，若自己能量为0则脱离。',
  },
  {
    id: '445',
    name: '叶冕魔力猫',
    types: ['草'],
    baseStats: { hp: 108, atk: 127, def: 81, spa: 127, spd: 151, spe: 55 },
    skills: ['53', '54', '8', '55', '50', '3', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '38', '81', '82', '83', '84', '85', '86', '87', '88', '89', '90', '91', '92', '93', '94', '95'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.004_叶冕魔力猫.png',
    traitName: '深层氧循环',
    traitEffect: '使用草系技能后，回复15%生命。',
  },
  {
    id: '446',
    name: '烈火战神',
    types: ['火'],
    baseStats: { hp: 117, atk: 175, def: 94, spa: 84, spd: 72, spe: 130 },
    skills: ['1', '96', '7', '97', '3', '98', '85', '42', '99', '100', '101', '52', '102', '20', '21', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '37', '106', '107', '108', '109', '110', '111', '90', '112', '113', '114', '115', '116', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.007_烈火战神.png',
    traitName: '爆燃',
    traitEffect: '使用火系技能后，获得双攻+30%。',
  },
  {
    id: '447',
    name: '圣水守护',
    types: ['水'],
    baseStats: { hp: 125, atk: 67, def: 104, spa: 141, spd: 145, spe: 85 },
    skills: ['3', '118', '119', '45', '4', '120', '121', '122', '123', '124', '125', '126', '40', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '74', '31', '32', '136', '137', '87', '138', '139', '38', '140', '141', '28', '142', '143', '144', '41', '44', '145', '146', '147', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.010_圣水守护.png',
    traitName: '浪潮',
    traitEffect: '使用水系技能后，全技能能耗-2。',
  },
  {
    id: '448',
    name: '鸭吉吉国王',
    types: ['普通'],
    baseStats: { hp: 136, atk: 135, def: 79, spa: 50, spd: 64, spe: 105 },
    skills: ['1', '7', '55', '3', '54', '149', '150', '142', '151', '152', '153', '154', '155', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '94', '75', '76', '77', '78', '86', '79', '80', '156', '157', '106', '158', '130', '109', '159', '84', '160', '90', '24', '127', '115', '161'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.011_鸭吉吉国王.png',
    traitName: '“国王”的威严',
    traitEffect: '鸭吉吉国王的种族资质大幅增加，能耗为1的技能威力+50%。',
  },
  {
    id: '449',
    name: '霜翼领主',
    types: ['翼'],
    baseStats: { hp: 90, atk: 142, def: 108, spa: 63, spd: 74, spe: 115 },
    skills: ['195', '7', '196', '106', '3', '110', '80', '197', '198', '199', '155', '200', '117', '20', '21', '22', '23', '24', '25', '103', '27', '28', '29', '94', '104', '105', '33', '51', '87', '36', '115', '201', '152', '38', '202', '13', '203', '182', '44', '204', '205', '9', '153', '206', '79', '147'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.020_霜翼领主.png',
    traitName: '破空',
    traitEffect: '若先于敌方攻击，本次技能威力+75%。',
  },
  {
    id: '450',
    name: '迷嶂布莱克',
    types: ['地'],
    baseStats: { hp: 125, atk: 139, def: 164, spa: 52, spd: 154, spe: 70 },
    skills: ['3', '51', '7', '236', '224', '226', '237', '154', '238', '239', '228', '240', '241', '232', '231', '127', '128', '22', '129', '130', '131', '132', '133', '134', '135', '94', '104', '105', '136', '34', '35', '120', '139', '202', '171', '142', '143', '109', '212', '189', '44', '184', '180', '242', '227', '181'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.029_迷嶂布莱克.png',
    traitName: '地脉馈赠',
    traitEffect: '突破能量上限并立即回复10能量，入场前己方精灵每放1次地系技能，回复3能量。',
  },
  {
    id: '451',
    name: '幻影荆棘',
    types: ['幽', '草'],
    baseStats: { hp: 125, atk: 96, def: 72, spa: 96, spd: 134, spe: 80 },
    skills: ['3', '242', '70', '209', '266', '267', '268', '132', '186', '181', '27', '183', '269', '60', '270', '20', '66', '22', '67', '68', '69', '103', '71', '72', '73', '74', '75', '76', '77', '78', '86', '79', '80', '54', '187', '38', '271', '61', '83', '272', '261', '190', '184', '262', '89', '216', '193', '58', '4'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.035_幻影荆棘.png',
    traitName: '大捞一笔',
    traitEffect: '回合结束时，偷取所有敌方精灵2能量。',
  },
  {
    id: '452',
    name: '钻石蜗',
    types: ['光', '地'],
    baseStats: { hp: 93, atk: 96, def: 124, spa: 101, spd: 91, spe: 65 },
    skills: ['4', '280', '137', '281', '12', '94', '237', '238', '34', '51', '282', '162', '11', '232', '127', '128', '22', '129', '130', '131', '132', '133', '134', '258', '30', '31', '32', '136', '220', '35', '120', '175', '202', '140', '203', '230', '171', '143', '109', '82', '41', '44', '126', '283', '218', '284', '227', '113', '3', '279'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.040_钻石蜗.png',
    traitName: '完全偏振',
    traitEffect: '抵抗自己携带技能系别的攻击伤害。',
  },
  {
    id: '453',
    name: '奇丽果',
    types: ['草'],
    baseStats: { hp: 112, atk: 128, def: 133, spa: 128, spd: 105, spe: 80 },
    skills: ['217', '85', '267', '3', '7', '8', '46', '91', '285', '61', '57', '188', '62', '286', '60', '193', '54', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '86', '79', '80', '157', '18', '65', '214', '83', '155', '44', '287', '12', '153', '223', '275', '51', '94', '222', '2', '127'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.043_奇丽果.png',
    traitName: '养分内循环',
    traitEffect: '回合结束时，回复6能量。',
  },
  {
    id: '454',
    name: '风暴战犬',
    types: ['火'],
    baseStats: { hp: 85, atk: 128, def: 101, spa: 46, spd: 82, spe: 120 },
    skills: ['3', '96', '69', '292', '7', '293', '294', '295', '42', '296', '101', '100', '52', '118', '21', '22', '23', '24', '6', '26', '27', '28', '29', '74', '31', '32', '15', '34', '35', '36', '115', '38', '202', '277', '297', '84', '182', '85', '112', '66', '298', '299', '11', '67'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.048_风暴战犬.png',
    traitName: '全神贯注',
    traitEffect: '入场时，获得物攻+100%，每次行动后-20%。',
  },
  {
    id: '455',
    name: '蹦蹦果',
    types: ['草', '毒'],
    baseStats: { hp: 100, atk: 87, def: 73, spa: 90, spd: 105, spe: 85 },
    skills: ['268', '209', '87', '86', '3', '267', '61', '133', '57', '324', '92', '310', '81', '62', '193', '308', '20', '66', '22', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '35', '79', '80', '130', '109', '83', '159', '85', '234', '8', '309', '168', '153', '60', '89', '50', '151', '163', '127', '325'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.065_蹦蹦果.png',
    traitName: '高浓生物碱',
    traitEffect: '使用技能时，敌方获得2层中毒。',
  },
  {
    id: '456',
    name: '千棘海针',
    types: ['水', '毒'],
    baseStats: { hp: 118, atk: 32, def: 94, spa: 85, spd: 133, spe: 100 },
    skills: ['3', '119', '79', '93', '92', '163', '307', '123', '310', '309', '124', '347', '338', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '87', '138', '80', '81', '107', '166', '109', '83', '348', '272', '85', '190', '47', '349', '90', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.078_千棘海针.png',
    traitName: '溶解腐蚀',
    traitEffect: '每携带1个毒系技能进入战斗，水系技能使敌方获得2层中毒。',
  },
  {
    id: '457',
    name: '花魁蜂后',
    types: ['虫', '翼'],
    baseStats: { hp: 145, atk: 54, def: 45, spa: 49, spd: 45, spe: 44 },
    skills: ['4', '357', '265', '249', '322', '250', '115', '106', '110', '358', '80', '169', '359', '360', '361', '117', '118', '21', '22', '23', '24', '25', '26', '27', '28', '258', '74', '31', '32', '33', '34', '87', '36', '37', '38', '337', '166', '155', '272', '182', '44', '153', '206', '88', '90', '92', '290', '219', '303', '3', '362'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.084_花魁蜂后.png',
    traitName: '虫群突袭',
    traitEffect: '队伍中每有1只其他的虫系精灵，自己入场时获得攻防速+15%。',
  },
  {
    id: '458',
    name: '神谕鲨',
    types: ['水', '翼'],
    baseStats: { hp: 90, atk: 77, def: 105, spa: 77, spd: 105, spe: 125 },
    skills: ['4', '119', '365', '364', '167', '348', '217', '38', '169', '125', '121', '347', '40', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '74', '31', '32', '353', '51', '87', '138', '115', '383', '41', '155', '384', '385', '124', '153', '146', '255', '386', '303', '3', '198'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.110_神谕鲨.png',
    traitName: '水翼飞升',
    traitEffect: '己方精灵每使用1次水系技能，自己入场时获得全技能能耗-1，且能耗为0的技能威力+30%。',
  },
  {
    id: '459',
    name: '祭礼巨像',
    types: ['地', '幻'],
    baseStats: { hp: 106, atk: 105, def: 115, spa: 111, spd: 119, spe: 85 },
    skills: ['224', '389', '371', '14', '4', '223', '7', '231', '225', '390', '39', '222', '241', '287', '372', '78', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '15', '51', '86', '79', '80', '370', '214', '210', '381', '144', '83', '369', '183', '85', '211', '103', '391', '237', '77', '3', '165'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.115_祭礼巨像.png',
    traitName: '坠星',
    traitEffect: '敌方每有1层星陨印记，自己的技能威力+15%。',
  },
  {
    id: '460',
    name: '彩虹独角兽',
    types: ['光'],
    baseStats: { hp: 99, atk: 78, def: 77, spa: 192, spd: 92, spe: 105 },
    skills: ['163', '4', '74', '3', '85', '82', '152', '17', '12', '19', '155', '146', '114', '20', '317', '22', '351', '174', '352', '103', '71', '13', '258', '30', '31', '32', '353', '51', '87', '170', '115', '337', '28', '57', '167', '109', '384', '268', '45', '80', '169', '283', '79', '10', '326', '303', '147', '67', '117'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.117_彩虹独角兽.png',
    traitName: '夺目',
    traitEffect: '额外获得三个未携带的随机技能，且非光系技能威力+25%。',
  },
  {
    id: '461',
    name: '黑猫密探',
    types: ['普通'],
    baseStats: { hp: 152, atk: 107, def: 67, spa: 186, spd: 119, spe: 70 },
    skills: ['4', '118', '3', '163', '152', '304', '192', '143', '392', '157', '270', '90', '155', '20', '66', '22', '67', '68', '69', '103', '56', '72', '73', '74', '75', '76', '15', '78', '86', '79', '139', '38', '70', '271', '210', '315', '84', '261', '177', '85', '153', '80', '198', '148'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.122_黑猫密探.png',
    traitName: '先知',
    traitEffect: '若敌方技能足够击败自己，回合开始时自己获得速度+50，双攻+50%。',
  },
  {
    id: '462',
    name: '恶魔狼王',
    types: ['恶'],
    baseStats: { hp: 115, atk: 121, def: 91, spa: 50, spd: 63, spe: 120 },
    skills: ['363', '66', '182', '7', '3', '196', '187', '244', '107', '111', '185', '247', '246', '20', '112', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '38', '202', '70', '277', '186', '83', '293', '42', '212', '85', '44', '97', '242', '52', '116'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.131_恶魔狼王.png',
    traitName: '悼亡',
    traitEffect: '双方队伍中每有1只力竭的精灵，自己获得双攻+30%。',
  },
  {
    id: '463',
    name: '雪影冰灵',
    types: ['冰', '萌'],
    baseStats: { hp: 130, atk: 120, def: 66, spa: 114, spd: 130, spe: 90 },
    skills: ['3', '398', '72', '293', '76', '254', '404', '140', '410', '252', '319', '415', '411', '405', '263', '417', '20', '66', '22', '67', '68', '69', '70', '56', '13', '73', '74', '75', '259', '77', '78', '86', '79', '80', '370', '38', '383', '28', '350', '7', '166', '374', '39', '83', '177', '371', '256', '388', '418', '409'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.144_雪影冰灵.png',
    traitName: '抓到你了',
    traitEffect: '自己入场时敌方获得2层冻结，使敌方获得冻结时，也会使其获得全技能能耗+1。',
  },
  {
    id: '464',
    name: '棋契陛下',
    types: ['武', '地'],
    baseStats: { hp: 90, atk: 200, def: 140, spa: 91, spd: 115, spe: 125 },
    skills: ['301', '4', '3', '168', '24', '7', '51', '68', '1', '302', '222', '159', '382', '339', '160', '228', '432', '232', '20', '21', '22', '23', '174', '25', '103', '27', '13', '29', '30', '407', '105', '33', '34', '87', '36', '115', '445', '38', '337', '196', '18', '229', '155', '431', '85', '12', '153', '221', '278', '276', '321', '94'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.192_棋契陛下.png',
    traitName: '御驾亲征',
    traitEffect: '棋契陛下大幅提升种族资质，力竭时扣除4魔力。',
  },
  {
    id: '465',
    name: '奇梦咪',
    types: ['萌'],
    baseStats: { hp: 81, atk: 128, def: 123, spa: 119, spd: 123, spe: 110 },
    skills: ['3', '259', '336', '254', '76', '319', '260', '127', '263', '252', '335', '418', '264', '154', '83', '20', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '32', '77', '78', '86', '79', '80', '157', '355', '350', '214', '176', '302', '159', '84', '339', '153', '331', '440', '24', '10', '299', '179'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.200_奇梦咪.png',
    traitName: '三鼓作气',
    traitEffect: '使用能耗为3的技能时，获得攻防永久+20%。',
  },
  {
    id: '466',
    name: '伊兰亚龙',
    types: ['龙'],
    baseStats: { hp: 112, atk: 91, def: 69, spa: 190, spd: 99, spe: 90 },
    skills: ['442', '4', '448', '3', '441', '22', '446', '349', '449', '450', '83', '451', '146', '118', '317', '429', '333', '174', '352', '103', '71', '28', '258', '74', '31', '32', '353', '51', '87', '170', '115', '214', '57', '39', '375', '332', '371', '46', '89', '416', '90', '10', '299', '114'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.204_伊兰亚龙.png',
    traitName: '游弋',
    traitEffect: '蓄力时可使用任一携带技能，且获得双防+100%。',
  },
  {
    id: '467',
    name: '波普鹿',
    types: ['电'],
    baseStats: { hp: 92, atk: 99, def: 108, spa: 34, spd: 79, spe: 120 },
    skills: ['297', '299', '354', '3', '85', '49', '7', '196', '326', '330', '403', '276', '332', '20', '21', '22', '333', '24', '25', '103', '27', '72', '29', '30', '104', '105', '33', '51', '87', '36', '115', '38', '337', '202', '18', '293', '182', '111', '44', '78', '12', '153', '373', '66', '94', '279'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.228_波普鹿.png',
    traitName: '超级电池',
    traitEffect: '每入场1次，获得双攻永久+30%。',
  },
  {
    id: '468',
    name: '圣剑骑士',
    types: ['机械'],
    baseStats: { hp: 187, atk: 154, def: 183, spa: 148, spd: 183, spe: 65 },
    skills: ['4', '3', '104', '407', '75', '196', '54', '457', '7', '445', '165', '419', '313', '423', '421', '456', '20', '21', '22', '23', '24', '25', '103', '27', '28', '29', '94', '31', '105', '33', '51', '87', '36', '115', '202', '411', '13', '214', '229', '82', '83', '44', '12', '280', '163', '303', '222', '11', '225', '382'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.286_圣剑骑士.png',
    traitName: '宝剑王牌',
    traitEffect: '仅可使用1号和3号位技能。',
  },
  {
    id: '469',
    name: '钨丝贝贝',
    types: ['机械'],
    baseStats: { hp: 62, atk: 68, def: 78, spa: 63, spd: 54, spe: 33 },
    skills: ['470', '471', '472', '473', '474', '475', '476', '477', '478', '479', '480', '481', '482', '483', '484', '485', '486', '487', '488', '489', '490', '491', '492', '493', '494', '495', '496', '497', '498', '499', '500', '501', '502', '503', '504', '505', '506', '507', '508', '509', '510', '511', '512', '513', '514', '515', '516', '517', '518'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.348_钨丝贝贝.png',
    traitName: '狂欢开始',
    traitEffect: '在场时，背包里会变化出随机精灵，随机精灵只能与本精灵相互更换。本精灵受到的克制伤害+25%。',
  },
  {
    id: '470',
    name: '辉光幕机',
    types: ['机械'],
    baseStats: { hp: 83, atk: 91, def: 104, spa: 84, spd: 72, spe: 44 },
    skills: ['470', '471', '472', '473', '474', '475', '476', '477', '478', '479', '480', '481', '482', '483', '484', '485', '486', '487', '488', '489', '490', '491', '492', '493', '494', '495', '496', '497', '498', '499', '500', '501', '502', '503', '504', '505', '506', '507', '508', '509', '510', '511', '512', '513', '514', '515', '516', '517', '518'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.349_辉光幕机.png',
    traitName: '狂欢开始',
    traitEffect: '在场时，背包里会变化出随机精灵，随机精灵只能与本精灵相互更换。本精灵受到的克制伤害+25%。',
  },
  {
    id: '471',
    name: '机幕方舟',
    types: ['机械'],
    baseStats: { hp: 104, atk: 113, def: 130, spa: 105, spd: 90, spe: 55 },
    skills: ['470', '471', '472', '473', '474', '475', '476', '477', '478', '479', '480', '481', '482', '483', '484', '485', '486', '487', '488', '489', '490', '491', '492', '493', '494', '495', '496', '497', '498', '499', '500', '501', '502', '503', '504', '505', '506', '507', '508', '509', '510', '511', '512', '513', '514', '515', '516', '517', '518'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.350_机幕方舟.png',
    traitName: '狂欢开始',
    traitEffect: '在场时，背包里会变化出随机精灵，随机精灵只能与本精灵相互更换。本精灵受到的克制伤害+25%。',
  },
  {
    id: '472',
    name: '凡雀',
    types: ['翼'],
    baseStats: { hp: 71, atk: 55, def: 52, spa: 53, spd: 66, spe: 75 },
    skills: ['519', '470', '520', '521', '522', '523', '524', '525', '526', '527', '528', '529', '530', '531', '532', '533', '534', '535', '489', '490', '536', '492', '537', '538', '495', '539', '540', '498', '541', '542', '501', '502', '518', '543', '544', '545', '546', '547', '548', '549', '550', '551', '552', '553', '554', '555', '556', '557', '558'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.351_凡雀.png',
    traitName: '展翅',
    traitEffect: '在场时，自己携带的普通系技能变为翼系技能，若后于对手行动，自己受到的伤害+25%。',
  },
  {
    id: '473',
    name: '紫翎鹰',
    types: ['翼'],
    baseStats: { hp: 94, atk: 74, def: 69, spa: 71, spd: 88, spe: 100 },
    skills: ['519', '470', '520', '521', '522', '523', '524', '525', '526', '527', '528', '529', '530', '531', '532', '533', '534', '535', '489', '490', '536', '492', '537', '538', '495', '539', '540', '498', '541', '542', '501', '502', '518', '543', '544', '545', '546', '547', '548', '549', '550', '551', '552', '553', '554', '555', '556', '557', '558'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.352_紫翎鹰.png',
    traitName: '展翅',
    traitEffect: '在场时，自己携带的普通系技能变为翼系技能，若后于对手行动，自己受到的伤害+25%。',
  },
  {
    id: '474',
    name: '凡鹰',
    types: ['翼'],
    baseStats: { hp: 118, atk: 92, def: 86, spa: 89, spd: 110, spe: 125 },
    skills: ['519', '470', '520', '521', '522', '523', '524', '525', '526', '527', '528', '529', '530', '531', '532', '533', '534', '535', '489', '490', '536', '492', '537', '538', '495', '539', '540', '498', '541', '542', '501', '502', '518', '543', '544', '545', '546', '547', '548', '549', '550', '551', '552', '553', '554', '555', '556', '557', '558'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.353_凡鹰.png',
    traitName: '展翅',
    traitEffect: '在场时，自己携带的普通系技能变为翼系技能，若后于对手行动，自己受到的伤害+25%。',
  },
  {
    id: '475',
    name: '小雪人',
    types: ['冰'],
    baseStats: { hp: 101, atk: 85, def: 78, spa: 80, spd: 105, spe: 60 },
    skills: ['559', '560', '503', '561', '470', '562', '563', '564', '482', '565', '566', '567', '568', '532', '533', '534', '535', '489', '490', '536', '492', '537', '538', '495', '539', '540', '498', '541', '542', '501', '502', '569', '496', '570', '571', '572', '573', '574', '575', '576', '577', '515', '530', '578', '579', '580', '581'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.354_小雪人.png',
    traitName: '大雪球',
    traitEffect: '自己使用2次不同的冰系技能后，对手获得4层冻结，随后特性重置。',
  },
  {
    id: '476',
    name: '雪怪',
    types: ['冰'],
    baseStats: { hp: 126, atk: 107, def: 98, spa: 99, spd: 131, spe: 75 },
    skills: ['559', '560', '503', '561', '470', '562', '563', '564', '482', '565', '566', '567', '568', '532', '533', '534', '535', '489', '490', '536', '492', '537', '538', '495', '539', '540', '498', '541', '542', '501', '502', '569', '496', '570', '571', '572', '573', '574', '575', '576', '577', '515', '530', '578', '579', '580', '581'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.355_雪怪.png',
    traitName: '大雪球',
    traitEffect: '自己使用2次不同的冰系技能后，对手获得4层冻结，随后特性重置。',
  },
  {
    id: '477',
    name: '爆焰仔',
    types: ['火', '龙'],
    baseStats: { hp: 89, atk: 101, def: 105, spa: 50, spd: 65, spe: 88 },
    skills: ['470', '582', '583', '584', '585', '586', '587', '588', '487', '589', '590', '591', '592', '532', '486', '534', '488', '489', '593', '491', '492', '493', '494', '495', '496', '497', '498', '499', '500', '471', '507', '594', '595', '503', '540', '596', '597', '598', '480', '550', '485', '599', '512', '600'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.356_爆焰仔.png',
    traitName: '大火球',
    traitEffect: '自己使用2次不同的火系技能后，下次技能无需蓄力，随后特性重置。',
  },
  {
    id: '478',
    name: '爆焰喷喷',
    types: ['火', '龙'],
    baseStats: { hp: 112, atk: 127, def: 131, spa: 63, spd: 81, spe: 110 },
    skills: ['470', '582', '583', '584', '585', '586', '587', '588', '487', '589', '590', '591', '592', '532', '486', '534', '488', '489', '593', '491', '492', '493', '494', '495', '496', '497', '498', '499', '500', '471', '507', '594', '595', '503', '540', '596', '597', '598', '480', '550', '485', '599', '512', '600'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.357_爆焰喷喷.png',
    traitName: '大火球',
    traitEffect: '自己使用2次不同的火系技能后，下次技能无需蓄力，随后特性重置。',
  },
  {
    id: '479',
    name: '猴麦仔',
    types: ['普通', '机械'],
    baseStats: { hp: 93, atk: 75, def: 50, spa: 121, spd: 102, spe: 88 },
    skills: ['470', '521', '601', '501', '504', '474', '602', '603', '598', '604', '516', '605', '532', '486', '487', '488', '489', '593', '491', '492', '493', '494', '495', '496', '497', '498', '499', '500', '471', '507', '482', '472', '578', '517', '606', '576', '547', '546', '543', '544', '545', '480', '485', '483', '607'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.358_猴麦仔.png',
    traitName: '换碟',
    traitEffect: '自己携带的音波弹/音爆/金属噪音/午夜噪音威力提升，且获得巧变：同系别技能。',
  },
  {
    id: '480',
    name: '音碟吼',
    types: ['普通', '机械'],
    baseStats: { hp: 116, atk: 94, def: 63, spa: 151, spd: 127, spe: 110 },
    skills: ['470', '521', '601', '501', '504', '474', '602', '603', '598', '604', '516', '605', '532', '486', '487', '488', '489', '593', '491', '492', '493', '494', '495', '496', '497', '498', '499', '500', '471', '507', '482', '472', '578', '517', '606', '576', '547', '546', '543', '544', '545', '480', '485', '483', '607'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.359_音碟吼.png',
    traitName: '换碟',
    traitEffect: '自己携带的音波弹/音爆/金属噪音/午夜噪音威力提升，且获得巧变：同系别技能。',
  },
  {
    id: '481',
    name: '加油海葵',
    types: ['水', '萌'],
    baseStats: { hp: 93, atk: 87, def: 102, spa: 87, spd: 102, spe: 76 },
    skills: ['608', '609', '556', '610', '470', '611', '612', '613', '614', '615', '616', '617', '618', '619', '620', '563', '621', '588', '622', '623', '490', '565', '492', '624', '625', '626', '539', '526', '498', '541', '627', '501', '628', '629', '630', '553', '631', '632', '633', '634', '635', '636', '637', '638', '480', '554', '579', '639'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.360_加油海葵.png',
    traitName: '拉拉队长',
    traitEffect: '若自己在萌化状态下再获得萌化会解除萌化。',
  },
  {
    id: '482',
    name: '加油蟹',
    types: ['水', '萌'],
    baseStats: { hp: 116, atk: 108, def: 128, spa: 108, spd: 128, spe: 95 },
    skills: ['608', '609', '556', '610', '470', '611', '612', '613', '614', '615', '616', '617', '618', '619', '620', '563', '621', '588', '622', '623', '490', '565', '492', '624', '625', '626', '539', '526', '498', '541', '627', '501', '628', '629', '630', '553', '631', '632', '633', '634', '635', '636', '637', '638', '480', '554', '579', '639'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.361_加油蟹.png',
    traitName: '拉拉队长',
    traitEffect: '若自己在萌化状态下再获得萌化会解除萌化。',
  },
  {
    id: '483',
    name: '小丑豆豆',
    types: ['恶'],
    baseStats: { hp: 66, atk: 87, def: 49, spa: 88, spd: 74, spe: 72 },
    skills: ['640', '563', '641', '642', '627', '470', '643', '644', '500', '645', '646', '647', '648', '649', '650', '532', '621', '588', '622', '623', '490', '565', '492', '624', '494', '626', '539', '526', '651', '541', '542', '501', '628', '538', '652', '625', '653', '654', '655', '656', '657', '658', '579', '512', '515', '659', '503', '504', '660'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.362_小丑豆豆.png',
    traitName: '戏耍',
    traitEffect: '自己回复生命变为敌方扣除等量生命。',
  },
  {
    id: '484',
    name: '小丑兔',
    types: ['恶'],
    baseStats: { hp: 88, atk: 116, def: 66, spa: 118, spd: 99, spe: 96 },
    skills: ['640', '563', '641', '642', '627', '470', '643', '644', '500', '645', '646', '647', '648', '649', '650', '532', '621', '588', '622', '623', '490', '565', '492', '624', '494', '626', '539', '526', '651', '541', '542', '501', '628', '538', '652', '625', '653', '654', '655', '656', '657', '658', '579', '512', '515', '659', '503', '504', '660'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.363_小丑兔.png',
    traitName: '戏耍',
    traitEffect: '自己回复生命变为敌方扣除等量生命。',
  },
  {
    id: '485',
    name: '小丑公爵',
    types: ['恶'],
    baseStats: { hp: 111, atk: 145, def: 82, spa: 147, spd: 124, spe: 120 },
    skills: ['640', '563', '641', '642', '627', '470', '643', '644', '500', '645', '646', '647', '648', '649', '650', '532', '621', '588', '622', '623', '490', '565', '492', '624', '494', '626', '539', '526', '651', '541', '542', '501', '628', '538', '652', '625', '653', '654', '655', '656', '657', '658', '579', '512', '515', '659', '503', '504', '660'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.364_小丑公爵.png',
    traitName: '戏耍',
    traitEffect: '自己回复生命变为敌方扣除等量生命。',
  },
  {
    id: '486',
    name: '烟花团',
    types: ['火', '毒'],
    baseStats: { hp: 61, atk: 35, def: 50, spa: 89, spd: 78, spe: 76 },
    skills: ['661', '588', '662', '470', '663', '625', '664', '665', '487', '666', '667', '563', '621', '584', '622', '489', '668', '565', '492', '624', '494', '626', '669', '526', '651', '541', '542', '501', '628', '670', '671', '655', '672', '627', '648', '642', '673', '674', '544', '515', '478', '598'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.365_烟花团.png',
    traitName: '焰色反应',
    traitEffect: '在场时，衰减的灼烧变为相同层数的中毒。',
  },
  {
    id: '487',
    name: '烟花伯爵',
    types: ['火', '毒'],
    baseStats: { hp: 76, atk: 44, def: 62, spa: 111, spd: 97, spe: 95 },
    skills: ['661', '588', '662', '470', '663', '625', '664', '665', '487', '666', '667', '563', '621', '584', '622', '489', '668', '565', '492', '624', '494', '626', '669', '526', '651', '541', '542', '501', '628', '670', '671', '655', '672', '627', '648', '642', '673', '674', '544', '515', '478', '598'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.366_烟花伯爵.png',
    traitName: '焰色反应',
    traitEffect: '在场时，衰减的灼烧变为相同层数的中毒。',
  },
  {
    id: '488',
    name: '咕咕帽',
    types: ['幽'],
    baseStats: { hp: 103, atk: 74, def: 110, spa: 72, spd: 76, spe: 80 },
    skills: ['675', '676', '470', '576', '478', '677', '528', '678', '577', '679', '680', '681', '636', '682', '683', '563', '621', '584', '622', '489', '593', '565', '492', '624', '625', '626', '669', '526', '651', '541', '542', '501', '628', '505', '506', '684', '685', '648', '572', '646', '598', '686', '554', '550', '515', '687', '573'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.367_咕咕帽.png',
    traitName: '魔术帽',
    traitEffect: '在场时，场上双方携带的技能获得巧变：同系别技能。',
  },
  {
    id: '489',
    name: '咕德帽帽',
    types: ['幽'],
    baseStats: { hp: 128, atk: 92, def: 137, spa: 90, spd: 95, spe: 100 },
    skills: ['675', '676', '470', '576', '478', '677', '528', '678', '577', '679', '680', '681', '636', '682', '683', '563', '621', '584', '622', '489', '593', '565', '492', '624', '625', '626', '669', '526', '651', '541', '542', '501', '628', '505', '506', '684', '685', '648', '572', '646', '598', '686', '554', '550', '515', '687', '573'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.368_咕德帽帽.png',
    traitName: '魔术帽',
    traitEffect: '在场时，场上双方携带的技能获得巧变：同系别技能。',
  },
  {
    id: '490',
    name: '炫光迪迪',
    types: ['电', '光'],
    baseStats: { hp: 83, atk: 95, def: 52, spa: 111, spd: 106, spe: 104 },
    skills: ['688', '689', '690', '691', '470', '692', '693', '694', '695', '696', '697', '698', '699', '563', '621', '588', '622', '623', '490', '565', '492', '537', '625', '626', '539', '526', '651', '541', '627', '501', '628', '624', '700', '701', '702', '703', '636', '555', '485', '704', '639', '705', '706', '518'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.369_炫光迪迪.png',
    traitName: '安可',
    traitEffect: '使用光系技能后，回合结束时自己返场。',
  },
  {
    id: '491',
    name: '小鼓象',
    types: ['机械'],
    baseStats: { hp: 106, atk: 100, def: 138, spa: 63, spd: 68, spe: 64 },
    skills: ['471', '523', '603', '477', '470', '707', '475', '604', '473', '474', '481', '607', '708', '563', '621', '584', '622', '489', '490', '565', '492', '624', '625', '626', '669', '526', '651', '541', '572', '501', '502', '551', '709', '710', '639', '687', '711', '628', '636', '518', '528', '484', '712', '713', '485'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.371_小鼓象.png',
    traitName: '合拍',
    traitEffect: '若本回合自己与敌方使用的技能在系别/类型/能耗上每有1项相同，回合结束时获得物攻和物防永久+20%。',
  },
  {
    id: '492',
    name: '巨鼓象',
    types: ['机械'],
    baseStats: { hp: 133, atk: 125, def: 173, spa: 79, spd: 85, spe: 80 },
    skills: ['471', '523', '603', '477', '470', '707', '475', '604', '473', '474', '481', '607', '708', '563', '621', '584', '622', '489', '490', '565', '492', '624', '625', '626', '669', '526', '651', '541', '572', '501', '502', '551', '709', '710', '639', '687', '711', '628', '636', '518', '528', '484', '712', '713', '485'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.372_巨鼓象.png',
    traitName: '合拍',
    traitEffect: '若本回合自己与敌方使用的技能在系别/类型/能耗上每有1项相同，回合结束时获得物攻和物防永久+20%。',
  },
  {
    id: '493',
    name: '牵线木偶',
    types: ['幻'],
    baseStats: { hp: 77, atk: 83, def: 69, spa: 89, spd: 107, spe: 84 },
    skills: ['714', '515', '470', '505', '636', '715', '550', '506', '685', '716', '579', '563', '621', '588', '622', '623', '668', '565', '492', '624', '625', '626', '669', '526', '651', '676', '627', '476', '717', '533', '718', '719', '720', '721', '722', '723', '690', '724', '554', '686', '485', '660', '508', '684', '725', '711', '504'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.373_牵线木偶.png',
    traitName: '盲从',
    traitEffect: '可以携带多个复写/借用/取念技能，非幻系技能能耗-2。',
  },
  {
    id: '494',
    name: '帅帅魔偶',
    types: ['幻'],
    baseStats: { hp: 97, atk: 104, def: 86, spa: 111, spd: 133, spe: 105 },
    skills: ['714', '515', '470', '505', '636', '715', '550', '506', '685', '716', '579', '563', '621', '588', '622', '623', '668', '565', '492', '624', '625', '626', '669', '526', '651', '676', '627', '476', '717', '533', '718', '719', '720', '721', '722', '723', '690', '724', '554', '686', '485', '660', '508', '684', '725', '711', '504'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.374_帅帅魔偶.png',
    traitName: '盲从',
    traitEffect: '可以携带多个复写/借用/取念技能，非幻系技能能耗-2。',
  },
  {
    id: '495',
    name: '学院呱呱',
    types: ['武'],
    baseStats: { hp: 132, atk: 99, def: 92, spa: 99, spd: 92, spe: 100 },
    skills: ['470', '640', '504', '569', '503', '726', '669', '544', '563', '621', '588', '622', '710', '668', '565', '585', '624', '625', '626', '580', '526', '651', '676', '627', '476', '628', '727', '560', '536', '728', '561', '729', '730', '731', '732', '733', '533', '734', '735', '736', '719', '718', '737', '738', '739', '740', '741', '742', '743', '744', '745', '746', '747', '659', '656', '748', '749', '750', '751', '752', '701', '510', '509', '593', '674', '753', '754', '755', '756', '757', '758', '759', '760', '761', '723', '690', '762', '763', '764', '765', '695', '766', '767', '768', '662', '538', '652', '769', '770', '771', '772', '773', '774', '775', '573', '572', '776', '647', '777', '642', '778', '574', '650', '779', '489', '780', '781', '689', '709', '555', '551', '782', '692', '783', '505', '784', '506', '687', '785', '786', '787', '788', '789', '661', '790', '534', '791', '589', '792', '664', '793', '794', '795', '796', '663', '599', '797', '798', '594', '799', '800', '471', '472', '801', '477', '501', '802', '483', '803', '804', '587', '592', '492', '595', '600', '608', '498', '610', '614', '805', '618', '806', '807', '619', '808', '524', '809', '810', '811', '812', '813', '528', '513', '631', '632', '527', '602', '814', '514', '815', '578', '816', '817', '818', '819', '820', '821', '822', '517', '823', '824', '825', '826', '530', '547', '546', '596', '601', '558', '605', '482', '597', '549', '827', '535', '828', '556', '612', '552', '829', '830', '616', '831', '832', '833', '834', '553', '496', '835', '557', '630', '570', '836', '837', '838', '571', '839', '840', '519', '841', '522', '540', '842', '525', '843', '844', '845', '531', '846', '548', '675', '847', '848', '576', '541', '606', '849', '850', '681', '577', '683'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.375_学院呱呱.png',
    traitName: '留学生',
    traitEffect: '自己全技能能耗+2，可以学习全部攻击技能石x。',
  },
  {
    id: '496',
    name: '霹雳迪迪',
    types: ['电', '光'],
    baseStats: { hp: 104, atk: 119, def: 65, spa: 139, spd: 133, spe: 130 },
    skills: ['688', '689', '690', '691', '470', '692', '693', '694', '695', '696', '697', '698', '699', '563', '621', '588', '622', '623', '490', '565', '492', '537', '625', '626', '539', '526', '651', '541', '627', '501', '628', '624', '700', '701', '702', '703', '636', '555', '485', '704', '639', '705', '706', '518'],
    imageUrl: 'https://static.gamecenter.qq.com/xgame/roco-kingdom/compendium/a/i/NO.370_霹雳迪迪.png',
    traitName: '安可',
    traitEffect: '使用光系技能后，回合结束时自己返场。',
  },
  {
    id: '497',
    name: '深渊罗隐',
    types: ['地', '恶'],
    baseStats: { hp: 107, atk: 159, def: 167, spa: 78, spd: 32, spe: 75 },
    skills: ['243', '363', '66', '7', '196', '222', '382', '107', '228', '239', '78', '111', '232', '240', '20', '112', '22', '23', '24', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '38', '166', '130', '171', '229', '246', '42', '44', '97', '221', '113', '52', '3', '165'],
    imageUrl: "/images/spirits/JL_shenyuanluoyin.webp",
    traitName: '盛宴',
    traitEffect: '能量不足时，消耗5%最大生命，代替1能量。生命低于50%时，获得吸血100%。',
  },
  {
    id: '498',
    name: '暮风隐者（金黄的样子）',
    types: ['普通', '虫'],
    baseStats: { hp: 105, atk: 30, def: 105, spa: 119, spd: 91, spe: 125 },
    skills: ['357', '192', '118', '3', '73', '322', '84', '162', '255', '148', '278', '303', '20', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '353', '51', '87', '170', '115', '156', '157', '152', '337', '109', '375', '268', '234', '153', '60', '361', '27', '114', '323'],
    imageUrl: "/images/spirits/JL_fenggunmuchong_shouling.webp",
    traitName: '共鸣',
    traitEffect: '携带的【虫鸣】技能威力+20。',
  },
  {
    id: '499',
    name: '暮风隐者（枯叶的样子）',
    types: ['普通', '虫'],
    baseStats: { hp: 107, atk: 31, def: 102, spa: 122, spd: 87, spe: 125 },
    skills: ['357', '192', '118', '3', '73', '322', '84', '162', '255', '148', '278', '303', '20', '317', '22', '351', '174', '352', '103', '71', '28', '258', '74', '31', '32', '353', '51', '87', '170', '115', '156', '157', '152', '337', '109', '375', '268', '234', '153', '60', '361', '27', '114', '323'],
    imageUrl: "/images/spirits/JL_fenggunmuchong_shouling.webp",
    traitName: '齐鸣',
    traitEffect: '自己携带的「虫鸣」技能威力+20，己方精灵携带的虫系技能获得巧变：虫鸣',
  },
  {
    id: '500',
    name: '风暴酷拉',
    types: ['电'],
    baseStats: { hp: 83, atk: 100, def: 78, spa: 100, spd: 97, spe: 125},
    skills: ['3', '23', '4', '399', '299', '10', '403', '49', '67', '452', '330', '356', '114', '332', '118', '21', '22', '333', '24', '25', '26', '27', '72', '29', '74', '31', '259', '33', '34', '35', '36', '37', '156', '245', '38', '7', '444', '302', '159', '168', '153', '76', '328', '160', '263', '357', '322', '254', '303'],
    imageUrl: "/images/spirits/JL_kula_shouling.webp",
    traitName: '噼啪噼啪！',
    traitEffect: '入场后首次行动，所选技能使用次数+1，且该回合每次行动后回复2能量。',
  },
  {
    id: '501',
    name: '烈焰狂战士',
    types: ['火'],
    baseStats: { hp: 105, atk: 79, def: 110, spa: 13, spd: 93, spe: 65 },
    skills: ['3', '25', '69', '443', '7', '149', '42', '102', '153', '100', '101', '52', '202', '1', '21', '22', '23', '174', '6', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '187', '196', '68', '130', '214', '301', '246', '155', '247', '341', '44', '223', '276', '113'],
    imageUrl: "/images/spirits/img_Fir_WaTeBo_001_Res.webp",
    traitName: '蒸汽革命',
    traitEffect: '己方精灵每使用1次火系技能，自己入场时获得全技能威力+10。己方精灵每使用1次火系技能，自己入场时获得全技能威力+10和物防+5%',
  },
  {
    id: '502',
    name: '高帽鹬者',
    types: ['翼'],
    baseStats: { hp: 96, atk: 106, def: 119, spa: 106, spd: 93, spe: 115 },
    skills: ['265', '262', '3', '37', '161', '217', '364', '139', '169', '106', '197', '113', '198', '110', '83', '54', '66', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '76', '77', '78', '86', '138', '115', '157', '337', '130', '142', '109', '155', '159', '85', '45', '168', '205', '365', '47', '153', '440', '216', '90', '125'],
    imageUrl: "/images/spirits/JL_gaomaoyuzhe.webp",
    traitName: '相争',
    traitEffect: '本场战斗首次使用的技能获得迅捷。拥有迅捷效果的技能先手+1。',
  },
  {
    id: '503',
    name: '满月砣（上弦的样子）',
    types: ['毒', '萌'],
    baseStats: { hp: 140, atk: 111, def: 100, spa: 108, spd: 81, spe: 105 },
    skills: ['393', '213', '76', '305', '86', '395', '252', '3', '87', '307', '319', '81', '256', '108', '310', '20', '112', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '259', '77', '78', '35', '79', '80', '54', '166', '214', '142', '83', '257', '84', '85', '309', '123', '122', '47', '9', '347', '90', '170', '418', '165'],
    imageUrl: "/images/spirits/img_Poi_CiLunTuoBo_001_Res.webp",
    traitName: '月相',
    traitEffect: '敌方受到中毒效果伤害时，自己回复等量生命。每过量回复10%生命敌方获得1层中毒。',
  },
  {
    id: '504',
    name: '满月砣（下弦的样子）',
    types: ['毒', '萌'],
    baseStats: { hp: 140, atk: 108, def: 81, spa: 111, spd: 100, spe: 105 },
    skills: ['393', '213', '76', '305', '86', '395', '252', '3', '87', '307', '319', '81', '256', '108', '310', '20', '112', '22', '67', '68', '69', '70', '56', '72', '73', '74', '75', '259', '77', '78', '35', '79', '80', '54', '166', '214', '142', '83', '257', '84', '85', '309', '123', '122', '47', '9', '347', '90', '170', '418', '165'],
    imageUrl: "/images/spirits/img_Poi_CiLunTuoBo_001_Res.webp",
    traitName: '月相',
    traitEffect: '敌方受到中毒效果伤害时，自己回复等量生命。每过量回复10%生命敌方获得1层中毒。',
  },
  {
    id: '505',
    name: '淤泥乌泽',
    types: ['地', '翼'],
    baseStats: { hp: 124, atk: 138, def: 132, spa: 58, spd: 108, spe: 98 },
    skills: ['7', '223', '195', '106', '196', '221', '206', '78', '110', '382', '228', '200', '232', '1', '112', '22', '23', '24', '25', '103', '27', '13', '29', '94', '104', '105', '33', '51', '87', '36', '115', '337', '229', '109', '315', '84', '85', '111', '44', '191', '80', '276', '366', '222', '3'],
    imageUrl: "/images/spirits/JL_nihouya_shouling.webp",
    traitName: '强制过滤',
    traitEffect: '在场时，所有精灵连击数固定为1。',
  },
  {
    id: '506',
    name: '暗夜颅主',
    types: ['幽'],
    baseStats: { hp: 117, atk: 5, def: 95, spa: 66, spd: 112, spe: 80 },
    skills: ['3', '103', '70', '211', '4', '304', '85', '269', '210', '314', '181', '212', '155', '118', '21', '22', '23', '24', '25', '207', '27', '28', '29', '74', '31', '32', '33', '34', '35', '36', '37', '187', '337', '214', '144', '42', '99', '272', '311', '465', '146', '90', '298', '439', '114'],
    imageUrl: "/images/spirits/JL_anyeluzhu.webp",
    traitName: '扫荡',
    traitEffect: '敌方每使用1次「聚能」技能或更换精灵，自己入场时获得魔攻+20%和魔防+10%。',
  },
  {
    id: '507',
    name: '恶魔男爵',
    types: ['恶', '翼'],
    baseStats: { hp: 117, atk: 128, def: 103, spa: 55, spd: 73, spe: 120 },
    skills: [],
    imageUrl: '',
    traitName: '贪得无厌',
    traitEffect: '',
  },
  {
    id: '508',
    name: '长尾火鸟',
    types: ['火', '翼'],
    baseStats: { hp: 63, atk: 52, def: 49, spa: 65, spd: 85, spe: 96 },
    skills: [],
    imageUrl: '',
    traitName: '不死鸟',
    traitEffect: '',
  },
  {
    id: '509',
    name: '火羽',
    types: ['火', '翼'],
    baseStats: { hp: 78, atk: 65, def: 61, spa: 81, spd: 106, spe: 120 },
    skills: [],
    imageUrl: '',
    traitName: '不死鸟',
    traitEffect: '',
  },
  {
    id: '510',
    name: '叮叮卯',
    types: ['机械', '虫'],
    baseStats: { hp: 117, atk: 45, def: 75, spa: 81, spd: 136, spe: 48 },
    skills: [],
    imageUrl: '',
    traitName: '上锁',
    traitEffect: '',
  },
  {
    id: '511',
    name: '飞飞钥',
    types: ['机械', '虫'],
    baseStats: { hp: 146, atk: 57, def: 94, spa: 101, spd: 170, spe: 60 },
    skills: [],
    imageUrl: '',
    traitName: '上锁',
    traitEffect: '',
  },
  {
    id: '512',
    name: '碎晶蝎',
    types: ['恶', '地'],
    baseStats: { hp: 65, atk: 76, def: 71, spa: 70, spd: 47, spe: 57 },
    skills: [],
    imageUrl: '',
    traitName: '流沙统治者',
    traitEffect: '',
  },
  {
    id: '513',
    name: '晶尾蝎',
    types: ['恶', '地'],
    baseStats: { hp: 86, atk: 101, def: 95, spa: 94, spd: 63, spe: 76 },
    skills: [],
    imageUrl: '',
    traitName: '流沙统治者',
    traitEffect: '',
  },
  {
    id: '514',
    name: '蝎子王',
    types: ['恶', '地'],
    baseStats: { hp: 108, atk: 126, def: 119, spa: 117, spd: 79, spe: 95 },
    skills: [],
    imageUrl: '',
    traitName: '流沙统治者',
    traitEffect: '',
  },
  {
    id: '515',
    name: '森豆丁',
    types: ['草'],
    baseStats: { hp: 87, atk: 93, def: 79, spa: 42, spd: 53, spe: 42 },
    skills: [],
    imageUrl: '',
    traitName: '盘根木',
    traitEffect: '',
  },
  {
    id: '516',
    name: '森蛮人',
    types: ['草'],
    baseStats: { hp: 115, atk: 124, def: 106, spa: 56, spd: 70, spe: 56 },
    skills: [],
    imageUrl: '',
    traitName: '盘根木',
    traitEffect: '',
  },
  {
    id: '517',
    name: '森巨人',
    types: ['草'],
    baseStats: { hp: 144, atk: 155, def: 132, spa: 70, spd: 88, spe: 70 },
    skills: [],
    imageUrl: '',
    traitName: '盘根木',
    traitEffect: '',
  },
  {
    id: '518',
    name: '霹雳宝宝',
    types: ['电'],
    baseStats: { hp: 54, atk: 66, def: 67, spa: 66, spd: 56, spe: 72 },
    skills: [],
    imageUrl: '',
    traitName: '电子音乐',
    traitEffect: '',
  },
  {
    id: '519',
    name: '雷鸣小子',
    types: ['电'],
    baseStats: { hp: 72, atk: 88, def: 90, spa: 88, spd: 74, spe: 96 },
    skills: [],
    imageUrl: '',
    traitName: '电子音乐',
    traitEffect: '',
  },
  {
    id: '520',
    name: '雷神之子',
    types: ['电'],
    baseStats: { hp: 90, atk: 110, def: 112, spa: 110, spd: 93, spe: 120 },
    skills: [],
    imageUrl: '',
    traitName: '电子音乐',
    traitEffect: '',
  },
  {
    id: '521',
    name: '雪灵兽',
    types: ['冰'],
    baseStats: { hp: 62, atk: 66, def: 67, spa: 24, spd: 62, spe: 75 },
    skills: [],
    imageUrl: '',
    traitName: '冰雪魂魄',
    traitEffect: '',
  },
  {
    id: '522',
    name: '幻雪兽',
    types: ['冰'],
    baseStats: { hp: 83, atk: 88, def: 89, spa: 32, spd: 82, spe: 100 },
    skills: [],
    imageUrl: '',
    traitName: '冰雪魂魄',
    traitEffect: '',
  },
  {
    id: '523',
    name: '饮雪狂兽',
    types: ['冰'],
    baseStats: { hp: 104, atk: 110, def: 111, spa: 40, spd: 103, spe: 125 },
    skills: [],
    imageUrl: '',
    traitName: '冰雪魂魄',
    traitEffect: '',
  },
  {
    id: '524',
    name: '火豆丁',
    types: ['火'],
    baseStats: { hp: 45, atk: 46, def: 49, spa: 15, spd: 30, spe: 29 },
    skills: [],
    imageUrl: '',
    traitName: '淬炼火',
    traitEffect: '',
  },
  {
    id: '525',
    name: '火蛮人',
    types: ['火'],
    baseStats: { hp: 60, atk: 62, def: 65, spa: 20, spd: 41, spe: 39 },
    skills: [],
    imageUrl: '',
    traitName: '淬炼火',
    traitEffect: '',
  },
  {
    id: '526',
    name: '火巨人',
    types: ['火'],
    baseStats: { hp: 75, atk: 77, def: 81, spa: 26, spd: 51, spe: 49 },
    skills: [],
    imageUrl: '',
    traitName: '淬炼火',
    traitEffect: '',
  },
  {
    id: '527',
    name: '友爱天天',
    types: ['普通'],
    baseStats: { hp: 97, atk: 30, def: 70, spa: 93, spd: 80, spe: 76 },
    skills: [],
    imageUrl: '',
    traitName: '友谊之果',
    traitEffect: '',
  },
  {
    id: '528',
    name: '友爱星飞',
    types: ['普通'],
    baseStats: { hp: 122, atk: 37, def: 88, spa: 116, spd: 100, spe: 95 },
    skills: [],
    imageUrl: '',
    traitName: '友谊之果',
    traitEffect: '',
  },
  {
    id: '529',
    name: '莫比乌乌',
    types: ['龙', '萌'],
    baseStats: { hp: 80, atk: 40, def: 71, spa: 105, spd: 90, spe: 80 },
    skills: [],
    imageUrl: '',
    traitName: '莫比乌斯',
    traitEffect: '',
  },
  {
    id: '530',
    name: '克莱因龙',
    types: ['龙', '萌'],
    baseStats: { hp: 100, atk: 50, def: 89, spa: 131, spd: 113, spe: 100 },
    skills: [],
    imageUrl: '',
    traitName: '莫比乌斯',
    traitEffect: '',
  },
  {
    id: '531',
    name: '瑰眼仔',
    types: ['恶', '虫'],
    baseStats: { hp: 67, atk: 59, def: 59, spa: 60, spd: 71, spe: 57 },
    skills: [],
    imageUrl: '',
    traitName: '瞳中倒影',
    traitEffect: '',
  },
  {
    id: '532',
    name: '耳翎瑰魅',
    types: ['恶', '虫'],
    baseStats: { hp: 89, atk: 78, def: 79, spa: 80, spd: 95, spe: 76 },
    skills: [],
    imageUrl: '',
    traitName: '瞳中倒影',
    traitEffect: '',
  },
  {
    id: '533',
    name: '邪眼巨魔',
    types: ['恶', '虫'],
    baseStats: { hp: 111, atk: 98, def: 99, spa: 99, spd: 119, spe: 95 },
    skills: [],
    imageUrl: '',
    traitName: '瞳中倒影',
    traitEffect: '',
  },
  {
    id: '534',
    name: '觅觅蝠',
    types: ['翼'],
    baseStats: { hp: 79, atk: 62, def: 60, spa: 61, spd: 76, spe: 33 },
    skills: [],
    imageUrl: '',
    traitName: '异类',
    traitEffect: '',
  },
  {
    id: '535',
    name: '翻翻蝠',
    types: ['翼'],
    baseStats: { hp: 105, atk: 82, def: 80, spa: 81, spd: 101, spe: 44 },
    skills: [],
    imageUrl: '',
    traitName: '异类',
    traitEffect: '',
  },
  {
    id: '536',
    name: '夜游魔',
    types: ['翼'],
    baseStats: { hp: 132, atk: 103, def: 100, spa: 101, spd: 127, spe: 55 },
    skills: [],
    imageUrl: '',
    traitName: '异类',
    traitEffect: '',
  },
  {
    id: '537',
    name: '芽眼魔',
    types: ['恶水'],
    baseStats: { hp: 80, atk: 62, def: 58, spa: 59, spd: 66, spe: 45 },
    skills: [],
    imageUrl: '',
    traitName: '滴眼液',
    traitEffect: '',
  },
  {
    id: '538',
    name: '叶眼魔',
    types: ['恶水'],
    baseStats: { hp: 107, atk: 82, def: 77, spa: 78, spd: 88, spe: 60 },
    skills: [],
    imageUrl: '',
    traitName: '滴眼液',
    traitEffect: '',
  },
  {
    id: '539',
    name: '障眼魔',
    types: ['恶水'],
    baseStats: { hp: 134, atk: 103, def: 96, spa: 98, spd: 110, spe: 75 },
    skills: [],
    imageUrl: '',
    traitName: '滴眼液',
    traitEffect: '',
  },
  {
    id: '540',
    name: '星云旅者',
    types: ['翼', '幻'],
    baseStats: { hp: 104, atk: 32, def: 104, spa: 129, spd: 83, spe: 120 },
    skills: [],
    imageUrl: '',
    traitName: '与星星同行',
    traitEffect: '',
  },
  {
    id: '541',
    name: '点点',
    types: ['萌'],
    baseStats: { hp: 94, atk: 41, def: 56, spa: 84, spd: 94, spe: 80 },
    skills: [],
    imageUrl: '',
    traitName: '迎宾',
    traitEffect: '',
  },
  {
    id: '542',
    name: '珀尔鼬',
    types: ['萌'],
    baseStats: { hp: 117, atk: 51, def: 69, spa: 105, spd: 117, spe: 100 },
    skills: [],
    imageUrl: '',
    traitName: '迎宾',
    traitEffect: '',
  },
  {
    id: '543',
    name: '不咕钟',
    types: ['机械', '幻'],
    baseStats: { hp: 68, atk: 67, def: 58, spa: 68, spd: 93, spe: 76 },
    skills: [],
    imageUrl: '',
    traitName: '整点报时',
    traitEffect: '',
  },
  {
    id: '544',
    name: '溯源钟',
    types: ['机械', '幻'],
    baseStats: { hp: 85, atk: 84, def: 72, spa: 86, spd: 116, spe: 95 },
    skills: [],
    imageUrl: '',
    traitName: '整点报时',
    traitEffect: '',
  },
  {
    id: '545',
    name: '加灵',
    types: ['普通', '萌'],
    baseStats: { hp: 39, atk: 22, def: 50, spa: 57, spd: 74, spe: 66 },
    skills: [],
    imageUrl: '',
    traitName: '有求必应',
    traitEffect: '',
  },
  {
    id: '546',
    name: '加益',
    types: ['普通', '萌'],
    baseStats: { hp: 52, atk: 29, def: 67, spa: 75, spd: 99, spe: 88 },
    skills: [],
    imageUrl: '',
    traitName: '有求必应',
    traitEffect: '',
  },
  {
    id: '547',
    name: '加尔',
    types: ['普通', '萌'],
    baseStats: { hp: 103, atk: 36, def: 84, spa: 94, spd: 124, spe: 110 },
    skills: [],
    imageUrl: '',
    traitName: '有求必应',
    traitEffect: '',
  },
  {
    id: '548',
    name: '黑化加尔',
    types: ['普通', '幽'],
    baseStats: { hp: 84, atk: 35, def: 94, spa: 104, spd: 124, spe: 110 },
    skills: [],
    imageUrl: '',
    traitName: '一意孤行',
    traitEffect: '',
  },
  {
    id: '549',
    name: '咬咬小子',
    types: ['机械'],
    baseStats: { hp: 102, atk: 102, def: 48, spa: 17, spd: 92, spe: 76 },
    skills: [],
    imageUrl: '',
    traitName: '守护之心',
    traitEffect: '',
  },
  {
    id: '550',
    name: '胡桃王子',
    types: ['机械'],
    baseStats: { hp: 128, atk: 127, def: 60, spa: 21, spd: 115, spe: 95 },
    skills: [],
    imageUrl: '',
    traitName: '守护之心',
    traitEffect: '',
  },
  {
    id: '551',
    name: '足尖元件',
    types: ['机械', '幻'],
    baseStats: { hp: 91, atk: 40, def: 62, spa: 88, spd: 96, spe: 100 },
    skills: [],
    imageUrl: '',
    traitName: '和弦共振',
    traitEffect: '',
  },
  {
    id: '552',
    name: '离心舞者',
    types: ['机械', '幻'],
    baseStats: { hp: 114, atk: 50, def: 77, spa: 110, spd: 120, spe: 125 },
    skills: [],
    imageUrl: '',
    traitName: '和弦共振',
    traitEffect: '',
  },
  {
    id: '553',
    name: '蝴蝶陶陶',
    types: ['萌'],
    baseStats: { hp: 57, atk: 60, def: 65, spa: 16, spd: 57, spe: 75 },
    skills: [],
    imageUrl: '',
    traitName: '猫精灵的礼物',
    traitEffect: '',
  },
  {
    id: '554',
    name: '铆钉毛毛',
    types: ['萌', '毒'],
    baseStats: { hp: 76, atk: 80, def: 87, spa: 21, spd: 76, spe: 100 },
    skills: [],
    imageUrl: '',
    traitName: '猫精灵的礼物',
    traitEffect: '',
  },
  {
    id: '555',
    name: '徘徊爪爪',
    types: ['萌', '毒'],
    baseStats: { hp: 95, atk: 100, def: 109, spa: 27, spd: 95, spe: 125 },
    skills: [],
    imageUrl: '',
    traitName: '猫精灵的礼物',
    traitEffect: '',
  },
  {
    id: '556',
    name: '苞米仔',
    types: ['草', '火'],
    baseStats: { hp: 92, atk: 79, def: 88, spa: 80, spd: 88, spe: 60 },
    skills: [],
    imageUrl: '',
    traitName: '爆裂玉米',
    traitEffect: '',
  },
  {
    id: '557',
    name: '炮米花',
    types: ['草', '火'],
    baseStats: { hp: 115, atk: 99, def: 110, spa: 100, spd: 110, spe: 75 },
    skills: [],
    imageUrl: '',
    traitName: '爆裂玉米',
    traitEffect: '',
  },
  {
    id: '558',
    name: '十字蝌蚪',
    types: ['水'],
    baseStats: { hp: 68, atk: 86, def: 70, spa: 36, spd: 52, spe: 66 },
    skills: [],
    imageUrl: '',
    traitName: '王子的诺言',
    traitEffect: '',
  },
  {
    id: '559',
    name: '十字蛙',
    types: ['水'],
    baseStats: { hp: 91, atk: 115, def: 93, spa: 48, spd: 70, spe: 88 },
    skills: [],
    imageUrl: '',
    traitName: '王子的诺言',
    traitEffect: '',
  },
  {
    id: '560',
    name: '深渊蛙',
    types: ['水', '武'],
    baseStats: { hp: 113, atk: 143, def: 116, spa: 60, spd: 87, spe: 110 },
    skills: [],
    imageUrl: '',
    traitName: '王子的诺言',
    traitEffect: '',
  },
  {
    id: '561',
    name: '卡波',
    types: ['恶'],
    baseStats: { hp: 94, atk: 65, def: 66, spa: 18, spd: 55, spe: 68 },
    skills: [],
    imageUrl: '',
    traitName: '诅咒',
    traitEffect: '',
  },
  {
    id: '562',
    name: '卡拉波斯',
    types: ['恶'],
    baseStats: { hp: 117, atk: 81, def: 82, spa: 23, spd: 68, spe: 85 },
    skills: [],
    imageUrl: '',
    traitName: '诅咒',
    traitEffect: '',
  },
  {
    id: '563',
    name: '守夜烛',
    types: ['火', '光'],
    baseStats: { hp: 97, atk: 76, def: 86, spa: 83, spd: 98, spe: 84 },
    skills: [],
    imageUrl: '',
    traitName: '光度换算',
    traitEffect: '',
  },
  {
    id: '564',
    name: '流明坎德拉',
    types: ['火', '光'],
    baseStats: { hp: 121, atk: 96, def: 108, spa: 104, spd: 123, spe: 105 },
    skills: [],
    imageUrl: '',
    traitName: '光度换算',
    traitEffect: '',
  },
  {
    id: '565',
    name: '蜜果骸',
    types: ['幽', '草'],
    baseStats: { hp: 102, atk: 43, def: 68, spa: 110, spd: 85, spe: 88 },
    skills: [],
    imageUrl: '',
    traitName: '长久保存制法',
    traitEffect: '',
  },
  {
    id: '566',
    name: '半朽蜜果灵',
    types: ['幽', '草'],
    baseStats: { hp: 128, atk: 54, def: 84, spa: 138, spd: 106, spe: 110 },
    skills: [],
    imageUrl: '',
    traitName: '长久保存制法',
    traitEffect: '',
  },
  {
    id: '567',
    name: '稻草人',
    types: ['萌', '武'],
    baseStats: { hp: 103, atk: 77, def: 97, spa: 77, spd: 97, spe: 44 },
    skills: [],
    imageUrl: '',
    traitName: '守望者',
    traitEffect: '',
  },
  {
    id: '568',
    name: '稻草守护者',
    types: ['萌', '武'],
    baseStats: { hp: 128, atk: 96, def: 121, spa: 96, spd: 121, spe: 55 },
    skills: [],
    imageUrl: '',
    traitName: '守望者',
    traitEffect: '',
  },
  {
    id: '569',
    name: '栗鼠',
    types: ['毒', '普通'],
    baseStats: { hp: 91, atk: 61, def: 62, spa: 63, spd: 89, spe: 80 },
    skills: [],
    imageUrl: '',
    traitName: '扎手',
    traitEffect: '',
  },
  {
    id: '570',
    name: '壳栗丝鼠',
    types: ['毒', '普通'],
    baseStats: { hp: 114, atk: 77, def: 77, spa: 79, spd: 111, spe: 100 },
    skills: [],
    imageUrl: '',
    traitName: '扎手',
    traitEffect: '',
  },
  {
    id: '571',
    name: '睡铃雪影娃娃',
    types: ['冰', '草'],
    baseStats: { hp: 116, atk: 42, def: 85, spa: 104, spd: 116, spe: 100 },
    skills: [],
    imageUrl: '',
    traitName: '安眠',
    traitEffect: '',
  },
  {
    id: '572',
    name: '宝藏小狐',
    types: ['普通'],
    baseStats: { hp: 77, atk: 81, def: 99, spa: 33, spd: 73, spe: 80 },
    skills: [],
    imageUrl: '',
    traitName: '博物',
    traitEffect: '',
  },
  {
    id: '573',
    name: '宝藏沙狐',
    types: ['普通'],
    baseStats: { hp: 96, atk: 101, def: 124, spa: 41, spd: 91, spe: 100 },
    skills: [],
    imageUrl: '',
    traitName: '博物',
    traitEffect: '',
  },
  {
    id: '574',
    name: '诅咒狼灵',
    types: ['幽', '幻'],
    baseStats: { hp: 69, atk: 77, def: 77, spa: 31, spd: 59, spe: 78 },
    skills: [],
    imageUrl: '',
    traitName: '铭记于月亮',
    traitEffect: '',
  },
  {
    id: '575',
    name: '新月狼灵',
    types: ['幽', '幻'],
    baseStats: { hp: 92, atk: 103, def: 102, spa: 41, spd: 78, spe: 104 },
    skills: [],
    imageUrl: '',
    traitName: '铭记于月亮',
    traitEffect: '',
  },
  {
    id: '576',
    name: '银月狼王',
    types: ['幽', '幻'],
    baseStats: { hp: 115, atk: 128, def: 128, spa: 51, spd: 98, spe: 130 },
    skills: [],
    imageUrl: '',
    traitName: '铭记于月亮',
    traitEffect: '',
  },
  {
    id: '577',
    name: '新月鹭',
    types: ['翼', '机械'],
    baseStats: { hp: 50, atk: 59, def: 62, spa: 60, spd: 68, spe: 69 },
    skills: [],
    imageUrl: '',
    traitName: '冷光源',
    traitEffect: '',
  },
  {
    id: '578',
    name: '月辉鹭',
    types: ['翼', '机械'],
    baseStats: { hp: 66, atk: 79, def: 83, spa: 80, spd: 90, spe: 92 },
    skills: [],
    imageUrl: '',
    traitName: '冷光源',
    traitEffect: '',
  },
  {
    id: '579',
    name: '月使鹭纳',
    types: ['翼', '机械'],
    baseStats: { hp: 83, atk: 99, def: 104, spa: 100, spd: 113, spe: 115 },
    skills: [],
    imageUrl: '',
    traitName: '冷光源',
    traitEffect: '',
  },
  {
    id: '580',
    name: '热团团',
    types: ['火', '虫'],
    baseStats: { hp: 48, atk: 69, def: 72, spa: 18, spd: 72, spe: 63 },
    skills: [],
    imageUrl: '',
    traitName: '热成像',
    traitEffect: '',
  },
  {
    id: '581',
    name: '焰米龙',
    types: ['火', '虫'],
    baseStats: { hp: 63, atk: 92, def: 96, spa: 23, spd: 96, spe: 84 },
    skills: [],
    imageUrl: '',
    traitName: '热成像',
    traitEffect: '',
  },
  {
    id: '582',
    name: '圣凯布米龙',
    types: ['火', '虫'],
    baseStats: { hp: 79, atk: 116, def: 120, spa: 29, spd: 120, spe: 105 },
    skills: [],
    imageUrl: '',
    traitName: '热成像',
    traitEffect: '',
  },
  {
    id: '583',
    name: '章脑丸',
    types: ['光', '水'],
    baseStats: { hp: 89, atk: 42, def: 69, spa: 99, spd: 99, spe: 80 },
    skills: [],
    imageUrl: '',
    traitName: '基因编辑',
    traitEffect: '',
  },
  {
    id: '584',
    name: '智辉章脑',
    types: ['光', '水'],
    baseStats: { hp: 112, atk: 53, def: 87, spa: 123, spd: 124, spe: 100 },
    skills: [],
    imageUrl: '',
    traitName: '基因编辑',
    traitEffect: '',
  },
  {
    id: '585',
    name: '未完虫',
    types: ['幽', '虫'],
    baseStats: { hp: 86, atk: 102, def: 68, spa: 111, spd: 100, spe: 100 },
    skills: [],
    imageUrl: '',
    traitName: '正模标本',
    traitEffect: '',
  },
  {
    id: '586',
    name: '玳龟',
    types: ['幻'],
    baseStats: { hp: 101, atk: 37, def: 58, spa: 85, spd: 93, spe: 40 },
    skills: [],
    imageUrl: '',
    traitName: '乌龟塔理论',
    traitEffect: '',
  },
  {
    id: '587',
    name: '玳塔',
    types: ['幻'],
    baseStats: { hp: 127, atk: 47, def: 72, spa: 107, spd: 116, spe: 50 },
    skills: [],
    imageUrl: '',
    traitName: '乌龟塔理论',
    traitEffect: '',
  },
  {
    id: '588',
    name: '量风碗',
    types: ['翼', '机械'],
    baseStats: { hp: 78, atk: 79, def: 93, spa: 77, spd: 67, spe: 96 },
    skills: [],
    imageUrl: '',
    traitName: '风速仪',
    traitEffect: '',
  },
  {
    id: '589',
    name: '测风蝉',
    types: ['翼', '机械'],
    baseStats: { hp: 98, atk: 98, def: 116, spa: 97, spd: 84, spe: 120 },
    skills: [],
    imageUrl: '',
    traitName: '风速仪',
    traitEffect: '',
  },
  {
    id: '590',
    name: '小浣蛋',
    types: ['恶'],
    baseStats: { hp: 78, atk: 93, def: 99, spa: 88, spd: 92, spe: 96 },
    skills: [],
    imageUrl: '',
    traitName: '翻垃圾桶',
    traitEffect: '',
  },
  {
    id: '591',
    name: '黑手浣熊',
    types: ['恶'],
    baseStats: { hp: 97, atk: 116, def: 124, spa: 110, spd: 115, spe: 120 },
    skills: [],
    imageUrl: '',
    traitName: '翻垃圾桶',
    traitEffect: '',
  },
  {
    id: '592',
    name: '幽铃',
    types: ['幽'],
    baseStats: { hp: 99, atk: 37, def: 80, spa: 93, spd: 105, spe: 76 },
    skills: [],
    imageUrl: '',
    traitName: '盗魂铃',
    traitEffect: '',
  },
  {
    id: '593',
    name: '摇铃魔偶',
    types: ['幽'],
    baseStats: { hp: 123, atk: 46, def: 99, spa: 117, spd: 131, spe: 95 },
    skills: [],
    imageUrl: '',
    traitName: '盗魂铃',
    traitEffect: '',
  },
  {
    id: '594',
    name: '星星眼',
    types: ['幻'],
    baseStats: { hp: 116, atk: 97, def: 116, spa: 120, spd: 71, spe: 85 },
    skills: [],
    imageUrl: '',
    traitName: '宇宙之眼',
    traitEffect: '',
  },
  {
    id: '595',
    name: '布灵',
    types: ['幻', '光'],
    baseStats: { hp: 66, atk: 92, def: 98, spa: 32, spd: 77, spe: 100 },
    skills: [],
    imageUrl: '',
    traitName: '旧玩具',
    traitEffect: '',
  },
  {
    id: '596',
    name: '布灵布灵',
    types: ['幻', '光'],
    baseStats: { hp: 83, atk: 115, def: 123, spa: 40, spd: 96, spe: 125 },
    skills: [],
    imageUrl: '',
    traitName: '旧玩具',
    traitEffect: '',
  },
  {
    id: '597',
    name: '果实立方人',
    types: ['机械', '草'],
    baseStats: { hp: 105, atk: 132, def: 120, spa: 50, spd: 98, spe: 95 },
    skills: [],
    imageUrl: '',
    traitName: '秋收',
    traitEffect: '',
  },
  {
    id: '598',
    name: '圣光迪莫',
    types: ['光'],
    baseStats: { hp: 122, atk: 84, def: 107, spa: 84, spd: 107, spe: 92 },
    skills: [],
    imageUrl: '',
    traitName: '裁决',
    traitEffect: '',
  },
  {
    id: '599',
    name: '圣草迪莫',
    types: ['光', '草'],
    baseStats: { hp: 132, atk: 80, def: 105, spa: 80, spd: 105, spe: 92 },
    skills: [],
    imageUrl: '',
    traitName: '滋养',
    traitEffect: '',
  },
  {
    id: '600',
    name: '圣火迪莫',
    types: ['光', '火'],
    baseStats: { hp: 120, atk: 88, def: 105, spa: 88, spd: 105, spe: 92 },
    skills: [],
    imageUrl: '',
    traitName: '点燃',
    traitEffect: '',
  },
  {
    id: '601',
    name: '圣水迪莫',
    types: ['光', '水'],
    baseStats: { hp: 120, atk: 80, def: 113, spa: 80, spd: 113, spe: 92 },
    skills: [],
    imageUrl: '',
    traitName: '净化',
    traitEffect: '',
  },
];

export const SPIRIT_MAP: Record<string, Spirit> = Object.fromEntries(
  SPIRITS.map((s) => [s.id, s]),
);
